import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Testimonial = () => {
  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    { label: "Testimonials", link: "/testimonial" },
    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22", link: "/carpediem" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/testimonial.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Testimonials"
                breadEnd="Testimonials"
                breadMid="Testimonials"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div class="text-box">
                <p>
                  Dear Principal Ma'am,
                  <br />
                  I hope this email finds you in good health and high spirits.
                  As I sit down to express my heartfelt sentiments, I get
                  reminded of the incredible journey I have embarked upon under
                  your esteemed guidance at Lotus Valley International School.
                  It is with immense gratitude and nostalgia that I reflect upon
                  the bright and joyous years spent within the walls of our
                  beloved school.
                  <br />
                  My time at Lotus Valley has been nothing short of a treasure
                  trove of laughter, happiness, and invaluable memories. These
                  moments have become an anchor for me, reminding me of the
                  beauty of my school years and their influence on shaping the
                  person I am today. I am deeply grateful to you for allowing me
                  the opportunity to have been a part of such a nurturing
                  environment that fostered academic excellence and personal
                  growth.
                  <br />
                  Your vision and guidance have been pivotal in charting the
                  course of my academic journey. Your unwavering dedication to
                  fostering a holistic view of education has propelled me toward
                  achieving milestones that I once deemed distant dreams. The
                  emphasis on academic rigor and character development has
                  undeniably been monumental in my personal growth.
                  <br />
                  I would be remiss if I didn't express my heartfelt
                  appreciation for Neeru Ma'am, my mathematics teacher. Her
                  unique teaching style of looking at mathematics problems from
                  a different lens along with seamlessly blending fun and
                  discipline in the classroom, ignited my passion for
                  mathematics. Without her, I may have missed out on life
                  lessons and cherished memories that have been instrumental in
                  shaping my perspective. Teachers like her exemplify the
                  dedication and passion that truly make a difference in a
                  student's life. Along with Neeru Ma'am, every teacher at Lotus
                  Valley has played an indispensable role in my journey. Their
                  collective effort and commitment have paved the way for my
                  achievements, both in the past and those I aspire to attain in
                  the future.
                  <br />
                  As I navigate my path beyond school, I get humbled by the
                  solid foundation I received at Lotus Valley. The values
                  instilled within me, the lessons learned, and the friendships
                  forged continue to guide me in every step I take. I have no
                  doubt that your unwavering commitment to shaping the lives of
                  countless students will continue to serve as a beacon of
                  guidance for years to come. Your influence will undoubtedly be
                  shaping countless bright futures through Lotus Valley
                  International School, just as it has shaped mine.
                  <br />
                  I eagerly await the day I return to Gurgaon, where I would be
                  absolutely delighted to reconnect with you and Neeru Ma'am.
                  The thought of revisiting the campus and rekindling the
                  memories is truly heartwarming.
                  <br />
                  In closing, I want to extend my heartfelt gratitude for being
                  an integral part of the most essential and cherished years of
                  my life. Your unwavering support, love, and guidance have been
                  a guiding light, and I am forever indebted to you and the
                  entire Lotus Valley family.
                  <br />
                  Thank you so much, Anita Ma'am, for your profound impact on my
                  life's journey and everything else.
                  <br />
                  With deepest regards and heartfelt appreciation,
                  <br />
                  Dhruv Chauhan
                </p>
                <hr />
                <p>
                  Dear Ma'am
                  <br />
                  I hope you are doing well!
                  <br />
                  <br />
                  I would like to thank you and the entire team for organising
                  such a wonderful experience for the young teens. Prateek is
                  super happy and he had a wonderful experience.
                  <br />
                  Special thanks to Ms Navita for taking good care of all
                  children.
                  <br />
                  This trip was much needed to refresh the learners before the
                  boards and bond well with the peers after lockdown days.{" "}
                  <br />
                  <br />
                  Always grateful,
                  <br />
                  Rupa Rani Sinha
                  <br />
                  M/O Prateek Sinha
                  <br />
                  Grade X Elbert
                </p>
                <hr />
                <p>
                  Dear Mam
                  <br />
                  Hope you are fine.
                  <br />
                  <br />
                  Really appreciate the process of feedback which allows parents
                  to share genuine concerns / feedback openly.
                  <br />
                  Since most of the experiences are very positive, I would first
                  reflect on that.
                  <br />
                  As parents, we am amazed each day with the awesome efforts put
                  in my LVIS and its teacher under your pristine guidance and
                  Arjun Mittal (X-Fuji) has really leant a lot &amp; is maturing
                  into a smart child, which reaffirms to us the perfect choice
                  we made in LVIS for our child.
                  <br />
                  Your focus on right development &amp; diver skill building for
                  children is unwavering, deeply appreciate that.
                  <br />
                  One feedback I would like to make (have posted this on
                  feedback section of the website also):
                  <br />
                  It would be great if parents of children studying in school
                  are strictly avoided from playing the role of a judge or jury
                  in any event.
                  <br />
                  This has been seen to allow personal bias to creep into events
                  structured to operate with a lot of independence to reflect
                  ethos &amp; beliefs of LVIS.
                  <br />
                  Unfortunately some parents use these opportunities to reflect
                  their dislike for children whose performance on most aspects
                  their wards are unable to match.
                  <br />
                  Ending with a note of gratitude for excellent &amp; well
                  rounded development Arjun is getting each day at LVIS. <br />
                  <br />
                  Regards
                  <br />
                  Yogesh Mittal
                  <br />
                  9811758077
                </p>
                <hr />
                <p>
                  Dear ma’am,
                  <br />
                  <br />
                  Thank you for organising a fun filled trip for the 10th
                  graders. Ashrita has come back happy and rejuvenated and the
                  first thing she said ‘I did not miss my phone’.
                  <br />
                  Heartfelt gratitude and thanks to all the teachers who went on
                  the trip and took excellent care of kids.
                  <br />
                  Special thanks to Preeti ma’am and Neha ma’am who kept us
                  updated with all the information and with beautiful pictures.
                  <br />
                  Thanks once again from the bottom of our hearts.
                  <br />
                  <br />
                  Warm regards <br />
                  Ashrita’s parents
                  <br />
                  Warm Regards
                  <br />
                  Tuhina Chakraborty
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  Greetings!
                  <br />
                  <br />
                  We parents of Sanvi Anand (Grade 5- Cedars) would like to take
                  this opportunity to Thank You and your team of educators for
                  providing quality education to our child through the years. It
                  has been our privilege to be associated with the Lotus Valley
                  family since grade Pre-Nursery. Our child is growing and
                  learning beautifully under your able guidance. With utmost
                  focus on value-oriented teaching, discipline and life skills
                  along with the academic and co-scholastic teaching has helped
                  us put even more faith in the institution. <br />
                  A special mention of the Vice-Principal Ms. Ritu Jawa, who has
                  always been approachable and a guiding force for us as parents
                  as and when we needed. We thank her sincerely for helping our
                  child feel comfortable in C block after the gap of 2 years of
                  lock down.
                  <br />
                  We would like to thank the Class Teacher Ms. Anupreet Kaur for
                  her kind help in settling our ward in class during initial
                  months and dealing with all our queries and anxieties with
                  patience. Her method of teaching and making the Social Studies
                  topics interesting for kids have really been beneficial in
                  better understanding of the themes. <br />
                  Our whole-hearted gratitude to all the associated subject and
                  activity teachers of grade 5th who have helped nurture our
                  child during the year. <br />
                  Thanking You
                  <br />
                  <br />
                  Warm Regards
                  <br />
                  Rohit Anand &amp; Sapna Anand
                  <br />
                  (P/o Sanvi Anand -LVG-2726)
                </p>
                <hr />
                <p>
                  Hello Mam, <br />
                  <br />
                  With new Session starting today and all the excitement of kids
                  and parents for Lotus Valley, would like to convey thanks for
                  great Entree Program and a very smooth books distribution
                  process this time. Really appreciate the idea and great
                  experience .<br />
                  Also would appreciate ID card team, who supported for some
                  challenges and helped in correction of ID Card.
                  <br />
                  Lots of wishes to team of Lotus valley <br />
                  Thanks and Regards
                  <br />
                  Preeti Sharma
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  I am writing this letter to express my heartfelt gratitude for
                  all the support and guidance you have provided me throughout
                  my academic and co-curricular journey at Lotus Valley
                  International School Gurugram. Your unwavering encouragement
                  and belief in me have played a pivotal role in shaping me into
                  the person I am today. You will be pleased to know that I have
                  been accepted to Pennsylvania State University,USA. I plan to
                  major in International Politics and Public Policy, with a
                  minor in Economics.
                  <br />
                  I'm also extremely grateful to have received their Provost's
                  Award, which is a Scholarship worth 24000 dollars.
                  <br />
                  <br />
                  I remember coming to Lotus Valley in 6th Grade, as a girl who
                  used to cry to go back home. Today, 7 years later, I can
                  proudly call Lotus Valley my home and its people,my family.{" "}
                  <br />
                  Your continuous support and guidance have been instrumental in
                  my academic success. Your tireless efforts in creating a
                  conducive learning environment have helped me develop a love
                  for learning, and I cannot thank you enough for that. From
                  providing extra classes to helping me develop study habits
                  that have stayed with me, the faculty at Lotus Valley has
                  always gone above and beyond to help me succeed.
                  <br />
                  Your constant motivation and encouragement have helped me push
                  myself to achieve academic excellence, and for that, I will be
                  forever grateful. You have always been approachable and
                  supportive, making it easy for me to seek your guidance
                  whenever I needed it. <br />
                  Moreover, your support for my co-curricular activities has
                  been equally commendable. You always encouraged me to pursue
                  my passions, and your support was the reason behind my success
                  in various competitions and inter-school events. Your belief
                  in me helped me realize my potential and instilled a sense of
                  confidence that will stay with me forever. I still remember
                  the time when you stayed late at school to help me prepare my
                  Secretary General speech for LotusMUN, and that act of
                  kindness will always be etched in my memory.
                  <br />
                  Our Vice Principals,Ritu Ma'am and Harvinder Ma'am have also
                  always been a sense of motivation for me. They were closely
                  involved in my journey at Lotus Valley and I have been lucky
                  to have made such fun loving memories with them.
                  <br />
                  I would also like to share with you that a huge part of my
                  decision to pursue Political Science has been shaped by
                  Ms.Sanchana Ma'am. She has not only always been my backbone
                  with whatever academic assistance I required, but she's also
                  actively helped me pursue my zeal for Political Science.
                  Whether it was any inter school events, or Student Council
                  leadership tasks, Sanchana ma'am was always there, smiling at
                  me and motivating me to push beyond my limits.She always
                  believed that I could accomplish anything I set my mind to,if
                  I worked hard enough. The bond I have with ma'am is one I will
                  cherish forever.
                  <br />
                  Once again, thank you for being an excellent principal and for
                  supporting me in all aspects of my school life. You have truly
                  made a difference in my life, and I will always remember your
                  guidance and support. I wish you all the best as you continue
                  to inspire and motivate the next generation of students.
                  <br />
                  <br />
                  With Gratitude,Love and Respect,
                  <br />
                  Gaurika Singh
                  <br />
                  12- Wordsworth
                </p>
                <hr />
                <p>
                  Dear Vani Ma'am and Juhi Ma'am,
                  <br />
                  <br />
                  It's a warm note with heartfelt thanks to both of you for the
                  care and affection you have extended to our kids in addition
                  to your academic roles. Especially for parents like us, it was
                  very challenging to send our kids straight to a formal school
                  without having any exposure to a play school or any sort of
                  classes due to the covide-19 crisis. There was always an
                  element of doubt in our minds whether the school will be fine
                  for her, if she will be okay in school etc. Of Course, the
                  beginning was a mix of excitement and anxiety but a big
                  portion of anxiety shedded away after attending the entree
                  program giving a confident start to our journey with LVIS.
                  There were ups and downs in the initial couple of months and
                  later during September when kids were falling sick frequently
                  as they were getting exposed to the real world around them.
                  But kids always faced it more bravely than the parents because
                  they knew that there was another home in the school. The love
                  and bonding the entire Dahlians share is commendable and very
                  inspiring. Thanks for seeding this in them from the very
                  beginning. With every passing day of the session, our
                  confidence in LVIS kept increasing and that element of doubt
                  vanished with time. This would not have been possible without
                  the kind of support and love our kids received from their
                  'Mothers' in school. Missing school during vocations and
                  relating to all classmates and teachers &amp; above all
                  depicting the very loving and helpful didis of the class
                  during pretend plays at home clearly indicates their happiness
                  and satisfaction in the school. Attending the PTMs was a novel
                  experience for us as parents. We appreciate the timely
                  feedback received from both of you throughout the session. The
                  Annual Day performance of all the nurseries reflected very
                  clearly the amount of efforts and hardwork put behind it by
                  the teachers and these little heros and heroines. It was a
                  great show! <br />
                  A big thanks to both of you again with a trust that the
                  confidence we got in LVIS due to this first year of the school
                  shall grow more and more with each passing session. We are
                  moving to another step on the ladder carrying lots of
                  memorable and cherishable memories created with teachers, kids
                  and other parents &amp; grandparents. <br />
                  <br />
                  Thank you very much!
                  <br />
                  <br />
                  Kind Regards,
                  <br />
                  Happy Parents.{" "}
                </p>
                <hr />
                <p>
                  Dear Principal Ma’am,
                  <br />
                  <br />
                  My children have been in Lotus Valley since the beginning, and
                  I have tried to be in touch with all the class teachers and
                  other teachers as much as I could, all the teachers have been
                  very nice over the years and I am very thankful for that.
                  <br />
                  And last year my daughter Ayrah Bhalla had Divya Narang as the
                  class teacher who was also my sons CT when he was in 3rd, and
                  I have no words to describe how much my child loves and
                  respects the teacher and honestly so do I. She has let Ayrah
                  be herself while also teaching her to be respectful and
                  disciplined, and I have seen my child grow so beautifully over
                  this past year. Divya ma’am is truly the best teacher my
                  children have had the privilege of learning from.
                  <br />
                  And my son Angad Bhalla, who is now in grade 8, had Shubharty
                  ma’am as his class teacher in grade 7th, who was a new teacher
                  and honestly she was really a blessing for the children as
                  they are at the age where they need someone strict but also
                  the comfort of being able to be themselves and share with the
                  teacher whatever they need to. When asked Angad he said she
                  was the best teacher he has ever had.
                  <br />
                  So dear Ma’am I have for the first time in these 10 years that
                  my kids have been in the school, written to you, to let you
                  know how thankful I am for such great teachers we have in the
                  school and how lucky I feel that my kids have such a wonderful
                  atmosphere to bloom in.
                  <br />
                  <br />
                  Thanking you,
                  <br />
                  Tina Malhotra Bhalla.
                  <br />
                  9971257733.
                </p>
                <hr />
                <p>
                  Dear Respected, <br />
                  Principal Ma'am
                  <br />
                  <br />
                  It is our immense pleasure and heartful gratitude for passing
                  our little one, Vivaan Agrawal's, 1st Year of School with
                  flying colours and this couldn't have been possible without
                  the support you have provided. I still remember the first
                  video shared with us of Mother's day where Vivaan said, 'Hello
                  Mumma' and the first question he asked to me after school
                  'Mumma, may i go to the washroom'. These were bits of moment
                  which definately made us feel that yes our kid is on a
                  beautiful journey guided by beautiful mentors. There was great
                  participation and learning in every occasion. We enjoyed all
                  the dress up, character play, PTM, and Annual day was a hit.
                  Reading session was my favourite of this all. In this entire
                  journey not only him, but we also have lived every steps,
                  every moments with joy, thrills and surprises(also craziness).
                  A special thanks to Class teachers, Vani ma'am and Juhi ma'am
                  for bringing that essence of learning and growing together.
                  They truly are hardworking with lots of patience, they have
                  always motivated us to go hand in hand with them and our
                  child, just as we wanted it to be. Nevertheless, Thank u
                  Principal ma'am for ur efforts and support for building this
                  up because we always believe that 'When a team is created with
                  a strong base a beautiful stable world is created with it'.{" "}
                  <br />
                  Grateful for Everything. We are happy a part of Lotus Valley
                  International School, Keep Growing.
                  <br />
                  <br />
                  Thanks <br />
                  Barsha and Vikash Agrawal <br />
                  Parents of Vivaan Agrawal <br />
                  Nursery Dahlias (Batch: 2022-2023)
                </p>
                <hr />
                <p>
                  Respected Ma'am, <br />
                  <br />
                  We are parents of Hetwik Pant student of Nursery Dahlias in
                  2022-23.
                  <br />
                  I would like to express my gratitude and thanks to Lotus
                  Valley International School Gurgaon for, first of all, giving
                  admission to my child and then nourish him throughout the year
                  so that he is blooming with pride and confidence.
                  <br />
                  I remember the day when Entrée program was conducted and I
                  listened to Vani Ma'am talking about magic happening after
                  sometime if we help our child and create a conducive
                  atmosphere around him. It was a bit hard for me to follow
                  those lines at that time, but for me the MAGIC happened this
                  year.
                  <br />
                  Hetwik needed a lot of attention at home from us and we were
                  aware of that it would not be easy for him to cope at school.
                  He was very energetic and was not very good at social skills.
                  He loved gazing at blue sky and colourful butterflies, reading
                  stories but couldn't understand how to express himself.
                  <br />
                  Vani Ma'am and Juhi Mam talked to us and expressed their
                  opinion about him. We decided to team up with class teachers
                  to help Hetwik. Initially Pooja Mam and later Manan
                  Mam(councillors) were involved. We were amazed to see the
                  detailed plan crafted by Manan Mam to help our child keeping
                  in mind his specific needs.
                  <br />
                  Also regular updates from class teachers and Manan Mam kept us
                  motivated. And then the real MAGIC happened. Hetwik was
                  socialising, writing, reading, his confidence increased and he
                  spoke on stage.He even danced so well on the stage during
                  'Manchatantra-The manual of life'.
                  <br />
                  Hetwik might not be perfect today and still need improvement
                  in some areas however his progress and journey from April last
                  year 2022 to March 2023 this year has been phenomenal and LVIS
                  team plays an important role in this.
                  <br />
                  Apologies for keeping this email so long but each word of this
                  email is from our heart. My sincere and heartfelt thanks to
                  Vani Ma'am, Juhi Mam, Manan Mam to be the guiding light and
                  wonderful teachers to Hetwik.
                  <br />
                  Thanks a lot to you Anita Ma'am for being the strong pillar in
                  education and promoting such environment in school where every
                  child gets individual attention so that they can chase their
                  unique dreams in future.
                  <br />
                  Looking forward for another exciting year and continued
                  support.
                  <br />
                  <br />
                  Thanks again,
                  <br />
                  Anvita Pant and Piyush Pant
                </p>
                <hr />
                <p>
                  Hello Mam, <br />
                  With new Session starting today and all the excitement of kids
                  and parents for Lotus Valley, would like to convey thanks for
                  great Entree Program and a very smooth books distribution
                  process this time. Really appreciate the idea and great
                  experience .<br />
                  Also would appreciate ID card team, who supported for some
                  challenges and helped in correction of ID Card.
                  <br />
                  Lots of wishes to team of Lotus valley{" "}
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  We would like to take this opportunity to share our thoughts
                  on the recently held Annual Day Function 2023.
                  <br />
                  We were extremely emotional, sometime shivering &amp; felt
                  goosebumps.
                  <br />
                  Right from the theme to costume and the level of confidence
                  shown by the children on stage was amazing.
                  <br />
                  The concept, art, music, lighting, discipline everything was
                  spectacular.
                  <br />
                  The hard-work and dedication of teachers could be seen at
                  every step of the event.
                  <br />
                  You are doing wonderful work on the students, for inculcating
                  the students with indispensable knowledge and preparing them
                  with the skills to stand out in life, thank you.
                  <br />
                  We wish the very best to the Principal Ma'am, Teachers, School
                  management, Volunteers, and all the children who together
                  delivered an outstanding experience last evening.
                  <br />
                  We are extremely happy that our child is in great and loving
                  hands. <br />
                  <br />
                  With Warm Wishes and Best Regards,
                  <br />
                  Monika and Manish
                  <br />
                  M/o &amp; F/o
                  <br />
                  Tanay Sharma <br />
                  Grade VI Brahmaputra
                </p>
                <hr />
                <p>
                  Dear Ritu ma’am, <br />
                  I would like to convey my appreciation for the spectacular
                  show put up by Grade VI learners today. <br />
                  Each performance was heart-warming and every nuance and
                  emotion so beautifully captured. <br />
                  Kudos to each and every learner. <br />
                  The tireless efforts, guidance and patience of every teacher
                  involved is laudable. Without doubt, the indomitable energy
                  flows from Anita ma’am and you to each and every LVIS mentor.{" "}
                  <br />
                  We are so proud to be a part of this fraternity. <br />
                  <br />
                  Our best wishes, always. <br />
                  Warm regards <br />
                  Pooja Gehani (Parent of Vivaan Gehani, Grade VI Brahmaputra)
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  <br />
                  We would like to take this opportunity to share our thoughts
                  on the recently held Annual Day Function 2023.
                  <br />
                  We were extremely emotional, sometime shivering &amp; felt
                  goose bumps.
                  <br />
                  Right from the theme to costume and the level of confidence
                  shown by the children on stage was amazing.
                  <br />
                  The concept, art, music, lighting, discipline everything was
                  spectacular.
                  <br />
                  The hard-work and dedication of teachers could be seen at
                  every step of the event.
                  <br />
                  You are doing wonderful work on the students, for inculcating
                  the students with indispensable knowledge and preparing them
                  with the skills to stand out in life, thank you.
                  <br />
                  We wish the very best to the Principal Ma'am, Teachers, School
                  management, Volunteers, and all the children who together
                  delivered an outstanding experience last evening.
                  <br />
                  <br />
                  We are extremely happy that our child is in great and loving
                  hands. <br />
                  With Warm Wishes and Best Regards,
                  <br />
                  Monika and Manish (Parents of Tanay Sharma, Grade VI
                  Brahmaputra)
                </p>
                <hr />
                <p>
                  Good afternoon ma'am,
                  <br />
                  <br /> A very big congratulations for the amazing show👏👏. It
                  was absolutely wonderful to see spellbound performances by all
                  the grade 6 learners. Lovely show..Thank you so much ma'am.
                  The best part was that every little detail was taken care
                  of...
                  <br />
                  <br />
                  Ms. Sonia Batra (Parent of Aadya Batra, Grade VI Sutlej)
                </p>
                <hr />
                <p>
                  Good afternoon ma'am, <br />
                  <br /> Outstanding performance by each one of the students..
                  Congratulations to you and the full team 👏🥰🥰... All the
                  wishes to you and the team 🙏. Thank you
                  <br />
                  <br />
                  Ms. Jais Pullan (Parent of Austin Pullan, VI Sutlej)
                </p>
                <hr />
                <p>
                  Dearest Nivedita Ma’am,
                  <br />
                  <br />
                  It was truly a very emotional feeling while watching the
                  performance. We were spellbound by the efforts of each child
                  and teacher. The amount of time, energy, and patience you all
                  have shown is stupendous. God bless you all. May you keep
                  achieving more feats. A big hug to you 🤗 Congratulations 🎊{" "}
                  <br />
                  <br />
                  Regards
                  <br />
                  Ipshita Ray (Parent of Shomaditya Ray, Grade VI Brahmaputra)
                </p>
                <hr />
                <p>
                  Just loved it....in total awe and admiration for all the
                  hardwork put forth by both students and teachers.....It was
                  overwhelming also for how beautifully the journey and emotions
                  of Auggie was presented 👏👏👏 I had been a parent at LVIS
                  around 6 to 7 years back also and indeed you all have raised
                  the bars high....Thank you so so much for bringing out the
                  best in each child 💫
                  <br />
                  <br />
                  Jayanti S Rathor (Parent of Aarnaa Rathor, VI Kaveri)
                </p>
                <hr />
                <p>
                  Dearest Ritu Maam
                  <br />
                  <br />
                  Firstly I want to congratulate on your love, guidance and
                  vision. Today I feel so confident and have always been in your
                  guiding hand. I know my child is in the best care. <br />
                  It was truly a very emotional feeling while watching the
                  performance. We were spellbound by the efforts of each child
                  and teacher. The amount of time, energy, and patience you all
                  have shown is stupendous. God bless you all. May you keep
                  achieving more feats. A big hug to you 🤗 Congratulations 🎊{" "}
                  <br />
                  <br />
                  Regards
                  <br />
                  Ipshita Ray (Parent of Shomaditya Ray, Grade VI Brahmaputra)
                </p>
                <hr />
                <p>
                  I want to congratulate you for the wonderful annual day
                  presentation. Thank you so much for all the hard work. I know
                  it's not an easy task but you all did it so perfectly that too
                  in such a short span of time. Thank You!
                  <br />
                  <br />
                  Ms. Nisha A. Roy (Parent of Ahan Roy, Grade VI Kaveri)
                </p>
                <hr />
                <p>
                  Dear Mam,
                  <br />
                  <br />
                  We are Aradhya's (Gulmohars) parents who are still enjoying
                  watching video's of one of the best event we attended so far
                  "Shanjahan and Ruby Robbers". Its not only us but her
                  grandparents and other family members, who have been asking
                  for remaining part of recordings as we shared only few moments
                  initially.
                  <br />
                  Two hours just went like few minutes. <br />
                  Heartiest congratulations to You, Ritu mam, all the staff
                  members and students for working so hard to bring out the best
                  performance, which was throughly enjoyed and appreciated by
                  all the parents.
                  <br />
                  <br />
                  Thank you
                  <br />
                  Regards
                  <br />
                  Pankaj Miglani
                </p>
                <hr />
                <p>
                  Dear Madam,
                  <br />
                  <br />
                  We thank you for hosting the event at your school.
                  <br />
                  The 3-day mega event was organised in a flawless manner. The
                  smooth conduct of each aspect of the event- hosting and
                  arranging the participant exhibits spaces, the evaluation
                  process, inaugural as well as the valedictory bear evidence of
                  the meticulous attention given by you, support of the
                  management and the hard work of the school team.
                  <br />
                  We are thankful to you, the management and the the team,
                  Madam.
                </p>
                <hr />
                <p>
                  Dear Mam,
                  <br />
                  <br />
                  We are Aradhya's (Gulmohars) parents who are still enjoying
                  watching video's of one of the best event we attended so far
                  "Shanjahan and Ruby Robbers". Its not only us but her
                  grandparents and other family members, who have been asking
                  for remaining part of recordings as we shared only few moments
                  initially.
                  <br />
                  Two hours just went like few minutes. <br />
                  Heartiest congratulations to You, Ritu mam, all the staff
                  members and students for working so hard to bring out the best
                  performance, which was throughly enjoyed and appreciated by
                  all the parents.
                  <br />
                  <br />
                  Thank you
                  <br />
                  Regards
                  <br />
                  Pankaj Miglani
                </p>
                <hr />
                <p>
                  Dear Ritu ma’am <br />
                  <br />
                  I would like to convey my appreciation for the spectacular
                  show put up by Grade VI learners today. <br />
                  Each performance was heartwarming and every nuance and emotion
                  so beautifully captured. <br />
                  Kudos to each and every learner. The tireless efforts,
                  guidance and patience of every teacher involved is laudable.
                  Without doubt, the indomitable energy flows from Anita ma’am
                  and you to each and every LVIS mentor. <br />
                  We are so proud to be a part of this fraternity. <br />
                  <br />
                  Our best wishes, always. <br />
                  Warm regards <br />
                  Pooja{" "}
                </p>
                <hr />
                <p>
                  Dear Ritu ma’am, <br />
                  <br />
                  I would like to convey my appreciation for the spectacular
                  show put up by Grade VI learners today. <br />
                  Each performance was heart-warming and every nuance and
                  emotion so beautifully captured. <br />
                  Kudos to each and every learner. <br />
                  <br />
                  The tireless efforts, guidance and patience of every teacher
                  involved is laudable. Without doubt, the indomitable energy
                  flows from Anita ma’am and you to each and every LVIS mentor.{" "}
                  <br />
                  We are so proud to be a part of this fraternity. <br />
                  <br />
                  Our best wishes, always. <br />
                  Warm regards <br />
                  Pooja Gehani (Parent of Vivaan Gehani, Grade VI Brahmaputra)
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br /> <br />
                  We would like to take this opportunity to share our thoughts
                  on the recently held Annual Day Function 2023.
                  <br />
                  We were extremely emotional, sometime shivering &amp; felt
                  goose bumps.
                  <br />
                  Right from the theme to costume and the level of confidence
                  shown by the children on stage was amazing.
                  <br />
                  The concept, art, music, lighting, discipline everything was
                  spectacular.
                  <br />
                  The hard-work and dedication of teachers could be seen at
                  every step of the event.
                  <br />
                  You are doing wonderful work on the students, for inculcating
                  the students with indispensable knowledge and preparing them
                  with the skills to stand out in life, thank you.
                  <br />
                  We wish the very best to the Principal Ma'am, Teachers, School
                  management, Volunteers, and all the children who together
                  delivered an outstanding experience last evening.
                  <br />
                  We are extremely happy that our child is in great and loving
                  hands. <br /> <br />
                  With Warm Wishes and Best Regards,
                  <br />
                  Monika and Manish (Parents of Tanay Sharma, Grade VI
                  Brahmaputra)
                </p>
                <hr />
                <p>
                  Good afternoon ma'am,
                  <br /> <br /> A very big congratulations for the amazing
                  show👏👏. It was absolutely wonderful to see spellbound
                  performances by all the grade 6 learners. Lovely show..Thank
                  you so much ma'am. The best part was that every little detail
                  was taken care of...
                  <br /> <br />
                  Ms. Sonia Batra (Parent of Aadya Batra, Grade VI Sutlej)
                </p>
                <hr />
                <p>
                  Good afternoon ma'am,
                  <br /> <br /> Outstanding performance by each one of the
                  students.. Congratulations to you and the full team 👏🥰🥰...
                  <br />
                  All the wishes to you and the team 🙏. Thank you
                  <br />
                  Ms. Jais Pullan (Parent of Austin Pullan, VI Sutlej)
                </p>
                <hr />
                <p>
                  Dearest Nivedita Ma’am,
                  <br /> <br />
                  It was truly a very emotional feeling while watching the
                  performance. We were spellbound by the efforts of each child
                  and teacher. The amount of time, energy, and patience you all
                  have shown is stupendous. God bless you all. May you keep
                  achieving more feats. A big hug to you 🤗 Congratulations 🎊{" "}
                  <br /> <br />
                  Regards
                  <br /> Ipshita Ray (Parent of Shomaditya Ray, Grade VI
                  Brahmaputra)
                </p>
                <hr />
                <p>
                  Just loved it....in total awe and admiration for all the
                  hardwork put forth by both students and teachers.....It was
                  overwhelming also for how beautifully the journey and emotions
                  of Auggie was presented 👏👏👏 I had been a parent at LVIS
                  around 6 to 7 years back also and indeed you all have raised
                  the bars high....Thank you so so much for bringing out the
                  best in each child 💫
                  <br />
                  Jayanti S Rathor (Parent of Aarnaa Rathor, VI Kaveri)
                </p>
                <hr />
                <p>
                  Dearest Ritu Maam
                  <br /> <br />
                  Firstly I want to congratulate on your love, guidance and
                  vision. Today I feel so confident and have always been in your
                  guiding hand. I know my child is in the best care. <br />
                  It was truly a very emotional feeling while watching the
                  performance. We were spellbound by the efforts of each child
                  and teacher. The amount of time, energy, and patience you all
                  have shown is stupendous. God bless you all. May you keep
                  achieving more feats. A big hug to you 🤗 Congratulations 🎊{" "}
                  <br /> <br />
                  Regards
                  <br /> Ipshita Ray (Parent of Shomaditya Ray, Grade VI
                  Brahmaputra)
                </p>
                <hr />
                <p>
                  I want to congratulate you for the wonderful annual day
                  presentation. Thank you so much for all the hard work. I know
                  it's not an easy task but you all did it so perfectly that too
                  in such a short span of time. Thank You!
                  <br /> <br />
                  Ms. Nisha A. Roy (Parent of Ahan Roy, Grade VI Kaveri)
                </p>
                <hr />
                <p>
                  Dear Principal maam
                  <br />
                  <br />
                  Saying a simple thank you would be very small for the event
                  today. <br />
                  Thank you for not just organizing this event but also being a
                  gracious host. Today maam you created a new definition of
                  being a leader. I felt so pampered. Heartfelt gratitude to
                  your efforts of standing there making sure we ate first before
                  you took your plate. Gratitude for your humility and
                  graciousness.
                  <br />
                  You put us first everywhere and made us feel so special. Thank
                  you is not enough maam. <br />
                  A heartfelt gratitude and many thanks. <br />
                  <br />
                  Warm Regards
                  <br />
                  Anupreet Kaur{" "}
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  <br />
                  We would like to take this opportunity to share our thoughts
                  on the recently held Annual Day Function 2023.
                  <br />
                  We were extremely emotional, sometime shivering &amp; felt
                  goosebumps.
                  <br />
                  Right from the theme to costume and the level of confidence
                  shown by the children on stage was amazing.
                  <br />
                  The concept, art, music, lighting, discipline everything was
                  spectacular.
                  <br />
                  The hard-work and dedication of teachers could be seen at
                  every step of the event.
                  <br />
                  You are doing wonderful work on the students, for inculcating
                  the students with indispensable knowledge and preparing them
                  with the skills to stand out in life, thank you.
                  <br /> We wish the very best to the Principal Ma'am, Teachers,
                  School management, Volunteers, and all the children who
                  together delivered an outstanding experience last evening.
                  <br />
                  We are extremely happy that our child is in great and loving
                  hands. <br />
                  <br />
                  With Warm Wishes and Best Regards,
                  <br />
                  Monika and Manish
                  <br />
                  M/o &amp; F/o
                  <br />
                  Tanay Sharma <br />
                  Grade VI Brahmaputra
                </p>
                <hr />
                <p>
                  Dear Ritu ma’am <br />
                  <br />
                  I would like to convey my appreciation for the spectacular
                  show put up by Grade VI learners today. <br />
                  Each performance was heartwarming and every nuance and emotion
                  so beautifully captured. <br />
                  Kudos to each and every learner. <br />
                  The tireless efforts, guidance and patience of every teacher
                  involved is laudable. Without doubt, the indomitable energy
                  flows from Anita ma’am and you to each and every LVIS mentor.
                  We are so proud to be a part of this fraternity. <br />
                  <br />
                  Our best wishes, always. <br />
                  Warm regards <br />
                  Pooja{" "}
                </p>
                <hr />
                <p>
                  Dear Ma'am,
                  <br />
                  <br />
                  I am writing this email in the capacity of a parent for my
                  kids studying in Grades 4th and 9th respectively. Both my kids
                  are sports enthusiasts and I would like to express my
                  gratitude towards Rahul sir and his team for coaching both of
                  them and providing the right guidance for Football and
                  Basketball respectively. I particularly like the sight of kids
                  playing in the greens and every coach is so involved. My elder
                  daughter comes for morning classes and I am pleased to see the
                  growth and developing interest in her favourite sport.
                  <br />
                  Three cheers for the sports department.
                  <br />
                  <br />
                  Warm Regards
                  <br />
                  Tuhina Chakraborty
                  <br />
                  Grade Prep- Rep
                  <br />
                  Class Teacher - Prep Daffodils{" "}
                </p>
                <hr />
                <p>
                  Respected Ma'am Principal,
                  <br />
                  <br />
                  In today's times when we often say that all schools are more
                  or less the same, the one human factor that differentiates
                  LVIS Gurgaon, is undoubtedly Ms. Ritu Jawa !! I have countless
                  reasons to support my thoughts but the one today is very close
                  to my heart...and hence this mail to you.
                  <br />
                  We had escalated a concern to her and are filled with
                  gratitude on how quickly and beautifully she handled the
                  situation.
                  <br />
                  We have often heard you say that she has been 'handpicked' by
                  you and how selflessly she puts in more than her 100% for the
                  growth of our school. But I have to tell you this, that
                  knowing her in person is such a humbling experience. It feels
                  as if she comes from an era where the Good souls carry a Halo
                  around their head and spread endless warmth, positivity and
                  assurance. I have said this before and would say it again that
                  the "Ritu Jawa' signature on our circulars is always more than
                  a name.....its a satisfaction,a reassurance, a warm smile, a
                  personal touch and so much more !! Wish God manufactures a few
                  more souls like her :)
                  <br />
                  A Big ThankYou to You for leading by example. We are happy to
                  be a part of this family and with pride I say, 'our child is
                  in the safest hands.' <br />
                  <br />
                  Thanks &amp; Warmest Regards
                  <br />
                  Himanshi Chawla
                </p>
                <hr />
                <p>
                  Dear Mrs. Malhotra,
                  <br />
                  <br />
                  It was a delight to meet you and witness your love for Indian
                  Handicraft and Handloom.
                  <br />
                  All the artisans were elated with your kind hospitality and
                  the response received from teachers and kids.Kids were seen
                  taking keen interest in the process of creating different
                  crafts and it clearly shows your great leadership skills to
                  inculcate love for Indian heritage among small kids at such an
                  early stage.
                  <br />
                  It would be an honor to recreate a similar experience for kids
                  and parents and will try to take it a notch higher. As a
                  special mention by Ms.Anand, I will try to include a puppeteer
                  who would showcase small puppet shows.Along with this,I'm also
                  planning to arrange "Kachhi Ghodi" wherein a person wears a
                  horse dress and performs a traditional dance. Also, a
                  "Bioscope" where kids see ancient Indian monuments the old
                  way.
                  <br />
                  As mentioned by Ms. Anand that this time parents are also
                  invited for the date, I would like to suggest that we should
                  not only keep Craft but also to keep a few Handloom Categories
                  like Woolen Shawls/stoles, Chanderi Handloom etc. and also
                  increase the number of artisans to around 10 in number.
                  <br />
                  I am also glad to inform you that our talks with the Indian
                  army for the army day rehearsals school visit will soon be
                  positively concluded and dates for the same will be out soon.
                  <br />
                  Kindly pour in your insight for the above. Look forward to
                  working alongside you and the lotus valley team on a much
                  bigger scale in the future.
                  <br />
                  <br />
                  Thank you
                  <br />
                  Regards
                  <br />
                  Deepshikha Sharma
                  <br />
                  (President, Oneworld Foundation)
                </p>
                <hr />
                <p>
                  Ma’am,
                  <br />
                  <br />
                  My daughter, who studied for 4 years in your school, has now
                  passed her 12th exams with more than satisfactory results.
                  <br />
                  I am writing this to convey what I felt like conveying at
                  different points of time during this journey but had to
                  refrain from doing so thinking that an honest acknowledgment
                  of great work could also be possibly seen as an attempt to
                  seek favour for my child.
                  <br />
                  During her entire schooling, my daughter had to study in 5
                  different schools owing to my transferable job and thus I had
                  the benefit of comparing one school to another. I also have
                  experience of working in the corporate world for more than 2
                  decades and thus I am able to evaluate the administrative,
                  operational and other processes.
                  <br />
                  Let me just state that every single time I got a chance to
                  experience any aspect of the school, be it the management
                  during Covid, logistics during PTMs, attitude of the staff at
                  the reception and even the sincerity of the security guards
                  and school bus crew, my respect for the institution and for
                  you as a leader went up consistently. The quality of teachers
                  not just in terms of their skill set but also in terms of
                  their dedication, hard work and the whole approach of putting
                  their heart and soul into the development and education of
                  their students was inspiring. <br />
                  As a parent, I am highly appreciative of the contribution of
                  every single member of the school staff and I feel extremely
                  grateful for all that my daughter fortunately got from the
                  school.
                  <br />
                  I strongly feel that we need many more institutions and
                  leaders like you. Thank you once again.
                  <br />
                  I am choosing to not write the name of my daughter, lest this
                  should be viewed as a biased communication.
                  <br />
                  Thank you very much once again. God bless you all!
                  <br />
                  <br />
                  Warm Regards,
                  <br />
                  Prabhat
                </p>
                <hr />
                <p>
                  Respected ma’am <br />
                  <br /> My daughters , Suhani and Hiti are part of your
                  institution . They study in grade XI and VIII respectively.
                  Elder one participated in dance today and younger one had put
                  up a stall with her friends. <br />I am writing this mail to
                  appreciate and thank the management , school and teachers for
                  organising Seva Mela . It’s not only for a good cause but in
                  the process kids are learning so much while having fun
                  alongside. Merging it with Children’s Day today was a really
                  good idea. They all had fun and enjoyed it even more. My
                  daughters were really happy and couldn’t stop talking about
                  the good time they had at school. <br />
                  <br />
                  Thanx a lot <br />
                  Warm Regards <br />
                  Jyoti Yadav <br />
                  Mother{" "}
                </p>
                <hr />
                <p>
                  Dear Anita Mam,
                  <br />
                  <br />
                  Thankyou for wonderful opportunity to kids and parents to
                  participate, contribute for a wonderful cause. This was a
                  great platform where kids got to learn so much to lead and
                  also a sense of contributing to society. We enjoyed a lot and
                  feel so good after making our contribution too.
                  <br />
                  Thanks to Ritu Mam and Harvinder Mam and all the teachers and
                  coordinators <br />
                  <br />
                  Thanks and Regards
                  <br />
                  Preeti Sharma
                </p>
                <hr />
                <p>
                  Respected Principal Ma'am,
                  <br />
                  <br />
                  I would like to extend my heartiest congratulations to you and
                  the LOTUS MUN OC for organizing an amazing event last week.
                  From the opening ceremony and your words of encouragement to
                  all participating students, the efforts put in to get the
                  dance &amp; music teams together, quality of food served, the
                  folders and give-aways presented to all students, to the
                  closing ceremony and awards function, everything was so
                  thorough and planned to perfection. I can vouch for this as a
                  first hand experience by my daughter who was a participant in
                  the choir as well as a Delegate of the UNGA committee. Infact,
                  she received this feedback from many other fellow delegates
                  from other schools as well. <br />
                  Also, it is worth mentioning that for the past few months
                  Shivangi has been going for inter-school competitions to many
                  schools including KR Mangalam, Kunskapsskolan, Lancers, DPS
                  Palam Vihar and Scottish High, and we are clearly able to see
                  the difference in quality (both in terms of event planning,
                  school infrastructure, teacher interaction and student
                  behaviour). Our school has a clear edge on all of these
                  criterias under your able guidance and we are so proud to be a
                  part of this family. <br />
                  Do let me personally on how we can continue to add value to
                  the success of our school in every way possible as proud
                  parents and as advocates. <br />
                  A sincere thanks and a big congratulations to the entire team
                  and staff for this.
                  <br /> <br />
                  Kind regards
                  <br /> Yours sincerely
                  <br /> Shweta Talwar
                  <br /> Mother of Shivangi Talwar
                  <br /> VIII - Mississippi
                </p>
                <hr />
                <p>
                  Hello Mam
                  <br />
                  <br />
                  Hope you are doing well !<br /> <br />
                  I would like to take the opportunity to express my thoughts on
                  the grandparents day celebration that was organised on 6th
                  oct.
                  <br />
                  The grand parents day at Lotus valley was celebrated with
                  abundance of respect and admiration. The children were really
                  excited to see their grandparents participate in games and
                  activities. Their fondness and affection for their
                  grandparents was clearly seen when they held hands, sang and
                  danced together. The teachers have gone an extra mile and left
                  no stone unturned to make this day a memorable event for all.
                  <br />
                  It truly will be a long cherished memory for everyone!
                  <br />
                  We truly appreciate the efforts put together for the event .
                  We look forward to such beautiful collaboration as we move in
                  the journey of our child’s development .<br />
                  Thankyou class teachers for your wisdom and all the sweet
                  things you do for our children.
                  <br />
                  Thankyou to lotus valley management and entire team who works
                  with passion and dedication for the future of our children.
                  <br />
                  Have a good day !<br /> <br />
                  Regards,
                  <br />
                  Happy Parents
                  <br />
                  Astha and Sameer Bajaj
                </p>
                <hr />
                <p>
                  Hello Mam
                  <br />
                  <br />
                  This is with regards to our discussion around improvements
                  observed in our ward - "Aarna Vashishtha" after undergoing the
                  counselling sessions in school. To be honest, at first I was
                  not very hopeful to see much results but much to my surprise,
                  these sessions have helped her to open up with you and Astha
                  mam about her struggles with studies, her emotional personna
                  and other related issues.
                  <br />
                  Then, there came a moment that instilled confidence in me
                  about these counselling sessions, was when Aarna came to me
                  and said that " Mumma, my counselor Mam is just like you. I
                  can share everything with Mam without any hesitation just like
                  you." This was when I felt that my daughter was in the right
                  hands and I started looking forward to seeing some improvement
                  very soon. All thanks to Mansi Mam for sharing that report
                  with my child.
                  <br />
                  Coming back to the present, I can see her motivated enough to
                  do her school work on time during class as well as home. She
                  has improved on the emotional front as well, however I
                  understand it's a slow process and would take time and
                  constant direction to keep the spirit alive. But, I know once
                  a child feels motivated to do something or in a certain way,
                  half battle is won, and another half can be won by
                  perseverance.
                  <br />
                  I would like to take this moment to thank both the counsellors
                  to counsel my child so well that she didn't for a moment
                  thought she's been counselled, instead she got someone in
                  school who would listen to her day to day issues and
                  understand her dilemma or struggles as a child and provide
                  some quick solutions and exercises to deal with them.
                  <br />
                  Looking forward to continued support and guidance.
                  <br />
                  <br />
                  Thanks and Regards,
                  <br />
                  Preeti Vashishtha
                  <br />
                  (Aarna's Mother)
                </p>
                <hr />
                <p>
                  Good Day Teachers of Lotus Valley, Gurgaon
                  <br />
                  <br />
                  Atharva Mittal a young learner from 2018 (Nur) to 2022 (Grade
                  2nd) misses his teachers and school a lot.
                  <br />
                  Just wanted to thank you all for all the efforts and pain in
                  making Atharva Mittal base strong. All the teachers stood
                  strong by the learners even during COVID times. They not only
                  took pain to upgrade themselves but also left no stone
                  unturned in imparting the best knowledge.
                  <br />
                  I am proud to share Atharva Mittal stands out in the crowd in
                  Mumbai with the knowledge the school have given him.
                  <br />
                  Thanking you from the bottom of our hearts.
                  <br />
                  We feel blessed to have Lotus Valley in his life.
                  <br />
                  Special thanks to Shilpa mam, Meenal mam and Ridhima mam
                </p>
                <hr />
                <p>
                  Hello Ma’am,
                  <br />
                  <br />
                  I would like to share my joy with you. My daughter, Tanvi
                  Chand, was accepted to Purdue University, University of
                  California, San Diego, University of California, Davis,
                  University of Illinois, Urbana Champaign, and Indiana
                  University. Tanvi has finally committed to Purdue as she
                  wanted to pursue UI/UX, which is available as an undergraduate
                  course only in very few schools.
                  <br />
                  Thank you for all your help and support over the past 11
                  years. Lotus Valley has been an integral part of the journey
                  to being successful for both my daughters (Shivangi, Class of
                  2016, and Tanvi, Class of 2022). This wouldn’t have been
                  possible without your constant encouragement.
                  <br />
                  <br />
                  Thanks and Regards,
                  <br />
                  Shalini Chand
                  <br />
                </p>
                <hr />
                <p>
                  Respected ma’am,
                  <br />
                  <br />
                  Greetings of the day!
                  <br />
                  We would like to express our heartfelt gratitude towards you
                  for listening to us, and directing the concerned authorities
                  to take necessary action. If it weren’t for you, we would have
                  been left stranded at a place where we had only two options –
                  either to change the school or to resign to the ill-formed bus
                  routes; both these things were practically not feasible.
                  <br />
                  Opting out of transport could never be an option for us, else
                  we wouldn’t have struggled hard in 2015-16 to initiate this
                  route towards Manesar. If you remember, at that time as well,
                  we had mentioned, sitting in your office, that “Ma’am, send
                  one Lotus Valley bus in our area and you would have a
                  requirement for four in no time”!
                  <br />
                  Ma’am, it does take a lot of grit and courage to stand in
                  front of you, and discuss our requirements :) We are speaking
                  from a parent’s perspective. We knew we would be scolded for
                  being a little impatient but we sincerely take it as your
                  blessing! In such instances, we couldn’t leave things to mend
                  on their own as each day was causing professional and
                  psychological loss to us. We were simply in the dark regarding
                  bus timing and bus route, and even the right bus number for
                  daily commute.
                  <br />
                  You would have never seen us writing to you or coming over to
                  meet you ‘unnecessarily’ in all these ‘ten years’. Tanvi has
                  been studying in LVIS since Nursery, and she has literally
                  grown with the school and in the school, including the period
                  of pandemic, when the students never felt being physically or
                  psychologically away from the school.
                  <br />
                  These four years are decisive for the students, and we need to
                  collectively make every possible effort so that they give
                  nothing but their best - for themselves and for the
                  prestigious institution of which they are a minute but
                  significant component. The students are proud of this fact!
                  <br />
                  Without taking much of your time, let us say “Thank you once
                  again” for your continued and valuable support. You are the
                  soul of LVIS, and we are not exaggerating here. When you are
                  there, we know that there's always someone who'd listen to
                  genuine concerns.
                  <br />
                  Happy Vaisakhi and a healthy, peaceful new year to you ma’am.
                  <br />
                  <br />
                  Warm Regards,
                  <br />
                  Dr. Harleen Wason / Amit Wason
                  <br />
                </p>
                <hr />
                <p>
                  Dear Harvinder ma’am
                  <br />
                  <br />
                  This note is to convey our appreciation for the vaccination
                  camp held at school today.
                  <br />
                  Grateful to Anita ma’am for always thinking of the best
                  options for the children.
                  <br />
                  The seamless coordination in safe environ of the school made
                  it a very comfortable experience for the children. <br />
                  Your constant presence along with Shalini ma’am, Komal ma’am
                  and other staff who were present there ensured everything was
                  done smoothly.
                  <br />
                  <br />
                  Thank you !<br />
                  Warm regards,
                  <br />
                  Pooja
                </p>
                <hr />
                <p>
                  Dear Anita Ma'am and Harvinder Ma'am, <br />
                  <br />
                  Congratulations for putting up a great show of Scholar Badge
                  ceremony. The ceremony was very well co-ordinated and it was
                  lovely to see students performing with so much confidence.
                  Kudos to the teachers and the core committee for working so
                  hard! <br />
                  It has been nostalgic for the kids to return back to the
                  school and live the good old times again! <br />
                  Because of the online mode, a large number of parents like me
                  were blessed to watch the performance of the children as well.{" "}
                  <br />
                  I really liked your address to the children and the way you
                  motivated the kids was commendable! Am so happy Ivana is in
                  good hands and shaping up so well! <br />
                  Ivana and we are blessed to be part of the Lotus Valley
                  Family! <br />
                  Looking forward to such more offline events! <br />
                  <br />
                  Best Regards,
                  <br />
                  Priya Lokwani
                  <br />
                  Mother of Ivana Agarwal <br />
                  Grade 4 Banyans
                </p>
                <hr />
                <p>
                  Respected Ma’am,
                  <br />
                  <br />
                  The Scholar Badge ceremony was flawless. Not for a minute did
                  we feel like we are sitting at home and watching the same. The
                  energy and warmth exuded by the performers, the scholar badge
                  winners, the teachers and above all Principal ma’am and
                  Harvinder ma’am was palpable. What a befitting way to end the
                  session, the love, warmth and pride in the achievements of all
                  the learners was evident in the speeches.
                  <br />
                  We are blessed to be a part of the ever growing lotus valley
                  family and treasure these moments deeply as these memories
                  live on forever.
                  <br />
                  Thank you once again ma’am for making today special. A big
                  thank you to all the teachers and children who made today a
                  roaring success.
                  <br />
                  <br />
                  Regards,
                  <br />
                  Arjita
                  <br />
                  (Parent of Agastya Trikha IX Kamet)
                </p>
                <hr />
                <p>
                  Dear Ma'am
                  <br />
                  <br />
                  I hope you are doing well.
                  <br />
                  I am extremely grateful to you and your entire team to put up
                  such an amazing and well structured event today. As mentioned
                  in your speech that you can feel the presence of parents in
                  the auditorium, I could also feel my presence with all others
                  inspite of the physical distance. I would like to share that
                  Prateek's maternal grandmom and paternal grandparents all were
                  able to witness their grandson fecilitated on Stage with blue
                  blazer and badge via YouTube link. They were extremely
                  delighted to see the entire event and it was all possible
                  through the virtual link as they live in different cities. It
                  was just like another grandparents day where they were equally
                  honoured <br />
                  I would also like to thank all his mentors for guiding him
                  properly by giving genuine feedback and encouraging him
                  positively in various aspects.
                  <br />
                  Thank you once again Ma'am and my best wishes to all your
                  future endeavours!
                  <br />
                  <br />
                  Thanks and Regards,
                  <br />
                  Rupa Rani Sinha
                  <br />
                  M/O Prateek Sinha
                  <br />
                  Grade IX Himalayas
                </p>
                <hr />
                <p>
                  Good Morning Ma’am.
                  <br />
                  <br />
                  I am pleased to see my children Rohini Verma (learner in XII)
                  and Raghav (leaner in VIII) emerging as strong individuals. I
                  am sure they will emerge as good citizen and balanced human
                  being.
                  <br />
                  It was really delightful and a proud moment for us to see them
                  receive their school blazer and scholar badge respectively.
                  <br />
                  Thanks to you and your team , who have helped us to groom our
                  kids in best possible manner.
                  <br />
                  <br />
                  Best Regards
                  <br />
                  Nehaa and Manish
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  <br />
                  I sincerely don't have words to describe the feeling of pride
                  and gratitude after the scholar badge ceremony today. It was
                  such an honor to hear both of you, and learn from you as
                  always. <br />
                  Anita Ma'am - A true visionary and leader - we are so inspired
                  by your ability to guide all of us with such compassion.{" "}
                  <br />
                  Harvinder Ma'am - Your love for every child, every teacher and
                  all that you do for the school with such grace is so
                  heart-warming. <br />
                  Shivangi is truly blessed to have mentors like you. <br />
                  A big congratulations for a successful event and I look
                  forward to speaking with you soon. <br />
                  <br />
                  Warm wishes <br />
                  Thanks and regards
                </p>
                <hr />
                <p>
                  Dear Ma’am, <br />
                  <br />
                  The Batch of 2022 would like to take this opportunity to
                  express our gratitude to this institution. Being the outgoing
                  batch for this year, we did not wish to leave without letting
                  you know of our appreciation towards Lotus Valley, our school
                  for life indeed. <br />
                  Thank you so much Anita ma’am, for providing us with the
                  platform to learn, grow, be the best version of ourselves, and
                  for surrounding us with such a positive environment to
                  facilitate overall holistic development. Your words of
                  encouragement and advice during every assembly or event are
                  forever engrained and have helped most of us to be where we
                  are today, taking all values along with us in our journey
                  forward. <br />
                  ‘Arise, awake and stop not till the goal is reached.' We take
                  ahead our beloved motto with us in our life with pride, and
                  our hearts are filled with gratitude towards this outstanding
                  institution and our dear faculty
                  <br />. We are forever indebted to our alma mater as it is
                  under its tutelage that every day, thousands of minds are
                  inspired and educated. Although our gratitude is immeasurable,
                  we hope that our token of appreciation towards the school
                  symbolizes the same. <br />
                  <br />
                  Regards, <br />
                  The Senior Council (on behalf of the Batch of 2022)
                </p>
                <hr />
                <p>
                  Good afternoon Ma'am,
                  <br />
                  <br />
                  This is regarding today's PTM, which was conducted very well
                  by Ms. Suman Dahiya for Grade IX Everest. We appreciate the
                  efforts put in by all the teachers and staff members under
                  your revered guidance, and the decision of continuing with the
                  'online mode' for its convenience and time saving impact for
                  all.
                  <br />
                  Further, we would like to express our gratitude for awarding
                  the prestigious 'Blue Blazer' at the scholar badge ceremony
                  for '21-22. This, indeed, fills the student with a sense of
                  pride and achievement, and they will strive hard to "maintain"
                  this status in the coming years. The habit of hard work (and
                  smart work) which they will cultivate now is going to help
                  them for the rest of their life!
                  <br />
                  <br />
                  Thank you once again,
                  <br />
                  Best wishes and Regards,
                  <br />
                  Dr. Harleen Wason / Amit Wason
                  <br />
                  (Parents of Tanvi Wason)
                  <br />
                </p>
                <hr />
                <p>
                  Dear Harvinder ma’am
                  <br />
                  <br />
                  This note is to convey our appreciation for the vaccination
                  camp held at school today.
                  <br />
                  <br />
                  Grateful to Anita ma’am for always thinking of the best
                  options for the children.
                  <br />
                  <br />
                  The seamless coordination in safe environ of the school made
                  it a very comfortable experience for the children. <br />
                  <br />
                  Your constant presence along with Shalini ma’am, Komal ma’am
                  and other staff who were present there ensured everything was
                  done smoothly.
                  <br />
                  <br />
                  Thank you !<br />
                  Warm regards,
                  <br />
                  Pooja
                </p>
                <hr />
                <p>
                  Respected ma’am,
                  <br />
                  <br />
                  Greetings of the day!
                  <br />
                  We would like to express our heartfelt gratitude towards you
                  for listening to us, and directing the concerned authorities
                  to take necessary action. If it weren’t for you, we would have
                  been left stranded at a place where we had only two options –
                  either to change the school or to resign to the ill-formed bus
                  routes; both these things were practically not feasible.
                  <br />
                  <br />
                  Opting out of transport could never be an option for us, else
                  we wouldn’t have struggled hard in 2015-16 to initiate this
                  route towards Manesar. If you remember, at that time as well,
                  we had mentioned, sitting in your office, that “Ma’am, send
                  one Lotus Valley bus in our area and you would have a
                  requirement for four in no time”!
                  <br />
                  <br />
                  Ma’am, it does take a lot of grit and courage to stand in
                  front of you, and discuss our requirements :) We are speaking
                  from a parent’s perspective. We knew we would be scolded for
                  being a little impatient but we sincerely take it as your
                  blessing! In such instances, we couldn’t leave things to mend
                  on their own as each day was causing professional and
                  psychological loss to us. We were simply in the dark regarding
                  bus timing and bus route, and even the right bus number for
                  daily commute.
                  <br />
                  <br />
                  You would have never seen us writing to you or coming over to
                  meet you ‘unnecessarily’ in all these ‘ten years’. Tanvi has
                  been studying in LVIS since Nursery, and she has literally
                  grown with the school and in the school, including the period
                  of pandemic, when the students never felt being physically or
                  psychologically away from the school.
                  <br />
                  <br />
                  These four years are decisive for the students, and we need to
                  collectively make every possible effort so that they give
                  nothing but their best - for themselves and for the
                  prestigious institution of which they are a minute but
                  significant component. The students are proud of this fact!
                  <br />
                  <br />
                  Without taking much of your time, let us say “Thank you once
                  again” for your continued and valuable support. You are the
                  soul of LVIS, and we are not exaggerating here. When you are
                  there, we know that there's always someone who'd listen to
                  genuine concerns.
                  <br />
                  <br />
                  Happy Vaisakhi and a healthy, peaceful new year to you ma’am.
                  <br />
                  <br />
                  Warm Regards, <br />
                  Dr. Harleen Wason / Amit Wason
                  <br />
                  <br />
                  PS: Copied to HM ma'am as well for her kind support despite
                  this being a totally 'out of the context' concern for her, and
                  arranging a meeting with you to resolve the issue.{" "}
                </p>
                <hr />
                <p>
                  Dear Anita Ma'am and Harvinder Ma'am, <br />
                  <br />
                  Congratulations for putting up a great show of Scholar Badge
                  ceremony. The ceremony was very well co-ordinated and it was
                  lovely to see students performing with so much confidence.
                  Kudos to the teachers and the core committee for working so
                  hard! <br />
                  <br />
                  It has been nostalgic for the kids to return back to the
                  school and live the good old times again! <br />
                  <br />
                  Because of the online mode, a large number of parents like me
                  were blessed to watch the performance of the children as well.{" "}
                  <br />
                  <br />
                  I really liked your address to the children and the way you
                  motivated the kids was commendable! Am so happy Ivana is in
                  good hands and shaping up so well! <br />
                  <br />
                  Ivana and we are blessed to be part of the Lotus Valley
                  Family! <br />
                  <br />
                  Looking forward to such more offline events! <br />
                  <br />
                  Best Regards,
                  <br />
                  Priya Lokwani
                  <br />
                  Mother of Ivana Agarwal <br />
                  Grade 4 Banyans{" "}
                </p>
                <hr />
                <p>
                  Respected Ma’am,
                  <br />
                  <br />
                  The Scholar Badge ceremony was flawless. Not for a minute did
                  we feel like we are sitting at home and watching the same. The
                  energy and warmth exuded by the performers, the scholar badge
                  winners, the teachers and above all Principal ma’am and
                  Harvinder ma’am was palpable. What a befitting way to end the
                  session, the love, warmth and pride in the achievements of all
                  the learners was evident in the speeches.
                  <br />
                  <br />
                  We are blessed to be a part of the ever growing lotus valley
                  family and treasure these moments deeply as these memories
                  live on forever.
                  <br />
                  <br />
                  Thank you once again ma’am for making today special. A big
                  thank you to all the teachers and children who made today a
                  roaring success.
                  <br />
                  <br />
                  Regards,
                  <br />
                  Arjita
                  <br />
                  (Parent of Agastya Trikha IX Kamet)
                </p>
                <hr />
                <p>
                  Dear Ma'am
                  <br />
                  <br />
                  I hope you are doing well.
                  <br />
                  <br />
                  I am extremely grateful to you and your entire team to put up
                  such an amazing and well structured event today. As mentioned
                  in your speech that you can feel the presence of parents in
                  the auditorium, I could also feel my presence with all others
                  inspite of the physical distance. I would like to share that
                  Prateek's maternal grandmom and paternal grandparents all were
                  able to witness their grandson fecilitated on Stage with blue
                  blazer and badge via YouTube link. They were extremely
                  delighted to see the entire event and it was all possible
                  through the virtual link as they live in different cities. It
                  was just like another grandparents day where they were equally
                  honoured <br />
                  <br />
                  I would also like to thank all his mentors for guiding him
                  properly by giving genuine feedback and encouraging him
                  positively in various aspects.
                  <br />
                  <br />
                  Thank you once again Ma'am and my best wishes to all your
                  future endeavours!
                  <br />
                  <br />
                  Thanks and Regards,
                  <br />
                  Rupa Rani Sinha
                  <br />
                  M/O Prateek Sinha
                  <br />
                  Grade IX Himalayas
                </p>
                <hr />
                <p>
                  Good Morning Ma’am.
                  <br />
                  <br />
                  I am pleased to see my children Rohini Verma (learner in XII)
                  and Raghav (leaner in VIII) emerging as strong individuals. I
                  am sure they will emerge as good citizen and balanced human
                  being.
                  <br />
                  <br />
                  It was really delightful and a proud moment for us to see them
                  receive their school blazer and scholar badge respectively.
                  <br />
                  <br />
                  Thanks to you and your team , who have helped us to groom our
                  kids in best possible manner.
                  <br />
                  <br />
                  Best Regards
                  <br />
                  Nehaa and Manish
                </p>
                <hr />
                <p>
                  Respected Ma'am,
                  <br />
                  <br />
                  I sincerely don't have words to describe the feeling of pride
                  and gratitude after the scholar badge ceremony today. It was
                  such an honor to hear both of you, and learn from you as
                  always. <br />
                  <br />
                  Anita Ma'am - A true visionary and leader - we are so inspired
                  by your ability to guide all of us with such compassion.{" "}
                  <br />
                  <br />
                  Harvinder Ma'am - Your love for every child, every teacher and
                  all that you do for the school with such grace is so
                  heart-warming. <br />
                  <br />
                  Shivangi is truly blessed to have mentors like you. <br />
                  <br />
                  A big congratulations for a successful event and I look
                  forward to speaking with you soon. <br />
                  <br />
                  Warm wishes <br />
                  Thanks and regards
                  <br />
                  Shweta
                  <br />
                  9910397046
                </p>
                <hr />
                <p>
                  Dear Ma’am, <br />
                  <br />
                  The Batch of 2022 would like to take this opportunity to
                  express our gratitude to this institution. Being the outgoing
                  batch for this year, we did not wish to leave without letting
                  you know of our appreciation towards Lotus Valley, our school
                  for life indeed.
                  <br /> <br />
                  Thank you so much Anita ma’am, for providing us with the
                  platform to learn, grow, be the best version of ourselves, and
                  for surrounding us with such a positive environment to
                  facilitate overall holistic development. Your words of
                  encouragement and advice during every assembly or event are
                  forever engrained and have helped most of us to be where we
                  are today, taking all values along with us in our journey
                  forward. <br />
                  <br />
                  ‘Arise, awake and stop not till the goal is reached.' We take
                  ahead our beloved motto with us in our life with pride, and
                  our hearts are filled with gratitude towards this outstanding
                  institution and our dear faculty.
                  <br /> <br />
                  We are forever indebted to our alma mater as it is under its
                  tutelage that every day, thousands of minds are inspired and
                  educated. Although our gratitude is immeasurable, we hope that
                  our token of appreciation towards the school symbolizes the
                  same. <br />
                  <br />
                  Regards, <br />
                  The Senior Council (on behalf of the Batch of 2022)
                </p>
                <hr />
                <p>
                  Good afternoon Ma'am,
                  <br />
                  <br />
                  This is regarding today's PTM, which was conducted very well
                  by Ms. Suman Dahiya for Grade IX Everest. We appreciate the
                  efforts put in by all the teachers and staff members under
                  your revered guidance, and the decision of continuing with the
                  'online mode' for its convenience and time saving impact for
                  all. <br />
                  <br />
                  Further, we would like to express our gratitude for awarding
                  the prestigious 'Blue Blazer' at the scholar badge ceremony
                  for '21-22. This, indeed, fills the student with a sense of
                  pride and achievement, and they will strive hard to "maintain"
                  this status in the coming years. The habit of hard work (and
                  smart work) which they will cultivate now is going to help
                  them for the rest of their life!
                  <br />
                  Thank you once again,
                  <br />
                  Best wishes and Regards,
                  <br />
                  Dr. Harleen Wason / Amit Wason
                </p>
                <hr />
                <p>
                  Hello Mams,
                  <br />
                  <br />
                  We are extremely happy for how the "Hues of Learning" program
                  was run and coordinated over the last three days. You played a
                  pivotal role through the year in building up the confidence of
                  our wards which was evident in the way they all performed. You
                  took the effort in explaining the itinerary of the program
                  time and again to all the parents as well as kids. We are also
                  thankful for giving them the stage and preparation to perform
                  with so much confidence that there was absolutely no stage
                  fright in any of them. Thank you for making us all believe
                  they can do it! :)
                  <br />
                  <br />
                  We also wanted to give feedback for the amazing experience we
                  as parents as well as Kiaan had the pleasure of sharing with
                  you both over the last 10 months. We can't thank you enough
                  for being a vital cog in shaping up Kiaan's personality. We
                  all were obviously uncertain and nervous about what the future
                  held when the schools began in online only mode, but you as
                  teachers were probably on the same boat too having to manage
                  an army of tiny tots in a virtual set up. We couldn't have
                  asked for a better learning curve for our wards. We could
                  never imagine Kiaan would be able to sit for such long hours
                  as he has always been an active kid while all his fancy chairs
                  went mostly unused. His attention span was always so short
                  that nothing could keep him engaged. We could hardly make him
                  write or read for the very same reason. We were hoping for all
                  of it to change and it did, thanks to you both. He started to
                  read and write, first because he feared his teachers and
                  eventually to impress as he adored you and loved the way you
                  praised him.
                  <br />
                  <br />
                  We are very happy to have gone ahead with Lotus Valley school
                  for Kiaan's education, for we may not have found better
                  teacher's elsewhere. We are elated for a successful
                  foundational year that has gone by in Kiaan's primary
                  education, but equally sad and nervous again for Kiaan as he
                  probably won't get your love, affection and knowledge in the
                  upcoming grades. You have set very high benchmarks that it is
                  hard to believe he'll get teachers of equal calibre and kind
                  hearts in the forthcoming grades.
                  <br />
                  <br />
                  We wish you all the very best and more success in setting up
                  the right values, vision and respect in the hearts and minds
                  of many more little stars!!
                  <br />
                  Thank you once again for all that you have done for Kiaan, he
                  loves you both and will miss you dearly!
                  <br />
                  <br />
                  Regards,
                  <br />
                  Kiaan and his parents
                </p>
                <hr />
                <p>
                  Respected ma'am,
                  <br />
                  Trust you are doing well.
                  <br />
                  Please find below the feedback from one of the parents from
                  Nursery- Lilies for 'Hues of Learning'.
                  <br />
                  <br />
                  Regards
                  <br />
                  Amandeep Vohra
                </p>
                <hr />
                <p>
                  Dear Mentors
                  <br />
                  <br />
                  We want to start with our congratulations on conducting such a
                  wonderful event "Hues of Learning". As parents, we can only
                  feel overwhelmed by the performance of all the students of
                  Nursery Lilies. We want to thank the class teachers Amandeep
                  and Shivani Ma'an for their persistent efforts throughout the
                  year that have brought tremendous change in the kids. We know
                  for a fact that both the class teachers have put an enormous
                  show of patience and hard work in navigating the bunch of
                  unlearned towards a life defining learning process.
                  <br />
                  We know that the year gone by was an unthinkable time of our
                  lives with pandemic playing spoilsport in the traditional
                  method of education. We as a parent were skeptical in the
                  start towards this online mode of education but the efforts of
                  the teaching fraternity and management of Lotus Valley have
                  proved that innovation is the key and every problem can be
                  solved with positive approach and effective execution. <br />
                  The change that we see in Manvik in the last year is not
                  something that we could have imagined with the current
                  constraints and seeing him communicating with such confidence
                  and clarity, understanding concepts like water cycle, life
                  cycle of a butterfly, solar system, continents etc. is
                  heartfelt.
                  <br />
                  We are grateful that the school decided to conduct Hues of
                  Learning for concluding this learning session. This has not
                  only given kids a platform to display their knowledge but also
                  boosted parents morale.
                  <br />
                  With our kid going to the next class, we can only hope that
                  this learning process continues with the same vigor and next
                  class teachers match the sincerity and passion as you have
                  demonstrated.
                  <br />
                  <br />
                  Thanks and Regards
                  <br />
                  Neha and Sumit Dua
                  <br />
                  Parents of Manvik
                </p>
                <hr />
                <p>
                  Dear Ma'am,
                  <br />
                  <br />
                  Hope you are doing well!
                  <br />
                  I am writing this email to express my gratitude towards the
                  excellent experience our children are having. The best blend
                  of focus on education and overall development has increased
                  their interest levels.Your dedication towards learners is
                  unparalleled.
                  <br />
                  We, as parents, have learnt a lot from your diligence towards
                  all topics including studies and a child's behaviour.
                  <br />
                  Please accept our sincere thanks for all your efforts. We have
                  seen a huge difference in our children.
                  <br />
                  <br />
                  Regards,
                  <br />
                  Geetika
                  <br />
                  m/o Advick Dua , Ayaansh Dua (IV- Ashokas)
                </p>
                <hr />
                <p>
                  Hello Mams,
                  <br />
                  <br />
                  We are extremely happy for how the "Hues of Learning" program
                  was run and coordinated over the last three days. You played a
                  pivotal role through the year in building up the confidence of
                  our wards which was evident in the way they all performed. You
                  took the effort in explaining the itinerary of the program
                  time and again to all the parents as well as kids. We are also
                  thankful for giving them the stage and preparation to perform
                  with so much confidence that there was absolutely no stage
                  fright in any of them. Thank you for making us all believe
                  they can do it! :)
                  <br />
                  We also wanted to give feedback for the amazing experience we
                  as parents as well as Kiaan had the pleasure of sharing with
                  you both over the last 10 months. We can't thank you enough
                  for being a vital cog in shaping up Kiaan's personality. We
                  all were obviously uncertain and nervous about what the future
                  held when the schools began in online only mode, but you as
                  teachers were probably on the same boat too having to manage
                  an army of tiny tots in a virtual set up. We couldn't have
                  asked for a better learning curve for our wards. We could
                  never imagine Kiaan would be able to sit for such long hours
                  as he has always been an active kid while all his fancy chairs
                  went mostly unused. His attention span was always so short
                  that nothing could keep him engaged. We could hardly make him
                  write or read for the very same reason. We were hoping for all
                  of it to change and it did, thanks to you both. He started to
                  read and write, first because he feared his teachers and
                  eventually to impress as he adored you and loved the way you
                  praised him.
                  <br />
                  We are very happy to have gone ahead with Lotus Valley school
                  for Kiaan's education, for we may not have found better
                  teacher's elsewhere. We are elated for a successful
                  foundational year that has gone by in Kiaan's primary
                  education, but equally sad and nervous again for Kiaan as he
                  probably won't get your love, affection and knowledge in the
                  upcoming grades. You have set very high benchmarks that it is
                  hard to believe he'll get teachers of equal calibre and kind
                  hearts in the forthcoming grades.
                  <br />
                  We wish you all the very best and more success in setting up
                  the right values, vision and respect in the hearts and minds
                  of many more little stars!!
                  <br />
                  Thank you once again for all that you have done for Kiaan, he
                  loves you both and will miss you dearly!
                  <br />
                  <br />
                  Regards,
                  <br />
                  Kiaan and his parents
                </p>
                <hr />
                <p>
                  Dearest Parminder Ma’am &amp; Ashima Ma’am
                  <br />
                  <br />
                  Thank you would be a small word for you for taking care of our
                  child REHAT KAUR.
                  <br />
                  You might not have realised that you have such good parental
                  qualities that while coming to school on the first day, Rehat
                  said ‘ Mumma she is like you”. In this tough time of pandemic
                  the kind of fun loving educational aura you have created that
                  too virtually is beyond imagination. Like playing with the
                  kids, doing activities to get the leaner’s concentration on
                  the screen is something no one would have ever imagined for
                  these kids. This is the only generation who has seen school at
                  this age of 6 years .<br />
                  We are truly thankful for inspiring our child to come out of
                  her shell. She loves you so dearly, and she seems to think
                  that you are made of magic. Thank you for being so good and so
                  patient with her. Bearing her complete DESI STYLE . Its an
                  honour for us as parents to hear a word of motivation &amp;
                  appreciation for Rehat from Ashima Ma’am in PUNJABI in PTM ,
                  which is our MOTHER TONGUE … We are equally grateful to
                  Parminder Ma’am who has never seen school as schedule for
                  work, she is always available to put more n more efforts to
                  solve the issues &amp; make the child comfortable. We are so
                  glad for teachers like you who really make a difference in a
                  child’s life. God bless you both more and keep up the
                  wonderful work!
                  <br />
                  We shifted from New Delhi to Gurgaon, at that time choosing
                  LOTUS VALLEY was a tough n complicated decision as we were
                  totally unaware of the culture but today we are here as proud
                  parents who can proudly say our kid goes to LOTUS VALLEY a
                  school of love &amp; laughter . TEACHERS LIKE ASHIMA MA’AM
                  &amp; PARMINDER MA’AM are your true assets. We highly
                  recommend to people this school got best teachers who take
                  care of the child their own.
                  <br />
                  <br />
                  Thanks &amp; Regards
                  <br />
                  Mrs &amp; Mr Amitoz Singh
                </p>
                <hr />
                <p>
                  Hello Mam,
                  <br />
                  <br />
                  Hues of Learning was a great learning experience for kids.This
                  is the day we are going to remember for a long time.
                  <br />
                  As a parent we felt so proud watching our daughter(Vanya)
                  explaining the complex things easily with a smile.Special
                  Thanks to Ms Nitika for patiently listening to our queries and
                  providing meaningful inputs to make Vanya's presentation more
                  innovative.She played the most important role in encouraging
                  and educating the children and honestly made our life as
                  parents little easier.
                  <br />
                  From our perspective, an integrated learning approach provides
                  a great platform for the learners to recapitulate the topics
                  learnt in academic session and make them more confident and
                  well prepared for next year. This is a great learning approach
                  and hopefully the mentors will come up with more such
                  innovative events in future!!
                  <br />
                  Thanks &amp; regards, <br />
                  Proud Parents <br />
                  Vanya Arora
                  <br />
                  Grade-1 Nightingales
                </p>
                <hr />
                <p>
                  Hello Mam,
                  <br />
                  Hues of Learning was a great learning experience for kids.This
                  is the day we are going to remember for a long time.
                  <br />
                  As a parent we felt so proud watching our daughter(Vanya)
                  explaining the complex things easily with a smile.Special
                  Thanks to Ms Nitika for patiently listening to our queries and
                  providing meaningful inputs to make Vanya's presentation more
                  innovative.She played the most important role in encouraging
                  and educating the children and honestly made our life as
                  parents little easier.
                  <br />
                  From our perspective, an integrated learning approach provides
                  a great platform for the learners to recapitulate the topics
                  learnt in academic session and make them more confident and
                  well prepared for next year. This is a great learning approach
                  and hopefully the mentors will come up with more such
                  innovative events in future!!
                  <br />
                  Thanks &amp; regards, Proud Parents <br />
                  Vanya Arora
                  <br />
                  Grade-1 Nightingales{" "}
                </p>
                <hr />
                <p>
                  Hello Mam,
                  <br />
                  We just wanted to express our heartfelt appreciation for a
                  well planned and executed event "Authorising Stars". <br />
                  We have read many books shared on social media and we are
                  amazed to see the imagination of inquisitive minds. The hard
                  work of children &amp; mentors is highly appreciable.
                  <br />
                  Special Thanks to Ms Nitika for a great job in mentoring the
                  kids. All the basics of story writing like Genre, protagonist
                  were explained well in the class and role playing in the
                  reading sessions made it fun for Vanya.
                  <br />
                  Regards,
                  <br />
                  Vanya Arora Parents
                  <br />
                  Grade1 Nightingales
                </p>
                <hr />
                <p>
                  Dear Ma'am, <br />
                  I am a happy parent who wanted to compliment the teachers and
                  the thoughts that go into the whole preparation process.{" "}
                  <br />
                  I was putting the leaves needed for an activity today in my
                  daughter's room when I overheard the conversation between
                  Shilpa ma'am and a child. I was highly impressed with ma'am's
                  response when the child commented about Goddess Sita knowing
                  taekwando. She is so brilliant and spontaneous with kids. Also
                  wanted to compliment upon the values and beliefs being
                  inculcated, whether it's making torans or knowing the how-why
                  behind different names of the gods. That's where we as busy
                  parents fail and the school and teachers are pitching in.{" "}
                  <br />
                  I agree that online mode is little difficult but I do believe
                  that the teachers are doing their best and I wish them the
                  very best. <br />
                  Thank you ma'am and wish you a very happy festive season.{" "}
                  <br />
                  Regards, <br />
                  Neha
                </p>
                <hr />
                <p>
                  Dear Principal Ma'am,
                  <br />
                  It was lovely meeting you at the school yesterday! Thanks for
                  inviting us to witness one of the most cherishable moments for
                  our daughter Ivana Agarwal receiving the prize from her lovely
                  principal ma'am! Thankyou for your kind and generous
                  compliments to Ivana, she adores every moment she spent in
                  your office yesterday. <br />
                  We are very glad to spend some moments with you Ma'am and your
                  grandson Anvay! Lots of Love and blessings to him! <br />
                  We hope Ivana will keep shining and make her school, teachers
                  and us proud! And most importantly thanks to Lotus Valley to
                  keep giving ample opportunities to the kids which brings out
                  the best in them! <br />
                  One small request ma'am, if you can please share the pics
                  clicked with you we would like to keep them as cherishable
                  memories for Ivana and us forever! Please find attached
                  picture clicked by us. <br />
                  Look forward to hearing back,
                  <br />
                  Warm Regards,
                  <br />
                  Priya Lokwani (Ivana's Mother){" "}
                </p>
                <hr />
                <p>
                  Dear Tuhina and Nancy Ma’am,
                  <br />
                  I would like to start with a big gratitude and my heartfelt
                  thanks.
                  <br />
                  Thank you for arranging today's session and giving our parents
                  the opportunity and platform to talk and share about their
                  lifetime experiences.
                  <br />
                  All grandparents and kids meet, see and talk to each other
                  every day but they were so excited and happy to connect this
                  way.
                  <br />
                  Kiyaan was super happy to meet them and also show his dada
                  dadi to all his classmates and it gave us also chance to meet
                  them all.
                  <br />
                  You both really made each one of them comfortable. Our parents
                  felt a very warm connect with both of you and were happy that
                  Kiyaan is blessed with such nice teachers so kudos to both of
                  you and a big shootout to LVIS school for this initiative .
                  <br />
                  Best regards,
                  <br />
                  Deepika
                  <br />
                  Child’s Name- Kiyaan Bhatia <br />
                  Grade- Prep Daffodils
                </p>
                <hr />
                <p>
                  Dear teachers <br />
                  It was really good to see all the grandparents talking about
                  kids and their experience. Great efforts by Shilpa and Nupur
                  ma'am <br />
                  Regards <br />
                  Sera’s parents <br />
                  Grade - Prep Primroses
                </p>
                <hr />
                <p>
                  Dear Rachna ma'am and Sonam ma'am
                  <br />
                  I would like to share my feedback on the grandparent’s day
                  that happened last week. <br />
                  This was a wonderful initiative from the school but teachers
                  like you brought it to life in such meaningful and beautiful
                  ways. I would like to pass on my heartfelt gratitude and
                  thanks for your efforts that you put in every day. <br />
                  The activity-garnered lot of appreciation from the
                  grandparent’s community solely because of your warm welcome
                  and ability to make everyone feel included that day. Starting
                  with a warm 'Namaste Aunty and uncle' did set the right tone
                  from the start. Saanvi's grandparents were overwhelmed and
                  really enjoyed speaking with you. The way everyone was able to
                  share their thoughts about their grandkids openly, was mainly
                  because of the pleasing way you spoke. I can only say that it
                  was an experience and spectacle to behold!
                  <br />
                  Thanks again for making it memorable for everyone. <br />
                  Jyoti Rajvanshi
                  <br />
                  Child’s Name- Saanvi <br />
                  Grade- Prep Marigolds
                </p>
                <hr />
                <p>
                  Dear Teachers
                  <br />
                  Greetings of the day!!
                  <br />
                  We duly received the bi-annual report card and it’s
                  overwhelming to see how wonderfully my child is growing and
                  learning day by day under your efforts. I would like to take
                  this opportunity to thank you from the bottom of my heart for
                  this fabulous learning experience, focussing on his each and
                  every aspect. Commendable efforts of both of you make us feel
                  proud on the decision of getting Aarav’s admission in LVIS.
                  <br />
                  Looking forward to see Aarav touching more heights under your
                  guidance and mentorship.
                  <br />
                  I assure you that we shall always be there for any kind of
                  parent support.
                  <br />
                  Thank you once again.
                  <br />
                  Regards
                  <br />
                  Preeti Gupta
                  <br />
                  M/0 Aarav Gupta
                  <br />
                  Grade- Prep Orchids
                </p>
                <hr />
                <p>
                  Dear lotus valley mentors <br />
                  This is a heartfelt letter to express my gratitude towards the
                  school authorities’ mentors and teachers for giving a lovely
                  opportunity of celebrating Grandparents Day and helping kids
                  connect with them even in circumstances like these where
                  personal touch is missing.
                  <br />
                  This has also helped parents like mine understand technology
                  and adapt to it only coz it was for their grandkids. <br />
                  Plus watching the super energy of the grandparents was an
                  overwhelming experience. I have personally learnt much from
                  them and can’t thank enough the school for this.
                  <br />
                  Please accept our many thanks.
                  <br />
                  Regards <br />
                  Roopa Pant <br />
                  M/o Aadiya Pant
                </p>
                <hr />
                <p>
                  Dear Ms.Malhotra
                  <br />
                  Truly appreciate the congratulatory message.
                  <br />
                  Aditya is growing leaps and bounds under your able guidance
                  and able to soar new heights by nouvelle initiatives that he
                  has been taking under Smriti's wings to shape his overall
                  personality from academics, sports to extra-curricular
                  activities. <br />
                  I firmly believe that my lovely wife Smriti is more
                  responsible for Aditya's success at Lotus Valley than me and I
                  should take this opportunity to acknowledge her dedication in
                  bringing up Aditya in the most responsible manner,
                  single-handedly.
                  <br />
                  I trust that Smriti is also adding immense value to your
                  esteemed organization in multiple ways and I am also thankful
                  for the opportunity that you have provided her to be of
                  service.
                  <br />
                  I come from a hospitality background where the pandemic has
                  impacted many of us adversely in many different ways,
                  therefore, getting this wonderful news has been like bringing
                  sunshine to my day.
                  <br />
                  I am sure to look you up the next time I am in India and pay
                  my respects in person.
                  <br />
                  Warm Regards
                  <br />
                  Lokesh Kumar
                  <br />
                  Proud Dad &amp; Grateful Husband
                </p>
                <hr />
                <p>
                  Respected Mrs. Malhotra,
                  <br />
                  I am Khushi and Vaanya Bhutani’s father, It recently came to
                  my knowledge that you have really gone above and beyond to
                  support the families, who have lost their loved ones during
                  second wave and waived off the school fee for kids to ensure
                  that they can pursue their education without worry. I
                  personally feel that this is a great example of humanity and
                  empathy for people who were impacted and not all the people
                  can think and act the way you did.
                  <br />
                  I was myself part of the various support groups across NCR
                  supporting families during the pandemic and that’s why I do
                  understand the situation and pressures you must have gone
                  through to do what’s “Right”. Think of it, how many people can
                  really rise themselves from protecting the community and you
                  are one of them.
                  <br />
                  Thank you is not enough; however, I would still like to really
                  share my gratitude for such an amazing gesture. I am extremely
                  humbled and grateful for your support.
                  <br />
                  Please do let me know should you require any support, or you
                  would want me to volunteer in any initiative for kids at
                  school.
                </p>
                <hr />
                <p>
                  Dear Principal and esteemed headmistresses,
                  <br />
                  The Covid pandemic has affected the entire world from public
                  to private sectors, large corporates to small/micro
                  businesses, universities/schools and all of us are impacted
                  with losses on both personal or professional fronts. While
                  we're all doing whatever we can to deal with this and help
                  each other out, I would like to thank Lotus valley and it's
                  leadership in helping the impacted families during these
                  difficult times.
                  <br />
                  From waiving off part of the development fees to providing
                  free education to children who have lost a parent, such
                  measures help everyone impacted and demonstrates the
                  generosity and compassion of Lotus Valley gurgaon.
                  <br />
                  Thank you once again for this gesture.
                  <br />
                  regards,
                  <br />
                  Ravneet and Shweta Singh.
                  <br />
                  Parents of Sohana Singh (Grade 7 - Mahanadi) and Riyana Singh
                  (Grade 1 - Hummingbirds)
                </p>
                <hr />
                <p>
                  Dear Ma'am,
                  <br />
                  Hope you are well.
                  <br />
                  I wanted to let you know that Nandini had a great time today
                  at school. She informed us, everything was well managed and we
                  were sitting at a distance. She was super happy on rejoining
                  the school and also said, would like to attend school
                  everyday.
                  <br />
                  I am really thankful to teachers and the school management for
                  taking this step for our children which was very important.{" "}
                  <br />
                  Looking forward to supporting the school. <br />
                  Thanks
                  <br />
                  Aarti
                  <br />
                  Nandini's Mother
                </p>
                <hr />
                <p>
                  To,
                  <br />
                  The Principal
                  <br />
                  Lotus Valley international School, Gurugram.
                  <br />
                  Subject : Vote of thanks for Rishit’s journey in Grade I
                  (Nightingales)
                  <br />
                  Respected mam,
                  <br />
                  I would like to extend my heartiest regard to Rishit’s class
                  teacher Nitika mam (Grade I – Nightingales) for her polite,
                  sensible and overwhelming love for the kids in Grade I during
                  the unexpected tough time of COVID pandemic, which was never
                  experienced before. The way she was handling the kids during
                  online classes was really commendable. Journey of online
                  classes were totally new for the kids as well as for the
                  school administration, teachers and parents. But the
                  smoothness of the process made everything joyful and
                  meaningful for the kids. It forces me to write you for such an
                  amazing experience.
                  <br />
                  I would like to thank you Principal mam for your guidance,
                  your core committee for processing and special thanks to
                  Nitika mam for her outstanding execution.
                  <br />
                  My regard to Divya mam, Tulika mam, Sadaf mam, PT sir, Music
                  sir &amp; mam, Art &amp; craft teacher, Yoga mam for enhancing
                  my extracurricular activities.
                  <br />
                  Thanks
                  <br />
                  Best Regards
                  <br />
                  Dr Rajesh Kumar, MD,DM
                  <br />
                  Associate Professor <br />
                  Deptt of Nephrology &amp; Renal Transplant Medicine
                </p>
                <hr />
                <p>
                  Dear Principal ma'am,
                  <br />
                  We really hope you are doing well and thank you for
                  everything.
                  <br />
                  We know it is a difficult period for everyone in the world.
                  Covid 19 has taken a toll on our lives and disrupted it in
                  many ways. But we would again like to stand up and applaud and
                  thank LVIS, teachers, administration and especially “Khushboo
                  Ma'am” for making things easier for us as parents and students
                  via undue hard work and efforts.
                  <br />
                  We are parents of Anya - Class Grade I Magpies and we are so
                  thankful to you and all other teachers for taking classes and
                  making children understand everything in the best possible
                  way.
                  <br />
                  Anya is missing her regular school a lot, missing seeing her
                  friends, teachers. But undoubtedly we are happy that we are
                  not missing on her studies as these are her foundation years
                  and a happy big milestone for her life...we don't know how
                  long the lockdown would be but we think this experience has
                  made us see life from a different perspective and filled us
                  with gratitude.
                  <br />
                  Kudos to the teachers who are managing both their personal
                  &amp; professional life in such a crisis situation. It’s
                  highly appreciated and a huge applaud to the teachers.
                  <br />
                  Yours Sincerely,
                  <br />
                  Ritika &amp; Manish Agarwal
                  <br />
                  Parents of Anya Agarwal
                  <br />
                  Grade I - Magpies
                  <br />
                </p>
                <hr />
                <p>
                  Good Morning Ma'am,
                  <br />
                  Hope this email finds you in good health.
                  <br />
                  Ma'am, <br />
                  With immense happiness, I would like to Congratulate You, Our
                  Vice Principal Ma'am and all the Teachers for such a
                  stupendous result of both Grade-10 and 12 learners.
                  <br />
                  Our teachers have worked so hard with the learners in these
                  unusual circumstances and didn't let the Pandemic be a
                  deterrent to the studies.
                  <br />
                  Ma'am, I'm so happy for Miheeka's Result. She has scored 100
                  in 3 Subjects and overall 96%.
                  <br />
                  I can't thank our teachers enough for their continuous support
                  and guidance for Miheeka.Not just academics, but in so many
                  extracurricular activities, she has kept herself busy
                  throughout the year.
                  <br />
                  Thanks to Lotus Valley School for giving such opportunities to
                  my child which is helping her in her overall grooming and
                  development.
                  <br />
                  Ma'am, along with Miheeka, I feel Immensely Happy and Proud to
                  be associated with Lotus Valley School.
                  <br />
                  I really hope and pray that the situation becomes conducive
                  and our kids join back school and we also get an opportunity
                  to meet each other in person.
                  <br />
                  Please Take Good Care Ma'am.
                  <br />
                  Once again Many Congratulations!
                  <br />
                  Warm Regards
                  <br />
                  Indrani Bhasin
                  <br />
                  M/O Miheeka Bhasin
                  <br />
                  (XI- Shakespeare)
                </p>
                <hr />
                <p>
                  I am overwhelmed while writing this email to you for an
                  amazing execution of Sports Day. I appreciate the way
                  different activities and dances were introduced throughout the
                  month and then commenced in the finale. It would have been
                  amazing if these kids had learned all this in offline classes
                  but still it was great to see these little munchkins
                  performing dance and activities. I would like to mention that
                  both of you did a great job in making this event a success.
                  Hats Off to dance and sports teachers as well. I look forward
                  to many more of such events in the future. Thank You <br />
                  Roohi Mathur <br />
                  M/o Riyanshi Mathur
                  <br />
                  Prep Orchids
                  <br />
                </p>
                <hr />
                <p>
                  Thanks Maam for such a great initiative.
                  <br />
                  In these difficult days kids are really missing the fun and
                  discipline that comes through sports. This has definitely
                  halped the, it has also given parents graet ideas to keep them
                  involved in constructive activities. Thanks. We truly loved it
                  <br />
                  Shanaya Goyal
                  <br />
                  Nursery Bluebells
                </p>
                <hr />
                <p>
                  It was really a pleasure to see our child performing so well
                  and enjoying every moment.
                  <br />
                  Thank you so much Maam
                  <br />
                  Shivaay Guglani
                  <br />
                  Nursery Carnations
                </p>
                <hr />
                <p>
                  Hello Ma’am,
                  <br />
                  Nevaan, Along with his parents, enjoyed the National Sports
                  Day celebration today. He was enthusiastic and excited for
                  this day, wearing his new dress, as per the dress code. He was
                  all happy to do the signature steps on the various sports
                  related dance numbers, like, chakk de, dil ziddi hai, as
                  taught by the teachers.
                  <br />
                  This was a good event in virtual environment. Thank you!
                  <br />
                  Regards,
                  <br />
                  Soumya Aggarwal
                  <br />
                  Nevaan’s Mother
                  <br />
                  Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  Hi Mam(s), I would like to thank you and the school team for
                  arranging such an awesome event. The way you managed our
                  3-year-old son to actively participated in this event is
                  commendable. Our son participated with such enthusiasm and
                  zeal that we could have imagined. You put in a lot of hard
                  work to make this happen.
                  <br />
                  We can see changes in our son because of you. We are highly
                  grateful to you for being there for our kid and helping him
                  grow. Aahan is always excited to attend the classes and it
                  feels amazing to see the joy of learning on his face.
                  <br />
                  Lastly, Congratulations to you and your school team for the
                  success of the event. <br />
                  Aahan Parihar Parents
                  <br />
                  Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  It was an awesome experience to attend today’s function.
                  Totally an enthralling combination of fun and learning.
                  Khiansh learnt about so many sports and sportspersons, which
                  will be going to surely motivate him to play. Hoping to have
                  next year event in the school! Thanks to the entire team for
                  organizing such a great event.
                  <br />
                  Regards
                  <br />
                  Khiansh’s Parents
                  <br />
                  Pre-Nursery Lilacs
                </p>
                <hr />
                <p>
                  Good Evening Ma’am,
                  <br />
                  The virtual sports day held on 31st August was a beautiful
                  experience. It was a great morning, to watch every child
                  perform their best. A special mention to the sports teachers
                  and the class teacher for the way they trained the kids
                  virtually and kept them motivated. <br />
                  The sports activities were very innovative and interesting and
                  kids loved every task assigned to them.
                  <br />
                  Thank You very much !<br />
                  Sweta &amp; Vishal Reddy
                  <br />
                  (Parents of Drihaana Reddy )<br />
                  Grade I - Nightingales
                </p>
                <hr />
                <p>
                  Dear maam,
                  <br />
                  Hope you and your family are doing well. I am a parent of
                  Riyana Singh. She is the student of Ms. Itey Wadhwa of Grade
                  I/Hummingbirds.
                  <br />
                  I am writing this email to express my heartfelt gratitude to
                  Itey Wadhwa maam for being such an amazing and dedicated
                  teacher. She is so compassionate and patient with kids and has
                  bonded extremely well with kids in such a short span of time
                  with her positivity and resilience. Her conceptual
                  understanding of subjects is meticulous and kids are building
                  a strong foundation under her mentorship. Even in the absence
                  of second teacher, she was able to single handedly manage the
                  class exceptionally well. It was very thoughtful of her to
                  call Riyana few times during summer vacations to catch up on
                  Riyana's health as Riyana was unwell before vacations. <br />
                  I am confident Riyana and other kids will shine under her
                  guidance and support.
                  <br />
                  Thank you so much maam for giving us such a wonderful teacher.
                  <br />
                  Regards <br />
                  Shweta Singh - Mother of Riyana Singh
                  <br />
                </p>
                <hr />
                <p>
                  It was an awesome experience to attend today’s function.
                  Totally an enthralling combination of fun and learning.
                  Khiansh learnt about so many sports and sportspersons, which
                  will be going to surely motivate him to play. Hoping to have
                  next year event in the school! Thanks to the entire team for
                  organizing such a great event. <br />
                  Regards
                  <br />
                  Khiansh’s Parents
                  <br />
                  Pre-Nursery Lilacs
                </p>
                <hr />
                <p>
                  Hi Mam(s), I would like to thank you and the school team for
                  arranging such an awesome event. The way you managed our
                  3-year-old son to actively participated in this event is
                  commendable. Our son participated with such enthusiasm and
                  zeal that we could have imagined. You put in a lot of hard
                  work to make this happen.
                  <br />
                  We can see changes in our son because of you. We are highly
                  grateful to you for being there for our kid and helping him
                  grow. Aahan is always excited to attend the classes and it
                  feels amazing to see the joy of learning on his face.
                  <br />
                  Lastly, Congratulations to you and your school team for the
                  success of the event. <br />
                  Aahan Parihar Parents
                  <br />
                  Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  Hello Ma’am,
                  <br />
                  Nevaan, Along with his parents, enjoyed the National Sports
                  Day celebration today. He was enthusiastic and excited for
                  this day, wearing his new dress, as per the dress code. He was
                  all happy to do the signature steps on the various sports
                  related dance numbers, like, chakk de, dil ziddi hai, as
                  taught by the teachers.
                  <br />
                  This was a good event in virtual environment. Thank you!
                  <br />
                  Regards,
                  <br />
                  Soumya Aggarwal
                  <br />
                  Nevaan’s Mother
                  <br />
                  Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  It was really a pleasure to see our child performing so well
                  and enjoying every moment.
                  <br />
                  Thank you so much Maam
                  <br />
                  Shivaay Guglani
                  <br />
                  Nursery Carnations
                </p>
                <hr />
                <p>
                  Thanks Maam for such a great initiative.
                  <br />
                  In these difficult days kids are really missing the fun and
                  discipline that comes through sports. This has definitely
                  halped the, it has also given parents graet ideas to keep them
                  involved in constructive activities. Thanks. We truly loved it
                  <br />
                  Shanaya Goyal
                  <br />
                  Nursery Bluebells
                </p>
                <hr />
                <p>
                  I am overwhelmed while writing this email to you for an
                  amazing execution of Sports Day. I appreciate the way
                  different activities and dances were introduced throughout the
                  month and then commenced in the finale. It would have been
                  amazing if these kids had learned all this in offline classes
                  but still it was great to see these little munchkins
                  performing dance and activities. I would like to mention that
                  both of you did a great job in making this event a success.
                  Hats Off to dance and sports teachers as well. I look forward
                  to many more of such events in the future. Thank You <br />
                  Roohi Mathur <br />
                  M/o Riyanshi Mathur
                  <br />
                  Prep Orchids
                </p>
                <hr />
                <p>
                  It was an awesome experience to attend today’s function.
                  Totally an enthralling combination of fun and learning.
                  Khiansh learnt about so many sports and sportspersons, which
                  will be going to surely motivate him to play. Hoping to have
                  next year event in the school! Thanks to the entire team for
                  organizing such a great event. <br />
                  Regards
                  <br />
                  Khiansh’s Parents
                  <br />
                  Pre-Nursery Lilacs
                </p>
                <hr />
                <p>
                  Hi Mam(s), I would like to thank you and the school team for
                  arranging such an awesome event. The way you managed our
                  3-year-old son to actively participated in this event is
                  commendable. Our son participated with such enthusiasm and
                  zeal that we could have imagined. You put in a lot of hard
                  work to make this happen.
                  <br />
                  We can see changes in our son because of you. We are highly
                  grateful to you for being there for our kid and helping him
                  grow. Aahan is always excited to attend the classes and it
                  feels amazing to see the joy of learning on his face.
                  <br />
                  Lastly, Congratulations to you and your school team for the
                  success of the event. <br />
                  Aahan Parihar Parents
                  <br /> Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  Hello Ma’am, Nevaan, along with his parents, enjoyed the
                  National Sports Day celebration today. He was enthusiastic and
                  excited for this day, wearing his new dress, as per the dress
                  code. He was all happy to do the signature steps on the
                  various sports related dance numbers, like, chakk de, dil
                  ziddi hai, as taught by the teachers. This was a good event in
                  virtual environment. Thank you!
                  <br />
                  Regards,
                  <br />
                  Soumya Aggarwal
                  <br />
                  Nevaan’s Mother
                  <br />
                  Pre-Nursery Asters
                </p>
                <hr />
                <p>
                  Thanks Maam for such a great initiative.
                  <br /> In these difficult days kids are really missing the fun
                  and discipline that comes through sports. This has definitely
                  halped the, it has also given parents graet ideas to keep them
                  involved in constructive activities. Thanks. We truly loved
                  it.
                  <br />
                  Shanaya Goyal
                  <br />
                  Nursery Bluebells
                </p>
                <hr />
                <p>
                  It was really a pleasure to see our child performing so well
                  and enjoying every moment. Thank you so much Maam
                  <br />
                  Shivaay Guglani
                  <br />
                  Nursery Carnations
                </p>
                <hr />
                <p>
                  I am overwhelmed while writing this email to you for an
                  amazing execution of Sports Day. I appreciate the way
                  different activities and dances were introduced throughout the
                  month and then commenced in the finale. It would have been
                  amazing if these kids had learned all this in offline classes
                  but still it was great to see these little munchkins
                  performing dance and activities. I would like to mention that
                  both of you did a great job in making this event a success.
                  Hats Off to dance and sports teachers as well. I look forward
                  to many more of such events in the future. Thank You. <br />
                  Roohi Mathur <br />
                  M/o Riyanshi Mathur
                  <br />
                  Grade Prep Orchids
                </p>
                <hr />
                <p>
                  It was a very well co-ordinated and excellently planned event.
                  The final performance itself showcased the amount of effort
                  put in by the teachers and the school management.
                  <br />
                  During the journey, our kids learnt so much about different
                  sports, skills, famous personalities etc. and all kids were
                  very thorough with all the steps and presented immaculately. I
                  also loved the badge kids themselves prepared.
                  <br />
                  Kudos to the entire team.
                  <br />
                  Zoomi Warman
                  <br />
                  Parent of Veer Marwah, Grade I Magpies
                </p>
                <hr />
                <p>
                  Dear Simran Ma’am, Sports day was super duper hit !! <br />
                  It was awesome to see kids performing so well and top it they
                  really enjoyed research work and share the knowledge with each
                  one!! Thanks to the PE ,dance ,music teacher and to you for
                  making them practicing so well!!
                  <br />
                  Warm Regards
                  <br />
                  Nidhi Sharma <br />
                  Parent of Nishka Sareen, <br />
                  Grade I Flamingoes
                </p>
                <hr />
                <p>
                  Dear Ma’am, <br />
                  Today's event was a great show. It was really fun to watch
                  little children participating with great zeal and enthusiasm.
                  Your management and effort made it a great success. <br />
                  We would like to appreciate and thank you and the management
                  for hosting and managing such event even during this time with
                  great success.
                  <br />
                  Thank You
                  <br />
                  Regards
                  <br />
                  Parent of Reyan Gulati, Grade I Penguins
                </p>
                <hr />
                <p>
                  Dear Simran Maa'm and respected teachers,
                  <br />
                  It was our pleasure to see these kids performing live and
                  making this sports day come alive with their zeal. Definitely,
                  it was a commendable effort by all the teachers could make
                  practice sessions possible along with their regular studies.{" "}
                </p>
                <hr />
                <p>
                  Never imagined that even an event like Sports day can be
                  organised and executed so well( virtually) by Teachers and
                  students team work. <br />
                  A special mention to Dance and Yoga teachers who made them
                  learn different skills in a brief time. <br />
                  Indeed a great day of this academic year. <br />
                  Thanks LVIS for focusing on the overall development of
                  learners. <br />
                  Warm regards
                  <br />
                  Dr. Anuj &amp; Shipra Chawla <br />
                  Parent- Siona Chawla, <br />
                  Grade I Flamingoes
                </p>
                <hr />
                <p>
                  Dear Ma’am,
                  <br />
                  Healthy mind lives in Healthy body. LVIS has always given due
                  importance to Sports &amp; Co-Curricular activities along with
                  Academics. <br />
                  Celebration of National Sports Day has been extremely
                  overwhelming. Kids learned a lot about various sports like
                  Boxing, Hockey as well as Athletics. They looked forward to
                  share their knowledge about the particular Sport they were
                  assigned. It helped in building Sportsmanship and teamwork
                  along with other qualities. <br />
                  Appreciate LVIS and the entire team for taking efforts and
                  making the journey of these little ones full of learning, fun
                  and laughter. Looking forward to many more such events in the
                  future. <br />
                  Ms. Indu Malhotra
                  <br />
                  Parent- Riyana Malhotra, Grade I Flamingoes
                </p>
                <hr />
                <p>
                  Dear Mam, We are extremely happy with the way the whole sports
                  day event was handled by you even during these virtual times.
                  It is commendable to see the enthusiasm of the kids as well as
                  that of the teachers for this kind of activity (never thought
                  a sports day could also be celebrated online with such
                  excitement ). Atharv had a wonderful time preparing as well as
                  presenting his research work during the event. kudos to you
                  and the kids for making it a great success!
                  <br />
                  Regards,
                  <br />
                  Madhvi -Parent of Atharv Bansal- Grade I Flamingoes
                </p>
                <hr />
                <p>
                  Good morning Ma’am,
                  <br />
                  Today's sports day event was really great. And we are actually
                  surprised that school has taken the pain to organize this
                  event virtually. The teachers has been working so hard with
                  the children and making them practice on screen which is a
                  really difficult job. Kudos to all of them.
                  <br />
                  Regards
                  <br />
                  Mousumi tyagi <br />
                  Parent of Virat Tyagi,
                  <br />
                  Grade I Flamingoes
                </p>
                <hr />
                <hr />
                <p>
                  Respected Teacher's ,A very Good Afternoon ,<br />
                  It was glad to see the outstanding performance of our
                  learners, the way they have done research work and spoke lines
                  about it. The way they did warmup exercises , shown their
                  skills on athletics, boxing and hockey and last but not least
                  the way the learners have showcased dance performance. Never
                  thought that even virtually this type of event and performance
                  is possible. Learners have really learned and gained a lot out
                  of it, as now they relate sports as a part of life. The credit
                  goes to the hardwork and efforts given by the class teachers ,
                  sports teachers , music teachers , dance teachers and all
                  other school staff members who have been working behind it ,
                  so that the event is successful. My regards and special thanks
                  to Respected Ritu Ma'am and Respected Principal Ma'am who
                  never comes in front of the stage but they are always there
                  standing behind the stage in organising and planning these
                  events on special and important days and making the
                  occasion/event finally successful.
                  <br />
                  Regards
                  <br />
                  Saurabh Sharma
                  <br />
                  Parent of Noor Sharma- Grade I Magpies
                </p>
                <hr />
                <p>
                  Dear Ma'am, <br />
                  It was such a wonderful event. All kids were full of
                  confidence, they thoroughly enjoyed themselves. I too enjoyed
                  it. Cheers to you Ma'am and all of your students. Great work.
                  Keep it up. <br />
                  Warm regards. <br />
                  Priti Chaudhary <br />
                  Parent-Anahita Malik- Grade I Flamingoes
                </p>
                <hr />
                <p>
                  Hello Ma’am , It was very nice event and very well managed .
                  Our children will come more confident through such activities.
                  <br />
                  Thanks and regards
                  <br />
                  Deepika -Parent of Anika Sharma, Grade I Flamingoes{" "}
                </p>
                <hr />
                <p>
                  Ma’am, Coming at Today’s event- Sports day activity.......{" "}
                  <br />
                  Well, u have added another feather to your crown I must say.
                  <br />
                  Heartfelt congratulations to you for the Job so well
                  accomplished.
                  <br />
                  Regarding any inputs I would say that keeping in mind the
                  situation and these online classes, the job was very well
                  planned and thoroughly executed too. Congratulations again!!
                  <br />
                  Regards <br />
                  Deepshikha
                  <br />A satisfied and happy Parent of Myra Arora, Grade I
                  Flamingoes{" "}
                </p>
                <hr />
                <p>
                  It was a wonderful event. It indeed came out as a great way
                  for learners to understand the game details. Thanks to
                  teachers for all efforts. <br />
                  Deepti Verma
                  <br />
                  M/o Aryaman Verma <br />
                  Grade II Doves
                </p>
                <hr />
                <p>
                  Really appreciate the efforts teachers have taken in putting
                  together an amazing performance. All the hard work was
                  reflecting during the performance. All learners are away from
                  each other and teachers are like the thread who has binded
                  them together.
                  <br />
                  Mallika Mittal
                  <br />
                  M/o Atharva Mittal
                  <br />
                  Grade II Kites
                </p>
                <hr />
                <p>
                  Excellent and well organised event. I feel Kids learnt a lot
                  and the self search made them more aware of the sports. Making
                  groups made them feel more inclusive instead of individual
                  performances. Great initiative!
                  <br />
                  Ishvinder Singh Chopra
                  <br />
                  F/o Arth Singh Chopra
                  <br />
                  Grade II Robins
                </p>
                <hr />
                <p>
                  All the participants were very enthusiastic and performed
                  really well. It was a beautiful experience watching kids
                  perform.
                  <br />
                  Nadia Ishtiyaq
                  <br />
                  M/o Pir Mohammad Saud <br />
                  Grade II Kiwis
                </p>
                <hr />
                <p>
                  It was lovely to see children presenting confidently and with
                  full enthusiasm. Every student was self starter and took
                  initiative to do their best. Thank you Anu Ma'am for giving
                  them such tasks to prove their strengths and motivate them by
                  praising their efforts. <br />
                  Monika Khari
                  <br />
                  M/o Pir Trishal Khari
                  <br />
                  Grade II Robins
                </p>
                <hr />
                <p>
                  Amazing efforts by students and especially teachers...heads
                  off to all of you.... Chak de!!! Karishma Shukla <br />
                  M/o Naisha Shukla <br />
                  Grade II Parrots
                </p>
                <hr />
                <p>
                  Sports Day provides platform to the kids to interact with each
                  other and they also learn the importance of fitness.
                  <br />
                  Deepak Gupta
                  <br />
                  F/o Kaashvi Gupta
                  <br />
                  Grade II Bulbuls
                </p>
                <hr />
                <p>
                  Amazing job done by the whole class, looking forward to the
                  next. once again, a very well job done And must appreciate the
                  teacher for keeping the children intact <br /> Tumul
                  <br />
                  F/o Yug Agrawal
                  <br />
                  Grade II Macaws
                </p>
                <hr />
                <p>
                  It was a great initiative by LVIS , as I can see a lot of
                  positive development in my child both physically and
                  mentally.. I would like to appreciate Devangana ma'am for her
                  commendable job in managing the sho
                  <br />
                  Dr. Geetika
                  <br />
                  M/o Rudra Raj Chandra
                  <br />
                  Grade II Kiwis
                </p>
                <hr />
                <p>
                  Thank you, Mam, for planning this in the virtual world. Kids
                  enjoyed a lot performing. <br />
                  Soma Mohapatra
                  <br />
                  M/o Saanvi Mohanty
                  <br />
                  Grade II Robins
                </p>
                <hr />
                <p>
                  It was a very refreshing experience to see kids conduct the
                  presentations all by themselves with such confidence and
                  excitement at such a tender age. This sports day is a super
                  success and all credit goes to students and their amazing
                  teachers.. all the best !<br />
                  Soumi Bose
                  <br />
                  M/o Advaita Bose
                  <br />
                  Grade II Bulbuls
                </p>
                <hr />
                <p>
                  It was a great performance by all the kids.. I would like to
                  thank all the teachers who put in their efforts to make the
                  event successful.. and especially you .. I appreciate all your
                  hard work and the way you helped the kids.. You were always
                  there for them clearing all their doubt related to the
                  event...which I know is not easy with 30 kids in a class.
                  Thank you so much again Neha Gupta
                  <br />
                  M/o Navya Gupta
                  <br />
                  Grade II Parrots
                </p>
                <hr />
                <p>
                  It was a great experience to see kids performing the tasks
                  enthusiastically. Great effort by Teachers.
                  <br />
                  Saurabh Gugnani
                  <br />
                  F/o Anayda Gugnani
                  <br />
                  Grade II Robins
                </p>
                <hr />
                <p>
                  It was a combined effort both from the learners and the
                  teachers.They put on a great show.Kids along with the parents
                  had fun.It was a very engaging activity.Kudos to the team
                  <br />
                  Anubhooti Sharma
                  <br />
                  M/o Rayaan Pradhan
                  <br />
                  Grade II Macaws
                </p>
                <hr />
                <p>
                  The learners never seize to amaze! The format of the sports
                  day was a very challenging one for a 6-7 years old, or, so I
                  thought. With a little direction from the teachers, it’s
                  amazing how the self - motivated kids understood what needs to
                  be done, collaborated with their team members, motivated &amp;
                  helped each other, practised and executed it with finesse!
                  Thankyou Lotus Valley for pushing their envelope and
                  inculcating team work in them! <br />
                  Gunjandeep Kaur <br />
                  M/o Uday Veer Singh
                  <br />
                  Grade II Bulbuls
                </p>
                <hr />
                <p>
                  It was great and well prepared. Kids did a good job. Teachers
                  have put a lot of effort. Priyanka Chaudhary
                  <br />
                  Parent of Jveer Singh
                  <br />
                  Grade III Cuckoos
                </p>
                <hr />
                <p>
                  Great experience for young ones on sports and presentation
                  skills!
                  <br />
                  Rajat Sharma
                  <br />
                  Parent of Shanaya Sharma
                  <br />
                  Grade III Hornbills
                </p>
                <hr />
                <p>
                  Great performance by the learners.. The efforts put in by the
                  teachers were commendable... Thank you
                  <br />
                  Kavyaan Arora
                  <br />
                  Parent of Garima Arora
                  <br />
                  Grade III Parakeets
                </p>
                <hr />
                <p>
                  Fabulous and energetic event . Emphasized very well on the
                  importance of physical fitness and also rolled us through the
                  success journey of our sportsmen
                  <br />
                  Rashmi Bhatia
                  <br />
                  Parent of Rahini Bhatia
                  <br />
                  Grade III Pigeons
                </p>
                <hr />
                <p>
                  It was a commendable job done by Ms. Divya and her students of
                  Grade 3 Pelicans. We had lots of fun watching all the learners
                  performing so enthusiastically and above all they were having
                  fun doing all the activities! Looking forward to more such
                  refreshing events.. Kudos Divya Ma'am and learners of
                  Pelicans.
                  <br />
                  Nupur Arora <br />
                  Parent of Aanya Arora
                  <br />
                  Grade III Pelicans{" "}
                </p>
                <hr />
                <p>
                  Sports day was well planned and children performed
                  fantastically. They have proved their Mattel in PowerPoint
                  presentation also. Amazing team work and mentor guidance
                  <br />
                  Ashwini Shah
                  <br />
                  Parent of Ridit Shah
                  <br />
                  Grade III Pigeons
                </p>
                <hr />
                <p>
                  It was outstanding performance. The learners were very
                  energetic and did superb. Vipula Satija <br />
                  Parent of Naysha Satija
                  <br />
                  Grade III Pigeons
                </p>
                <hr />
                <p>
                  Great effort by the teachers and the students. Good
                  performances. Keep up the great work Ruchika Goel
                  <br />
                  Parent of Gauri Saraswat
                  <br />
                  Grade III Skylarks
                </p>
                <hr />
                <p>
                  Respected Mrs. Malhotra,
                  <br />
                  I am Khushi and Vaanya Bhutani’s father, It recently came to
                  my knowledge that you have really gone above and beyond to
                  support the families, who have lost their loved ones during
                  second wave and waived off the school fee for kids to ensure
                  that they can pursue their education without worry. I
                  personally feel that this is a great example of humanity and
                  empathy for people who were impacted and not all the people
                  can think and act the way you did.
                  <br />
                  I was myself part of the various support groups across NCR
                  supporting families during the pandemic and that’s why I do
                  understand the situation and pressures you must have gone
                  through to do what’s “Right”. Think of it, how many people can
                  really rise themselves from protecting the community and you
                  are one of them.
                  <br />
                  Thank you is not enough; however, I would still like to really
                  share my gratitude for such an amazing gesture. I am extremely
                  humbled and grateful for your support.
                  <br />
                  Please do let me know should you require any support, or you
                  would want me to volunteer in any initiative for kids at
                  school.
                  <br />
                </p>
                <hr />
                <p>
                  Dear maam,
                  <br />
                  Hope you and your family are doing well. I am a parent of
                  Riyana Singh. She is the student of Ms. Itey Wadhwa of Grade
                  I/Hummingbirds.
                  <br />
                  I am writing this email to express my heartfelt gratitude to
                  Itey Wadhwa maam for being such an amazing and dedicated
                  teacher. She is so compassionate and patient with kids and has
                  bonded extremely well with kids in such a short span of time
                  with her positivity and resilience. Her conceptual
                  understanding of subjects is meticulous and kids are building
                  a strong foundation under her mentorship. Even in the absence
                  of second teacher, she was able to single handedly manage the
                  class exceptionally well. It was very thoughtful of her to
                  call Riyana few times during summer vacations to catch up on
                  Riyana's health as Riyana was unwell before vacations. <br />
                  I am confident Riyana and other kids will shine under her
                  guidance and support.
                  <br />
                  Thank you so much maam for giving us such a wonderful teacher.
                  <br />
                  Regards <br />
                  Shweta Singh - Mother of Riyana Singh
                  <br />
                </p>
                <hr />
                <p>Dear Principal and esteemed headmistresses,</p>
                <p>
                  The Covid pandemic has affected the entire world from public
                  to private sectors, large corporates to small/micro
                  businesses, universities/schools and all of us are impacted
                  with losses on both personal or professional fronts. While
                  we're all doing whatever we can to deal with this and help
                  each other out, I would like to thank Lotus valley and it's
                  leadership in helping the impacted families during these
                  difficult times.
                </p>
                <p>
                  From waiving off part of the development fees to providing
                  free education to children who have lost a parent, such
                  measures help everyone impacted and demonstrates the
                  generosity and compassion of Lotus Valley gurgaon.
                </p>
                <p>Thank you once again for this gesture.</p>
                <p>
                  regards,
                  <br />
                  Ravneet and Shweta Singh.
                  <br />
                  Parents of Sohana Singh (Grade 7 - Mahanadi) and Riyana Singh
                  (Grade 1 - Hummingbirds)
                </p>
                <hr />
                <p>Dear Madam, </p>
                <p>
                  My daughter Rehat Kaur is studying in your school -class
                  Nursery Dahliyas. We appreciate that school has organised
                  online classes for all the students during this pandemic.
                  <br />
                  However, our family have been victims of virus COVID 19. In
                  June 2020, I was first to be diagnosed as COVID+ve and then In
                  November 2020, My wife was also diagnosed as COVID+ve and in
                  January 2021, Rehat was also diagnosed as COVID+ve. As a
                  result, Rehat had to be kept in isolation on these 3
                  occasions. Not only she had to abstain from attending on-line
                  classes but she had to undergo mental trauma of separation
                  from her family. As a result, her studies suffered a lot.
                  <br />
                  But this loss was compensated by the help provided by her two
                  teachers: Ms Sheetal Mahajan and Ms Isha Vohra. Both these
                  teachers have been very much supportive. They made calls to
                  enquire about her health, regularly spoke to Rehat during the
                  isolation period and then took extra classes to make up for
                  the loss. Despite this help, they never treated her a laggard,
                  rather provided her every possible assistance. They mailed us
                  the curriculum, so that we can understand the gap and organise
                  time accordingly. We would like to thank them for their
                  support during the tough times.
                  <br />
                  This is school is first institution for her to ascend the
                  academic career path. And the staff and this school has given
                  a first step with a confidence which will enable her to
                  subsequently take big strides in her career. We value the
                  contribution made by the school and shall ever remember it.
                </p>
                <p>
                  Regards
                  <br />
                  Amitoz Singh
                </p>
                <hr />
                <p>
                  Goodafternoon Ma'am,
                  <br />
                  Wishing you and your team a very Happy New Year !!
                </p>
                <p>
                  This mail is delayed by almost a month...reason - am not too
                  good at writing formal mails, hence the hitch, uneasyness and
                  countless edits...and yet, here I am making an unsuccessful
                  attempt in writing one. <br />I won't be at peace until I
                  share and express my feelings, so kindly pardon me for
                  following this informal style.
                  <br />
                  Respected Ma'am,
                  <br />
                  I would like to convey my heartfelt thanks to all the mentors
                  of Grade IV Banyans. <br />
                  A lot 'not so happy' went into the last year....but I also
                  hold memories of moments which brought ease, comfort, calmness
                  and smiles. The last 10 months offered a mix bag of emotions.
                  It was draining physically emotinally and mentally. There was
                  a time when the celebrity virus caught me too !! And in
                  between all this, often my child wasn't getting my due
                  attention. <br />
                  And here's where my Santas played a flawless role :) His
                  teachers left us with melting moments !! They were gentle
                  &amp; liberal when he felt low, accomodating when he was all
                  messed up, lend a ear when he had some 'ghar ki kahani' to
                  tell, firm when he was loosing focus, strict when he needed
                  that look and all this wrapped in a warm bundle of love and
                  care. Am so full of gratitude for each one of them for going
                  that extra mile !! <br />
                  It surely takes a village to raise a child and am blessed to
                  be in a village like this :){" "}
                </p>
                <p>
                  Thanking you from the bottom of my heart..
                  <br />
                  Warm Regards,
                  <br />A happy and satisfied parent :){" "}
                </p>
                <hr />
                <p>
                  Respected Principal Ma’am, Harvinder Ma’am and Tina Ma’am,
                </p>
                <p>
                  Today was our second virtual Open House and I realised that
                  the school and teachers must be missing the students just as
                  much as they miss school. I know the school halls, classrooms,
                  fields and cafeteria must look sad and despondent, and
                  hopefully soon things will get back to normal. In the interim
                  I wanted to start by extending my gratitude to the teachers
                  for all the hard work they are putting in, it must not be easy
                  to work with students you have never seen before and have no
                  way of understanding except for what you see on screen but
                  more than halfway into the school term I can say with
                  absolutely certainty that each and every teacher has put in so
                  much into making this format a success.
                  <br />
                  The lockdown and extended period of virtual classes must have
                  gotten exhausting for everyone and so I wanted to share with
                  you a little bit of what Agastya has been up to during these
                  months. Agastya honed his Art, participated in an online quiz,
                  bettered his guitar skills, learnt how to write lyrics, sing
                  in a choir online, participated in debates and MUN, started
                  reading the news on an online platform, he learnt how to bake
                  with me and started helping in household chores. He learnt
                  that you can exercise at home without stepping out, he has
                  read more books than I can count! He learnt that you can be
                  attentive and responsive in class even when there is no
                  teacher to hold you accountable. He learnt to become more
                  responsible and independent, he learnt the value of doing
                  group activities and helping people who he may not have been
                  friends with during physical classes. He learnt that you don’t
                  need too much of anything, in fact what you have is more than
                  enough. I have not heard him complain about anyone in the past
                  9 months, maybe they have become more tolerant, maybe they
                  value each other just a little bit more and realise that it is
                  the diversity that makes everything more interesting.
                  <br />
                  Without realising this year all these kids gradually moved
                  towards the dreaded teens all while being cooped up at home, I
                  couldn’t be more proud of each and every child who has been
                  through this and come out stronger and smarter. While these
                  times may have taken away a lot from them, there is a lot to
                  be thankful for so this is me sharing the little things that
                  Agastya has learnt, just to give you a glimpse into the year
                  of his life you have missed.
                  <br />
                  Thank you once again for helping him grow, inch by inch, bit
                  by bit into a person who will make you proud maybe not by
                  grandiose actions but the little things that matter.
                  <br />I must admit I miss seeing all of you and the warm
                  smiles that always fill me with a sense of gratitude,
                  hopefully the impasse will change soon, until such time
                  wishing all of you stay safe and healthy.
                </p>
                <p>Warm Regards, Arjita</p>
                <hr />
                <p> Respected Principal Ma’am,</p>
                <p>
                  Can I take this opportunity to thank everyone at Lotus Valley
                  International School who have gone out of their way in order
                  to provide care for my daughter and the other children during
                  this situation. I am so very grateful.
                  <br />
                  I really appreciate all the work “Shalini and Ishmeet Ma’am”
                  are doing to set work for their class. This has especially
                  helped me as I am working from home and it has made things
                  less stressful, I just have to encourage and support my
                  daughter to do it. <br />
                  Thank you to everyone who is stepping up to ensure the
                  students are staying healthy and safe, and still continuing to
                  learn, during COVID-19. Teachers are balancing the challenging
                  demands of simultaneously teaching/working and parenting. I
                  want to acknowledge this difficult work, particularly as we
                  are all navigating uncharted waters together.
                  <br />
                  I am not surprised by the speed, innovation, creativity,
                  brilliance, sensitivity and care that I have repeatedly seen
                  in Shalini and Ishmeet Ma’am demonstrate during this crisis.
                  Education may look different right now, but the commitment and
                  care that teachers are providing to the students is
                  exceptional.
                  <br />
                  Please accept my sincere gratitude towards your hard work,
                  initiative, and flexibility. Be healthy and well!
                  <br />
                </p>
                <p>
                  Yours Sincerely
                  <br />
                  Ritika&amp; Manish Agarwal
                  <br />
                  Parents of Anya Agarwal
                  <br />
                  Class- Prep - Marigold
                </p>
                <hr />
                <p>
                  {" "}
                  Respected <br />
                  Anita Malhotra Mam
                  <br />
                  Principal
                  <br />
                  Lotus Valley International School, Gurgaon
                </p>
                <p>
                  I am glad to share my thought on behalf of parent of
                  RishitAyan (Grade I-Nightingales) on today's show on subject
                  of "GOOD HABBITS AND MANNERS". <br />
                  What a beautiful show it was. I congratulate all kids for
                  their extraordinary performance and their enthusiasm for this.
                  This was not only a show this was a learning concert for us
                  too. Beginning of the show with your prayer and beautiful
                  message till the end was a big hit. Rishit was waiting to see
                  you also. We thoroughly enjoyed this show.
                  <br />
                  During this time of pandemic you planned for this show on
                  virtual platform but we felt we were in Lotus valley
                  auditorium and connected to every kids. Best thing related to
                  this show was that every kids were very happy and excited for
                  this performance. To see happiness on face of kids is the best
                  gift for any parents. So thanks a lot for this beautiful
                  thought from the Lotus Valley Gurgaon Team under your
                  leadership.
                  <br />
                  Overall I will appreciate the way Nitika mam was able to
                  organize and coordinate every kids at this very tender and
                  growing age for this. Nitika mam is doing her marvelous job in
                  class as well. <br />
                  Great job mam and a round of applause to all kids, their
                  parents and teachers.
                </p>
                <p>Thanks</p>
                <hr />
                <p>Respected Principal Ma'am,</p>
                <p>
                  Hope things are going well and you are keeping safe. <br />
                  To begin with, congratulations on the successful completion of
                  Term I. <br />
                  It is commendable to note that even in such unprecedented
                  times, the
                  <br />
                  school has not only been successful in conducting online
                  classes with such patience, but also managed to conduct online
                  HY exams with sincerity and fervour. The very fact that we as
                  parents were given the important duty of invigillation made me
                  feel very responsible. I was proud to be a part of this
                  process and ensured that I encourage my daughter to do her
                  papers with full honesty. I would also like to sincerely thank
                  you for the important step taken to discourage children and
                  parents who did not follow this process honestly. The lesson
                  and values you have been able to inculcate in our children
                  through this process cannot be learnt anywhere outside.
                  <br />
                  I would also really like to take this opportunity to thank
                  Kriti Ma'am for patiently handholding us through the process
                  of mock tests, google drive set up, scanning and submission of
                  papers in time and ensure that no parents/children were in
                  panic or facing issues during this time. Her constant effort
                  in also ensuring that correct marks were uploaded, report
                  cards were sent in time and all queries were answered well in
                  time is appreciative.
                  <br />
                  Overall, the sheer commitment and effort shown in the whole
                  process until the last point reinforces my belief in the
                  school as always, since I am sure a lot of leg work,
                  deliberations and guidance must have gone in by all of you to
                  make this happen so smoothly. It almost looks like normal
                  times again :)
                  <br />
                  Lastly, please do let me know anytime how I can contribute to
                  the success of the school.
                  <br />
                </p>
                <p>
                  Thanks and regards
                  <br />
                  Shweta Talwar
                  <br />
                  Mother of ShivangiTalwar
                  <br />
                  Grade VI - Narmada
                </p>
                <hr />
                <p>Respected Madam,</p>
                <p>
                  I am Aditya Sundaram (IX Shivalik’s) parents read your
                  interviews last 2 weeks about school reopening.
                  <br />
                  I really appreciate your view about school opening you
                  mentioned in HT that you will assess the situation and same
                  for practical classes which demonstrates how you are taking
                  care of our children’s Safety. It clearly shows how you are
                  committed, dedicated Safety as priority which gives a great
                  confidence to the parents to send our Kids to such a great,
                  wonderful school.
                  <br />
                  As time flies Half year term is going to complete by end of
                  the month and with great teachers who taught online classes.
                  It is another milestone and biggest achievements from your
                  side and teachers who teaches under COVID-19 situation as they
                  do have challenges/constraints in their homes. As I know I am
                  working from home last 6 months it is very challenge to
                  concentrate fully due to some distraction.
                  <br />
                  The above words are not enough to praise your leadership,
                  commitment and great support to students, teachers and
                  parents. It is a great school, teachers, students and parents.
                  <br />
                </p>
                <p>
                  Regards,
                  <br />
                  Sundaram and Kala
                </p>
                <hr />
                <p>Respected Principal Ma'am,</p>
                <p>
                  Thank you so much for your kind words for Aadya and we really
                  thank Lotus Valley School under your esteemed leadership, for
                  shaping up my daughter's future. <br />
                  In such tough times during Covid, I will also take this as an
                  opportunity to extend our thankfulness to all the teachers and
                  especially Olympus Class teacher Ms. Sneha Mukherjee for
                  making such great efforts to ensure that all students are
                  being benefitted from the current online classes. The way the
                  teachers are taking care of all the queries of Aadya, is
                  greatly appreciated.
                  <br />
                  We are very happy for all teachers who are taking continuos
                  pain to upload worksheets and guiding our kid to resolve
                  issues, if any. <br />
                  Also, the way the Half yearly exams are planned across 2 days
                  of 1hour 30 minutes each, is really very helpful for all and
                  also the date sheet is very well prepared. <br />
                  Such flawless planning and execution is only possible under a
                  great leadership and we are really greatful to you, for this.
                  <br />
                  Just wanted to share our overall feedback and wanted to extend
                  once again our thankfulness to you and all the teachers of
                  grade X especially Olympus. As parents, we never felt that
                  there was any impact of Lockdown on the studies and regular
                  activities of my daughter. This is indeed due to a great team
                  effort by LVIS team.
                </p>
                <p>
                  Thank you so much Ma'am. Stay Safe!
                  <br />
                  Warm Regards,
                  <br />
                  Gautam&amp;Meenu Mukherjee
                </p>
                <hr />
                <p>Good Afternoon Maam,</p>
                <p>
                  I just wanted to write and let you know that the celebration
                  of International Day of Older Persons today was a brilliant
                  concept and well implemented. I could see every child and
                  their grandparents smile with pride this morning. It was a
                  beautiful sight. Drihaana was anxiously waiting for this day.{" "}
                  <br />
                  I have literally seen her grow into a very confident child in
                  the last few months. <br />
                  I want to thank you all for the effort and time that you put
                  in by planning and educating our children. The class teachers
                  efforts are praiseworthy and words are less to appreciate all
                  that they do for the learners. <br />
                  Thank You again for providing the children with such quality
                  Education. <br />
                  Stay Safe and I pray and hope our kids are able to attend
                  school soon.{" "}
                </p>
                <p>
                  Warm Regards,
                  <br />
                  Sweta Reddy{" "}
                </p>
                <hr />
                <p>
                  A big round of applause to you and the kids!!!! Our first
                  Virtual Assembly was a grand success and we enjoyed every bit
                  of it!The Lotus Valley team has time and again proved that
                  even the sky has no limits and that the show must always go
                  on! Even at this challenging phase you continue to keep our
                  kids motivated and talented. Thanking you once again. <br />
                  Thanks and Regards,
                  <br />
                  Parent of Nikita Memani- III Peacocks
                </p>
                <hr />
                <p>
                  Good afternoon ma'am. It was a very nice show that the kids
                  put up. Thank you for all your efforts. <br />
                  Thanks and Regards,
                  <br />
                  Parent of Ashnoor Bhatia- III Peacocks
                </p>
                <hr />
                <p>
                  Thank you so much Mam for putting up so much effort for a
                  wonderful amazing performance. Our kids are so fortunate to
                  have you. We all are feeling so special at this moment which I
                  am not able to express in words. Thank you Mam and thank you
                  to Hridev sir too for all the efforts which made the virtual
                  assembly a success.
                  <br />
                  Parent of Shiv Pant- III Parakeets
                </p>
                <hr />
                <p>
                  Thank you mam for the wonderful Assembly. Mesmerized by the
                  expressions and confidence of kids. Great job, it was the best
                  example of learning by doing. Thank you mam!
                  <br />
                  Parent of GeetanshChitara- III Parakeets
                </p>
                <hr />
                <p>
                  Ma’am really want to thank you from my bottom of heart for all
                  the effort and hardwork put by you and dance teacher.... Must
                  say kids are very lucky to have you as their class
                  teacher..... Without meeting you they have become so fond of
                  you!
                  <br />
                  Parent of Rayaansh Jain- III Parakeets
                </p>
                <hr />
                <p>
                  Such a lovely assembly! Fabulous performance by all kids!
                  Thanks a bunch to you! <br />
                  Parent of MannatSehra- III Parakeets
                </p>
                <hr />
                <p>
                  Thank you so much mam for all the efforts for a wonderful
                  assembly! Arnav is overjoyed!
                  <br />
                  Parent of Arnav Vig- III Parakeets
                </p>
                <hr />
                <p>
                  Thank you so much ma’am for the effort and hard work you have
                  put in to organise this virtually, it is commendable and
                  explicit. The kind of patience you have is unmatchable. Thank
                  you again for being so wonderful.
                  <br />
                  Parent of ShivikaBehl- III Pelicans
                </p>
                <hr />
                <p>
                  Dear Ma'am, Great efforts from your end. You are blessed with
                  immense patience. Your learners did excellent performance.
                  Also I want to add that the topic which was chosen was really
                  nice. Thank you so much for organizing this beautiful virtual
                  assembly.P.s We were also observing and were listening to you.
                  <br /> Learnt really new things from you. <br />
                  Parent of Aarya n Agraj Singh- III Pelicans
                </p>
                <hr />
                <p>
                  Dear Ma'am, Thank you so much for all your efforts and
                  guidance... The kids had a wonderful time and so did we.{" "}
                  <br />
                  Parent of Saesha Khanna- III Pelicans
                </p>
                <hr />
                <p>
                  Thank you ma’am, the kids really felt nice about today’s
                  session, thank you for all your efforts and patience. <br />
                  Parent of SeeratJetley- III Pelicans
                </p>
                <hr />
                <p>
                  Thanks a ton for your efforts. It was great! <br />
                  Parent of Kiara Jai Prakash- III Pelicans
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong> I would like to congratulate you
                  again for a nicely coordinated assembly. <br />
                  Parent of ArohiBeejawat- III Pelicans
                </p>
                <hr />
                <p>
                  It was a pleasure being part of the first ever virtual
                  assembly with kids. While we have been doing a lot of virtual
                  meeting and sessions in office without realizing that we could
                  have the kids also do the same. The kids have yet again proved
                  that they can do anything that they set their mind to. And
                  with a great anchor and motivator like you, they have really
                  done very well. Thanks a lot for your patience and support -
                  you are truly the guiding light for the kids and they love
                  you.
                  <br />
                  Parents of Anusha- III Skylarks
                </p>
                <hr />
                <p>
                  I just wanted to let you know how much we appreciate the hard
                  work you do every day, especially in these online classes.
                  Thank you for the patience you display while teaching. Aishani
                  is enjoying all other classes like dance, art, craft also. We
                  enjoyed today's assembly a lot. Thank you for all effort you
                  put in. We are lucky to have you as a teacher of our child.
                  <br />
                  Parent of Aishani Yadav- III Skylarks{" "}
                </p>
                <hr />
                <p>
                  Appreciate efforts by you and kids together. It was such a
                  nice feeling to attend virtual assembly today. Kids performed
                  so well. Thanks to you for proper guidance to our kids.
                  <br />
                  Parent of Advay Gupta- III Skylarks
                </p>
                <hr />
                <p>
                  Must say it was an amazing show by the kids in your
                  direction... Glad to be with you and for your constant
                  support.It was just amazing to see kids so independent and
                  confident in your presence. Thanks for your support and
                  guidance.
                  <br />
                  Parent of Mihira Das- III Skylarks
                </p>
                <hr />
                <p>
                  Thank you so much for such a wonderful experience of virtual
                  assembly, Kudos to your efforts and enthusiasm which helped
                  kid's also to give their best.
                  <br />
                  Parent of Chahel Gupta- III Skylarks
                </p>
                <hr />
                <p>
                  Congratulations for the wonderful assembly. <br />
                  Parent of AshniVora- III Skylarks
                </p>
                <hr />
                <p>
                  It was an amazing concept of the first ever ‘Virtual
                  Assembly’.... what a novel idea, beyond words. That something
                  like this is even possible. Cheers to the team behind the
                  thought. It gives me immense pleasure to share that what a
                  heart touching effort by the school to reach out to learners,
                  parents, grandparents and bringing the smiles on their faces
                  in these difficult times. Every time my child hears anything
                  about school, my child only says “I wanna go back to school,
                  missing it so much!” This is the magic of the school,
                  Principal Ma’am, headmistress, mentors.Principal Ma’am’s
                  address really touched us and kids sincerely offered their
                  prayers with her to end these hard times sooner than later....
                  what a heart touching moment. And Ritu Ma’am’s presence made
                  kids go gaga... they were actually giving her a tight hug...
                  we could feel her love. The twinkle in the eyes of kids to
                  look at their school, their teachers cannot be described.Hats
                  off to the grade 3 team of teachers and the class teacher
                  ‘Sarwada Ma’am’ who is doing a brilliant job in handling
                  Skylarks.
                  <br />
                  Thanks once again to the school for bringing ‘The School for
                  life.... to life!’
                  <br />
                  Parents of Sanvi Anand- III Skylarks
                </p>
                <hr />
                <p>
                  Good work, its difficult teaching and putting it up
                  virtually!! Amazing work by everyone!
                  <br />
                  Parent of Aarav Balecha - III Cuckoos{" "}
                </p>
                <hr />
                <p>
                  <strong>Hi Ma'am</strong> - Thank you for all you efforts the
                  assembly was awesome. Just wanted to pass my best wishes to
                  you!! <br />
                  Parent of Noya - III Cuckoos
                </p>
                <hr />
                <p>
                  Thank you ma’am. Congratulations to u for being able to get
                  the kids to prepare and perform so independently. Great job by
                  everyone under your guidance.
                  <br />
                  Parent of MairaSingal - III Cuckoos{" "}
                </p>
                <hr />
                <p>
                  Thanks for all the effort mam. It was a superb experience.
                  Thanks and stay safe.
                  <br />
                  Parent of Arunima Sharma - III Cuckoos{" "}
                </p>
                <hr />
                <p>
                  Great assembly.Thank you Mam for your patience and hard work
                  managing our little ones online
                  <br />
                  Parent of Aarav Aroara- III Cuckoos
                </p>
                <hr />
                <p>
                  Thanks Sanya Ma’am for putting this together. Thanks to Hridev
                  sir. The kids did a great job!
                  <br />
                  Parent of AmairaKhetarpal - III Cuckoos
                </p>
                <hr />
                <p>
                  Thank you for putting in so much efforts for the assembly.{" "}
                  <br />
                  Parent of Aisha Agarwal - III Cuckoos
                </p>
                <hr />
                <p>
                  Thank you so much ma'am for the wonderful and successful
                  online assembly. Thanks once again for your guidance and
                  motivation to the kids and making them perform so confidently
                  as a team
                  <br />
                  Parent of Prachita- III Hornbills
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  The assembly was stupendous in spite of the limitations
                  involved. It was simply awesome!! Kudos to all the kids and to
                  you.
                  <br />
                  Parent of MishkaSawhney- III Hornbills
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  It was a lovely assembly .Loved the confidence of the children
                  and how well they picked up in spite of the glitches and
                  unforeseen challenges :)
                  <br />
                  Parent of NaishaBothra- III Hornbills
                </p>
                <hr />
                <p>
                  D<strong>ear ma'am,</strong>
                  <br />
                  It was a wonderful show by all kids. Really appreciate all the
                  efforts u all take at this difficult time. Sparsh was all
                  excited for the assembly. Thanks and regards
                  <br />
                  Parent of Sparsh Jain- III Hornbills
                </p>
                <hr />
                <p>
                  <strong>Good Afternoon Maam,</strong>
                  <strong></strong>
                  Hope you are staying safe. I am Drihaana Reddy’s mother (
                  Prep- Primroses)<strong></strong>I am writing this email to
                  show my appreciation to the innovative teaching techniques
                  adopted by the class teachers to make virtual learning
                  interesting for the learners. <strong></strong>
                  Today’s hindi class was so much fun and interactive and my
                  child enjoyed it thoroughly and I truly compliment the
                  hardwork and preparation put in by the teachers to impart the
                  best to our children. <strong></strong>
                  Thank you again Lotus Valley for making the virtual classes
                  feel so real. <strong></strong>
                  Regards,<strong></strong>
                  Sweta Reddy
                </p>
                <hr />
                <p>
                  <strong>Dear ma’am,</strong>
                  <br />
                  It was an amazing concept of the first ever ‘Virtual
                  Assembly’.... what a novel idea , beyond words .. that
                  something like this is even possible. <br />
                  Cheers to the team behind the thought. It gives me immense
                  pleasure to share that what a heart touching effort by the
                  school to reach out to learners,parents , Grand parents and
                  bringing the smiles on their faces in these difficult times.
                  Every time my child hears anything about school, my child only
                  says “I wanna go back to school, missing it so much! “ this is
                  the magic of the school, principal Ma’am, headmistress,
                  mentors .<br />
                  Principal Ma’am’s address really touched us and kids sincerely
                  offered their prayers with her to end these hard times sooner
                  than later.... what a heart touching moment. And Ritu Ma’am’s
                  presence .... made kids go gaga... they were actually giving
                  her a tight hug... we could feel her love. The twinkle in the
                  eyes of kids to look at their school, their teachers cannot be
                  described.
                  <br />
                  Hats off to the grade 3 team of teachers and the class teacher
                  ‘ Sarwada Ma’am’ who is doing a brilliant job in handling
                  Skylarks.
                  <br />
                  Thanks once again to the school for bringing ‘ The School for
                  life.... to life’ .... and that too virtually. <br />
                  Humbled parents of Sanvi Anand
                  <br />
                  Grade 3 Skylarks
                </p>
                <hr />
                <p>
                  <strong>
                    Greetings of the day to principal maam, harvindermaam and
                    Ritu maam.
                  </strong>
                  <br />
                  I'm not good at writing formal emails but still I want to take
                  this opportunity of writing this mail.
                  <br />
                  I agree to one thing in today's time that taking virtual class
                  is not an easy task as not everyone is tech savvy but still I
                  can see efforts, dedication, patience and hard work of LVIS
                  teachers in making kids understand the concepts during these
                  virtual sessions.They are trying to create normal classroom
                  environment by giving reading opportunity to kids,small
                  science experiments,day to day talk in group time ,PE and many
                  more activities.
                  <br />
                  Hats off to Lvis teachers for their dedication efforts and
                  understanding limitations of students.The way teaching is
                  going on is commendable.
                  <br />
                  This appreciation goes to entire faculty of LVIS.
                  <br />
                  Thankyou LVIS family
                  <br />
                  Stay safe stay connected
                  <br />
                  Regards
                  <br />
                  Swati Jain &amp;Anuj Jain
                  <br />
                  Ayati Jain 6 Ganges
                  <br />
                  Saanvi Jain -Nursery Lillies
                </p>
                <hr />
                <p>
                  <strong>Respected Principal Maam&amp; Teachers,</strong>
                  <br />
                  I wanted to drop this thank you note to Lotus valley
                  international school family for putting so much of efforts to
                  keep the momentum of learning , joy and happiness on for our
                  little ones. I have two kids studying in lotus valley school ,
                  Naman Bajaj (prep daffodils) and LavanYa Bajaj (Grade VI
                  Niles).
                  <br />
                  When lockdown started and kids got to know that they won’t be
                  going to school for couple of months then they got very upset
                  , and as soon as they got to hear about virtual class , some
                  excitement came , and later they just started living it.
                  <br />
                  All thanks to teachers and brain behind it ( Respected
                  Principal Maam, Head Mistresses).
                  <br />
                  Regular classes with so much of rigour in complete learning
                  alongside a lot of fun activities , is just commendable ,
                  specially virtually .<br />
                  We loved the mentor program which really made my daughter
                  emotional as she wants to come back to school as soon as
                  possible.
                  <br />
                  We loved and thoroughly enjoyed the party for class prep today
                  , it was so well planned and executed by Parminder and
                  Raginimaam , children were thrilling and just living every bit
                  of it as if they are in their classrooms with their best
                  buddies.
                  <br />
                  Don’t have enough words to thank you all.
                  <br />
                  Best Regards,
                  <br />
                  Nitu Bajaj
                </p>
                <hr />
                <p>
                  <strong>Good afternoon Ma'am,</strong>
                  <br />
                  Greetings of the day!
                  <br />
                  This is a small gesture to appreciate all the hard work that
                  has gone into making online classes a real success.
                  <br />
                  Parents may have different perceptions but, personally, we
                  would truly appreciate the whole concept. The syllabus has
                  indeed moved forward, students have understood well, and, most
                  importantly, the whole thing has succeeded in keeping them
                  positively occupied. It also gives us a way forward when
                  schools have to close down due to temperature extremes or
                  pollution or alike. Hopefully, the students would remain
                  constructively occupied during the summer vacations as well
                  when we would be missing the online interactions.
                  <br />
                  We would appreciate the efforts and journey till date and look
                  forward to future course. We do acknowledge all the hard work
                  that goes into making the study material. <br />
                  Hope things revert to normalcy soon. Best wishes for Safety
                  and Good Health for the entire Lotus Valley Team!
                </p>
                <p>
                  Warm regards,
                  <br />
                  Dr.HarleenWason/Amit Wason
                  <br />
                  (Parents of TanviWason, <br />
                  Grade 7 Damodar)
                </p>
                <hr />
                <p>
                  <strong>Dear Principal Maam and Mentors </strong>
                  <br />
                  Hope this email finds you in best of your health. <br />
                  Though I am short of words and I am sure my appreciation won’t
                  be enough for the kind of work the mentors are doing
                  especially Ms. Tripti. She has tremendous patience and
                  kindness and this goes for all other teachers associated with
                  my child Purvi. I was much worried like any other parent as
                  how the online classes will contribute to the learning of
                  Purvi but the mentors had made it so fun and easy that Purvi
                  look forward to attend to each and every class. <br />
                  The hiccups of technical issues and other glitches will always
                  be there as we are so use to the conservative method but the
                  wonderful mentoring of the each individual has made it easy to
                  adapt to the “NEW NORMAL”. The type of methods and
                  preparations that mentors are ready with, makes online classes
                  a success. <br />
                  Overall, I am sure my kid is in safe place when it comes to
                  her learning &amp; development. I will look forward to more
                  programs and connects with everybody and would extend my full
                  cooperation whenever and wherever needed. <br />
                  KUDOS to all the mentors.
                  <br />
                  Thanks &amp; Regards
                  <br />
                  Aparna Gupta
                  <br />
                  (Happy parent of Purvi Gupta - 4th - Ashokas){" "}
                </p>
                <hr />
                <p>
                  <strong>Respected Ma'am</strong>
                </p>
                <p>
                  As an elated parent, I would like to extend my congratulations
                  and heartfelt thanks to you for the outstanding board
                  result(98.4%) of my daughter Ananya Jain. It is the result of
                  the dedicated efforts of your esteemed self and the meticulous
                  teachers at Lotus Valley who helped push Ananya on a daily
                  basis to better herself. Thank you Ma'am. I stand validated
                  once again in choosing this wonderful school for my daughter.
                  You have truly given wings to her dreams.
                </p>
                <p>
                  Regards,
                  <br />
                  Bharat Bhushan
                  <br />
                  Director, SVT/PV Engineering | Ciena{" "}
                </p>
                <hr />
                <p>
                  Ma'am, the show was incredible. Kudos to you. Vrishank Sen
                  (Macaws)
                </p>
                <hr />
                <p>
                  Sooo soo beautiful...thanks so much ma'am for all your love
                  for our kids Veer Vats ( Macaws )
                </p>
                <hr />
                <p>
                  {" "}
                  Thanku ma'am it was an amazing show...kids were so confident
                  and also fearless for stage..thanx for all your efforts and
                  co-operation you did Abizer Bhatia, 2-Kites
                </p>
                <hr />
                <p>
                  Thanks to u for so much of effort in putting together a show
                  like this Samaira Gandhi 2 Kiwi
                </p>
                <hr />
                <p>
                  <strong>Dear ma’am,</strong>
                </p>
                <p>
                  Thank you so much. This has been a fabulous year so far for
                  Ira and for us as her parents. We have seen her grow leaps and
                  bounds in the months that she has been with you. We are
                  thankful to you and the entire team that worked tirelessly for
                  the show today for taking Ira under your wings, helping her
                  grow, motivating her to learn, pushing her when she needed it,
                  pulling her back when she went too far and loving her so much.
                  I watched my daughter from a distance, knowing she had you all
                  and didn’t need me.
                </p>
                <p>
                  So thank you once again since there is nothing more I could
                  say to you.{" "}
                </p>
                <p>
                  The show was fabulous. All the kids were brilliant. There were
                  so many moments during the play when I struggled to remember
                  to look at Ira since everyone on stage was so captivating. It
                  was all too easy to forget where we were and to lose ourselves
                  in what was happening on stage. We are enchanted. Thank you
                  for the experience Ira Awasthi Grade II Bulbuls{" "}
                </p>
                <hr />
                <p>
                  <strong>Dear ma'am,</strong>
                </p>
                <p>
                  Congratulations to all the teachers and the entire team who
                  organised such a fabulous annual concert "Charlotte's Web"
                  yesterday.We thoroughly enjoyed the jaw dropping performance
                  of all the kids, every minute details were careful taken care
                  by you all.Thanks a lot for putting up sincere efforts in
                  bringing out the best in children
                </p>
                <p>Mitashi Bansal (Tanishka's mother)</p>
                <hr />
                <p>
                  <strong>
                    Dear ma’am,
                    <br />
                    Greetings!
                  </strong>
                </p>
                <p>
                  Congratulations to you and your team for a superb SHOW!!!!! We
                  thoroughly enjoyed every bit of it, Learners carried out their
                  roles effortlessly, flawlessly and smoothly........ Kudos to
                  the little ones and KUDOS to the mentors, art, music, drama
                  department. When parents return happy to see their child on
                  stage , we understand that a lot of effort, toil and hardwork
                  of Teachers also goes into it and we really appreciate that
                  effort and hardwork. Please accept our gratitude and thanks
                  for showcasing such a wonderful show. Many many thanks to Dear
                  Ritu Ma’am for always being patient and supportive to the
                  little ones and their parents. My heart felt token of thanks
                  to her for always BEING THERE .
                </p>
                <p>
                  Thanks and Regards <br />
                  Parents of Sanvi Anand <br />
                  Grade 2 Robins
                </p>
                <hr />
                <p>
                  Thank u maam,real efforts are of urs,it ws really beautiful
                  and well planned and organized prgm God bless u all Atharv-
                  Grade 2Doves
                </p>
                <hr />
                <p>
                  The show no doubt was a big hit . All the teachers staff n
                  kids did a very hard work to make it super duper show .
                  Specially you mam . Took a good care of the kids , sending
                  this msg or the other so that parents might not hv any problem
                  .
                </p>
                <p>
                  {" "}
                  Kudos to you all <br />
                  Shreyan - Grade 2 Doves
                </p>
                <hr />
                <p>
                  Big congratulations to you for amazingly crafted assembly and
                  thanks for mentoring our little bundle of joys and always
                  being there.
                </p>
                <p>
                  Aarvi ‘s mother
                  <br />
                  Grade 1 Falcons
                </p>
                <hr />
                <p>
                  It was a wonderful assembly. Students were so confident,
                  teachers hard work was clearly visible. Thanks to you Amyra
                  got the opportunity to be on stage.
                </p>
                <p>
                  Amyra Tandon ‘s mom
                  <br />
                  Grade 1 Falcons
                </p>
                <hr />
                <p>
                  Hello ma’am! Thank you so much for all the efforts and
                  hardwork put in the amazing show. Also for trusting and
                  shaping Aarna so well I was really amazed to see her
                  confidence. Thanks for everything
                </p>
                <p>
                  Aarna negi mom <br />
                  Grade 1 Falcons
                </p>
                <hr />
                <p>
                  Thanks so much for giving wings to Kshemya. I am really happy
                  that Kshemya us in your class. I can feel and see the
                  difference when a child is in really good hands like you.
                  Really appreciate all your efforts and support.
                </p>
                <p>
                  Kshemya’s Mother
                  <br />
                  Grade 1 Flamingoes
                </p>
                <hr />
                <p>
                  Dear Nitika ma'am and Simran ma'am, many congratulations and
                  compliments to you both, and our entire section for such fab
                  performance today. Forward to many more such delightful events
                  ahead.
                </p>
                <p>
                  Vanshika’s mother
                  <br />
                  Grade 1 Hummingbirds
                </p>
                <hr />
                <p>
                  It was a treat to eyes. Each and every child were at their
                  best! Kudos to your effort for guiding these little ones into
                  the right direction. Many congratulations and best wishes to
                  Divya ma’am as well.
                </p>
                <p>
                  Mother of Adhrit Chakraborty <br />
                  Grade 1 Kingfishers
                </p>
                <hr />
                <p>
                  Thank you ma’am, it was truly a delight to see them Perform
                  with such confidence. You really pushed their limits to a new
                  level. The vocabulary in the script was great and glad
                  children could remember and present it so well. Their Hindi
                  was so bang on.{" "}
                </p>
                <p>
                  Truly great <br />
                  Mother of Gitalaya Manchanda <br />
                  Grade 1 Kingfishers
                </p>
                <hr />
                <p>
                  Thanks to you Ma'am for your efforts . It was so well
                  organized and kids performances were fantabulous . Thanks a
                  lot for boosting so much confidence in them .{" "}
                </p>
                <p>
                  Mother of Rida Huck <br />
                  Grade 1 Kingfishers
                </p>
                <hr />
                <p>
                  Superb performance by the kids..all credit goes to the
                  wonderful teachers..really appreciate your hard work..many
                  thanks
                </p>
                <p>
                  Mother of Yashvardhan Kalra
                  <br />
                  Grade 1 Kingfishers
                </p>
                <hr />
                <p>
                  <strong>Good afternoon ma'am!</strong>
                </p>
                <p>
                  Congratulations for yesterday's successful event.. It was fun
                  watching kids performing with immense confidence!!{" "}
                </p>
                <p>
                  All thanks to you n your efforts..
                  <br />
                  Aanya’s Mother
                  <br />
                  Grade1 Magpies
                </p>
                <hr />
                <p>
                  Thanks Preeta ma’am for an outstanding assembly. Learners were
                  super confident and enjoyed delivering their performance. Well
                  planned and very well executed....
                </p>
                <p>
                  It felt great to be associated with a superb mentor like you.
                  Looking forward to more such opportunities.
                </p>
                <p>
                  Cheers!
                  <br />
                  Sarthak’s Mother
                  <br />
                  Grade1 Magpies
                </p>
                <hr />
                <p>Hello Ma'am</p>
                <p>
                  It was a really good experience today. All learners did really
                  well. Was amazed by their confidence and vocabulary used.{" "}
                </p>
                <p>
                  Really appreciate
                  <br />
                  Thanks for all the efforts.
                </p>
                <p>
                  Regards
                  <br />
                  Reyansh’s Mother
                  <br />
                  Grade1 Magpies
                </p>
                <hr />
                <p>
                  Ma’am you did a brilliant job..the show was awesome..each and
                  every kid performed to the best of their abilities..kudos to
                  your commitment and hard work
                </p>
                <p>
                  Mayra Kurana’s Mother
                  <br />
                  Grade1 Magpies
                </p>
                <hr />
                <p>
                  <strong>Ma'am</strong>
                </p>
                It was a great performance by them. I can’t get over how
                beautifully they sang and how clearly they spoke !!!<p></p>
                <p>
                  Your hard work was visible <br />
                  Keep up the good work !
                </p>
                <p>
                  Amira Hooda Mother
                  <br />
                  Grade 1 Nightingales
                </p>
                <hr />
                <p>
                  Thanks a lot to both you and sonali mam for encouraging and
                  guiding our kids to give such a wonderful performance.
                </p>
                <p>
                  Regards
                  <br />
                  Yashveer Singh Sagoo Mother
                </p>
                <hr />
                <p>
                  Thank you Mam, this was indeed a great performance and really
                  appreciate your efforts as class teachers to prepare the
                  children for the event
                </p>
                <p>
                  Vivan Lamba Mother
                  <br />
                  Grade 1 Nightingales
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am</strong>
                </p>
                <p>
                  Thanks to you. So much effort and continuous practice. To
                  motivate the kids and to make them perform despite all their
                  inhibitions ,takes a lot. Thanks again{" "}
                </p>
                <p>
                  Rahini Mother
                  <br />
                  Grade 1 Nightingales
                </p>
                <hr />
                <p>
                  We are so grateful to have you as her teacher because it
                  requires immense energy and patience to deal with her. Your
                  positive attitude towards her is a great source of
                  encouragement and that’s what is keeping us going on. We are
                  thankful to God that you are there for her. She is lucky to
                  have a second mother in school. I am sure that it is just a
                  matter of time that is keeping her away from her goals. One
                  day very soon she will outshine and will be known as your
                  student.{" "}
                </p>
                <p>
                  We trust you completely. My daughter is in safe hands because
                  it is the teacher who can build the future of the child if he
                  or she wants.
                </p>
                <p>
                  Thank you
                  <br />
                  AANANDITA BANSAL'S MOTHER <br />
                  Grade 1 Penguins
                </p>
                <hr />
                <p>
                  Dear Ma'am, we are full of gratitude for the excellent
                  performances put up by you. Kids were so well prepared and
                  well disciplined. Also grateful for the opportunities you
                  offered to our kids for welling forth their potential. I am
                  sure you would have felt equally proud seeing all.of them
                  performing in the assembly.
                </p>
                <p>
                  Wishing best to both of you as we move forward in the session.
                </p>
                <p>
                  With regards, Navneet &amp; Rajan
                  <br />
                  MEHER NIGAM'S MOTHER <br />
                  Grade 1 Penguins
                </p>
                <hr />
                <p>
                  Great and enlightening workshop, as a parent I was able to
                  learn the skills to help my daughter learn better. Thank You
                </p>
                <p>
                  Amayara Tondon’s Mom
                  <br />
                  Grade I Falcons
                </p>
                <hr />
                <p>
                  I wish, I would have learned and experienced the same way like
                  these kids are getting classes. teachers make studies so fun
                  learning. Keep it up. Wonderful workshop!
                </p>
                <p>
                  Samaira Kukreja
                  <br />
                  Grade I Falcons
                </p>
                <hr />
                <p>
                  It’s always amazing to join such workshops. As parents , there
                  is a lot of learning which helps us to learn efficiently and
                  correctly. Thanks to the teachers for taking up so much pains
                  to organize such special classes.
                </p>
                <p>
                  Ahaan Mehta’ Mom
                  <br />
                  Grade I Falcons
                </p>
                <hr />
                <p>
                  Very Informative Session! Well framed and executed. Great
                  effort by the teachers, please do more of these. Keep up!
                  Lovely teachers!
                </p>
                <p>
                  Gitalaya Manchanda’s mom
                  <br />
                  Grade 1 Kingfishers
                </p>
                <hr />
                <p>
                  Informative and Impressive as always. We always wait and look
                  forward to this session. Thank you dear mentors for your
                  efforts to make us learn and grow with the right direction.
                </p>
                <p>
                  Vanshika’s mom
                  <br />
                  Grade 1 Hummingbirds
                </p>
                <hr />
                <p>
                  It was a learning experience for parents. We got our concepts
                  clear, now we would be able to teach them properly
                </p>
                <p>
                  Advay Gupta’s mom
                  <br />
                  Grade 1 Penguins
                </p>
                <hr />
                <p>
                  Thank you teachers for putting so much efforts of making us
                  learn the correct methods of learning. I think it was a loss
                  for the parents who were not able to attend. More of such
                  workshops should be organized. Thank you once again
                </p>
                <p>
                  Aarna Sharma’s mom
                  <br />
                  Grade 1 Magpies
                </p>
                <hr />
                <p>
                  Great workshop and efforts from teachers to make parents aware
                  with all teaching pedagogies which can be really helpful in
                  teaching kids.
                </p>
                <p>
                  Kavyaan Arora’s mom
                  <br />
                  Grade I Hummingbirds
                </p>
                <hr />
                <p>
                  <strong>Respected Ma’am,</strong>
                </p>
                <p>
                  A heartfelt thankyou for adding countless moments to my
                  treasured LVIS memorabilia. What we witnessed was sheer,
                  unadulterated MAGIC. The magic that transposed us to a
                  different world; the magic that left us awestruck; the magic
                  that made us believe that are munchkins are true prodigies;
                  the magic that made us cheer for an encore; the magic that
                  once again demonstrated the expertise, craftsmanship and
                  creativity of the mentors; the magic that further strengthened
                  our belief in the LVIS Leadership !!
                </p>
                <p>
                  “Theatre” has always made my heart skip a beat and bring a
                  twinkle in my eyes and when my child, at the age of 8, gets
                  this unique, immersive learning experience without me being
                  burdened/troubled/loaded with anything extra, I have all the
                  reasons to feel elated. Thankyou for cultivating a platform
                  where imagination holds equal importance as knowledge.
                </p>
                <p>
                  I can endlessly thank the entire team for the ‘moment of
                  pride’ we went through….but it surely will be a repetition.
                </p>
                <p>
                  Besides the core team, I want to appreciate Deepali’s efforts
                  for flawlessly making arrangements for the transport (there
                  was a day when my route bus travelled the entire distance only
                  for 1 kid…while the other days the max were 5).
                </p>
                <p>
                  And, please pardon me for this too informal and cheesy
                  statement, but aapki teachers kaunsi chakki ka aata khati hain
                  ? :){" "}
                </p>
                <p>
                  There were whatsapp updates as early as 7 am. Until 9 p.m.
                  Explicit details to even the tiniest of intricacy. Besides
                  managing the regular school schedule, rehearsals, snapapp,
                  parent queries and their personal life too. And not to forget,
                  that extreme micro management of the costumes. If my brain was
                  a CPU, it would have gone bizarre and behaved like a zombie
                  with this amount of pressure. I bow down to their energy ,
                  spirit and PATIENCE !!
                </p>
                <p>
                  …..thankyou isn’t the word !!
                  <br />
                  Himanshi
                </p>
                <hr />
                <p>
                  Thank you so much for the lovely, lovely performance. We
                  really appreciate your patience, perseverance and dedication.
                  It was delightful at the same time touching. Thank you for the
                  opportunity that you extended to Shom.
                </p>
                <p>
                  Shomaditya Ray’s Mother
                  <br />
                  Grade III – Pelicans
                </p>
                <hr />
                <p>
                  Thank you, was very good to see so many children participate.
                  I am sure they would have learnt much from the practice and
                  final performance.
                </p>
                <p>
                  Austin Raju Pullan’s Mother
                  <br />
                  Grade 3 -Skylarks
                </p>
                <hr />
                <p>
                  Wow ma'am, it was such a spectacular show … what a great
                  performance by our kids... And obviously the credit goes to
                  all of you... It was so well presented, well co-ordinated,
                  beautiful costumes, make up, team work, and endless hours of
                  minute work by all of you... You all had so much to take care
                  of and it was so well delivered...
                </p>
                <p>Kudos to all of you ma'am and heartiest congratulations!!</p>
                <p>
                  I hope you all can catch up same number of hours of sleep.{" "}
                </p>
                <p>
                  Vedika Marwah's mother
                  <br />
                  Grade 3 -Skylarks
                </p>
                <hr />
                <p>
                  I express my heartfelt thanks to you for allowing Misha to
                  perform for a single day. We really loved the efforts made by
                  school for today's successful event. Only LVIS can do any
                  event in such a organized way. And a special mention for the
                  instruction messages as I really like the way you all put
                  planning and discipline in everything. LVIS is the best school
                  when it comes to discipline, planning and care for the
                  children.
                </p>
                <p>
                  Many thanks again,
                  <br />
                  Mother of Misha Vasal <br />
                  Grade 3 - Cuckoos
                </p>
                <hr />
                <p>
                  Congratulations ma'am for such a beautiful show put together
                  and all your hard work showed with the kids ..
                </p>
                <p>
                  Siddh Bakliwal’s mother
                  <br />
                  Grade 3 - Parakeets
                </p>
                <hr />
                <p>
                  Hi Ma’m, it was a fabulous performance yesterday. Great hard
                  work put in by you and all the team.
                </p>
                <p>
                  Jayansh Saxena’s mother <br />
                  Grade 3 - Parakeets{" "}
                </p>
                <hr />
                <p>
                  Brilliant Play Ma’am !! Many congratulations to you and the
                  kids.
                </p>
                <p>
                  Siddharth Bansal’s mother <br />
                  Grade 3 - Peacocks
                </p>
                <hr />
                <p>
                  Thank you so much for the lovely, lovely performance. We
                  really appreciate your patience, perseverance and dedication.
                  It was delightful at the same time touching. Thank you for the
                  opportunity that you extended to Shom.
                </p>
                <p>
                  Shom’s Mother
                  <br />
                  Grade III – Pelicans
                </p>
                <hr />
                <p>
                  Thank you, was very good to see so many children participate.
                  I am sure they would have learnt much from the practise and
                  final performance.
                </p>
                <p>
                  Austin's Mother
                  <br />
                  Grade 3 -Skylarks
                </p>
                <hr />
                <p>
                  Wow ma'am, it was such a spectacular show … what a great
                  performance by our kids... And obviously the credit goes to
                  all of you... It was so well presented, well co-ordinated,
                  beautiful costumes, make up, team work, and endless hours of
                  minute work by all of you... You all had so much to take care
                  of and it was so well delivered...
                </p>
                <p>Kudos to all of you ma'am and heartiest congratulations!!</p>
                <p>
                  I hope you all can catch up same number of hours of sleep.{" "}
                </p>
                <p>
                  Vedika Marwah's mother
                  <br />
                  Grade 3 -Skylarks
                </p>
                <hr />
                <p>
                  I express my heartfelt thanks to you for allowing Misha to
                  perform for a single day. We really loved the efforts made by
                  school for today's successful event. Only LVIS can do any
                  event in such a organized way. And a special mention for the
                  instruction messages as I really like the way you all put
                  planning and discipline in everything. LVIS is the best school
                  when it comes to discipline, planning and care for the
                  children.
                </p>
                <p>
                  Many thanks again,
                  <br />
                  Mother of Misha Vasal <br />
                  Grade 3 - Cuckoos
                </p>
                <hr />
                <p>
                  Congratulations ma'am for such a beautiful show put together
                  and all your hard work showed with the kids ..
                </p>
                <p>
                  Siddh Bakliwal <br />
                  Grade 3 - Parakeets{" "}
                </p>
                <hr />
                <p>
                  Hi Ma’m, it was a fabulous performance yesterday. Great hard
                  work put in by you and all the team.
                </p>
                <p>
                  Jayansh Saxena <br />
                  Grade 3 - Parakeets{" "}
                </p>
                <hr />
                <p>
                  Brilliant Play Ma’am !! Many congratulations to you and the
                  kids.
                </p>
                <p>
                  Siddharth Bansal
                  <br />
                  Grade 3 - Peacocks
                </p>
                <hr />
                <p>
                  <strong>Dear Anita</strong>
                  <br />
                  Thanks&nbsp;ever so much for the most beautiful morning The
                  prestigious Invesiture ceremony 2019 What a memorable day?
                  Followed by your gratitude message And gorgeous photographs
                  Lucky are the students&nbsp;Under your leadership God
                  bless&nbsp;you&nbsp;the staff students and their parents{" "}
                  <br />
                  Dr Chona
                </p>
                <hr />
                <p>
                  <strong>Respected Ma'am</strong>
                  <br />
                  Its these lil things that instill my faith, time and again, in
                  the virtues of the school - Right from the Principal to the
                  helping staff !!
                  <br />
                  I was crossing the Arcadia red light in a cab and I see school
                  buses of 2 prominent gurgaon schools flaut the red traffic
                  signal. And then I see LV bus behind it (Route 24). My ostrich
                  neck turned in a milisecond to observe what happens next...coz
                  1. it was LV bus and 2. it's my route.
                  <br />
                  And my belief just got stronger when it halted just before the
                  turn.
                  <br />
                  What's more noteworthy is that it was a left turn, which under
                  no law is prohibited. But just to ensure safety, the driver
                  halted while the guard waved to make way and ensure the turn
                  happens only when its safe.
                  <br />
                  Our route parents have always been extremely happy with Guard
                  Jitender, and today, the driver too stole our hearts !!&nbsp;
                  <br />
                  A shout-out to Deepali for being on her toes every minute and
                  a BIG Thankyou to all the school chiefs for nurturing this
                  behaviour.
                  <br />
                  Himanshi Malhotra
                </p>
                <hr />
                <p>
                  <strong>Dearest Anita</strong>
                  <br />
                  I hope you are well.
                  <br />
                  I very much appreciate your note but it definitely should be
                  me that is thanking you!&nbsp; My face still aches with
                  smiling so much and I am still getting a lump in my throat and
                  tears in my eyes thinking about the wonderful experience that
                  you gifted to me.&nbsp; The pleasure&nbsp;was definitely all
                  mine!
                  <br />
                  You have such an amazing school with such fabulous students
                  and teachers.&nbsp; I am&nbsp;exceptionally proud to have had
                  the honour to&nbsp; be chosen to be your Chief Guest at this
                  prestigious event.&nbsp; It is memory that I will cherish
                  forever along with the wonderful photographs that you have
                  sent.
                  <br />
                  Thank you so much for my fabulous plant.&nbsp; I have named it
                  my 'Grade V' plant and it is looking beautiful with my
                  'Attitude' plant which you gifted to me on my last visit to
                  the school.
                  <br />
                  If there is anything else that I can do for you, please do not
                  hesitate to ask.&nbsp; I would be delighted to support the
                  school in anyway where you feel that I could add value.
                </p>
                <p>
                  Warmest Regards
                  <br />
                  Phillippa Mathewson
                </p>
                <hr />
                <p>
                  <strong>Respected Ma'am</strong>
                  <br />
                  Thank you for inviting us in the Scholar badge ceremony for
                  Grade V. It was truly a wonderful and well co-ordinated
                  event.&nbsp;It was lovely seeing the parents applauding for
                  each student regardless of whose child he/she
                  was.&nbsp;Prateek's journey started in Pre-Nursery, Roses and
                  each year has been a great learning experience for him. I
                  would like to share with you that he has even stopped me from
                  helping him in his hws/MTs and exams! It amazes me to see him
                  becoming such an independent learner.I would like to thank all
                  the mentors of Prateek who have always provided him the
                  guidance and proper direction.
                  <br />
                  &nbsp; Thank you once again!
                  <br />
                  Warm Regards, Rupa Rani Sinha
                  <br />
                  M/O Prateek Sinha
                  <br />
                  Grade VI, Narmada
                </p>
                <hr />
                <p>
                  <strong>Respected Ma'am</strong>
                  <br />
                  &nbsp; I,&nbsp;Meenu&nbsp;Mukherjee, M/o Aadya Mukherjee
                  presently studying in IX Vindhyas, would really like to
                  appreciate the efforts of all the teachers of Grade VIII
                  (except Spanish) for taking the time out to make the
                  worksheets along with the answer keys during the final
                  examination for the session 2018-2019.&nbsp;
                  <br />
                  &nbsp; I understand that I am too late in acknowledging the
                  wonderful work done by all the subject teachers, but was
                  extremely busy after the exams due to some other commitments
                  at home.
                  <br />
                  &nbsp; Not to miss the wonderful efforts of Ms.Anju Bala,
                  their class teacher in wonderfully handling the class, along
                  with Ms. Ragini Mall their Rep and Ms. Harwinder Kaur for
                  always being there for us in extending their help and support.
                  <br />
                  &nbsp; Lastly, thanking you for building such a strong team
                  under whose supervision great work is being administered.
                  <br />
                  &nbsp; Yours Sincerely,
                  <br />
                  &nbsp; Meenu&nbsp;Mukherjee
                </p>
                <hr />
                <p>
                  <strong>Dear Ma’am</strong>
                  <br />
                  &nbsp; My daughter, Ananya Jain, presently in Grade X Olympus,
                  had joined Lotus Valley Gurgaon in April 2018 in IX Vindhyas.
                  As she completes one year in the school and steps into a new
                  grade today, I would like to thank you for a wonderful year
                  gone by.
                  <br />
                  Ananya has always been academically excellent and has done
                  well in IX grade as well with 94% score. While acknowledging
                  the efforts of the teachers in contributing to her academic
                  performance, I would like to make a special mention of the
                  exposure that the school has provided to&nbsp; her in the
                  co-scholastic domain. This is one area where Lotus Valley has
                  had tremendous contribution in grooming her personality and
                  enhancing her confidence. The school gave her an opportunity
                  to participate in diverse activities like Behtar India,
                  SHIS-MUN, Nukkad Nataks, Inter-House Basketball competition,
                  Inter-school Art competition, Spanish fest, the Spanish
                  Exchange Program to Barcelona, School Stars to mention a few,
                  and these have given wings to her personality and polished her
                  innate talents. Being a part of the Community Service Club has
                  instilled in her the virtues of selflessness &amp; helping the
                  needy. I would like to extend heartfelt gratitude to you for
                  empowering your students, especially the new joinees, to
                  transition seamlessly into the environs of your school and
                  carve a niche for themselves.
                  <br />
                  &nbsp;Today Ananya is well-loved by all her teachers and has
                  shown holistic growth, thanks to all the co-curricular
                  activities that she was a part of. We are extremely happy to
                  say that we are proud parents of a proud Lotusian.
                  <br />
                  &nbsp;Ma’am, she is gearing up to take her SAT in October this
                  year and with your blessings, will hopefully score well. The
                  school has helped contribute significantly to her portfolio
                  and we are keeping our fingers crossed that she may get a
                  chance to be a part of the School Council to further polish
                  her rough edges.
                  <br />
                  &nbsp;Our decision to move her to Lotus Valley stands
                  validated today and we thank you and your wonderful team for
                  all your brilliant efforts. May Ananya soar to greater heights
                  under your esteemed guidance.
                  <br />
                  &nbsp;Thank you and warm regards,
                  <br />
                  &nbsp;Bharat Bhushan
                </p>
                <hr />
                <p>
                  <strong>Respected Principal mam,</strong>
                  <br />
                  &nbsp; My ward Shivangi just completed her Grade 4 with your
                  esteemed school. She was under the guidance of Neha Jain Mam
                  as part of Grade IV – Chinars. She overall scored an aggregate
                  of 97% with A1 grades in all subjects, A grade in all
                  co-scholastic activities/ discipline and physical education
                  and was able to keep a healthy attendance of 92% through the
                  year. She was also the Star Student of the month for April
                  2018.
                  <br />
                  &nbsp; I just wanted to write this
                  personal&nbsp;note&nbsp;to&nbsp;you&nbsp;and&nbsp;thank&nbsp;you&nbsp;for
                  the able guidance and encouragement&nbsp;you&nbsp;have shown
                  to us and the children through the year. Your constant
                  reminders and motivational talks were a guiding light for me
                  personally since I do belong to the old school of thought of
                  exams, revisions,&nbsp;notes, learning through them and so on,
                  unlike some schools/parents who consider it as a “stress”. I
                  am so glad that Shivangi has got this exposure early on and is
                  well prepared to take on healthy challenges ahead.
                  <br />
                  &nbsp; Last but not the least – I really want to put in a word
                  for Neha mam. She was a constant support through the year in
                  guiding Shivangi, helping her overcome her challenges and
                  providing me timely feedback to help me with Shivangi.
                  <br />
                  I can really see my daughter growing well in your and the
                  teacher’s capable hands.&nbsp;Thanks&nbsp;once again for
                  everything.
                  <br />
                  &nbsp; Yours sincerely
                  <br />
                  Shweta Talwar
                  <br />
                  Mother of Shivangi
                  <br />
                  Class V – Neems
                </p>
                <hr />
                <p>
                  <strong>Dear Anita Ma’am,</strong>
                  <br />
                  &nbsp; Let me start by expressing my heart felt gratitude for
                  all your love and support that you have given to Kabir while
                  he was with LVIS Gurgaon. We have never once regretted our
                  decision to change his school that we made five years
                  ago.&nbsp;
                  <br />
                  &nbsp; We have and will always be great ambassadors of Lotus
                  Valley.&nbsp;
                  <br />
                  &nbsp; Kabir had offers from 6 universities that we had
                  applied to (University of Virginia, University of Minnesota,
                  McGill University, York University, Western University and
                  University of British Columbia Vancouver Campus) for a BA
                  program in Psychology. He has accepted the offer for UBC and
                  has met the condition of scoring 85% or above in his final
                  12th exam.
                  <br />
                  &nbsp; Kabir and I would like to&nbsp;meet&nbsp;you for 5-10
                  mins on Monday, 6th May at your office. Please let me know
                  what would be a good time for you and we shall be there.
                  &nbsp; Best regards,
                  <br />
                  Simi Hanspal
                  <br />
                  9818028437
                </p>
                <hr />
                <p>
                  <strong>Dear Ma’am&nbsp;</strong>
                  <br />
                  Immense&nbsp; gratitude and heartfelt thanks for your
                  overwhelming support and guidance throughout the two years as
                  my daughter’s class teacher , mentor , a great SST teacher and
                  guiding force through her MUN career . You instilled in her
                  confidence and strive to reach out for bigger frontiers in
                  life <br />
                  Thank you, and thank you to all the teachers who corrected her
                  errors ,and taught her with utmost diligence. What this school
                  imparted to us was more than&nbsp; pure academics , true
                  education and returned to me an all rounder child -Shreeya .
                  She blossomed under the nurturing of her teachers and friends
                  .<br />
                  A heartfelt gratitude
                  <br />
                  &nbsp; Warm Regards&nbsp;
                  <br />
                  Ruchhi Chugh
                </p>
                <hr />
                <p>
                  <strong> Dear Ma’am,</strong>
                  <br />
                  &nbsp; Greetings from the Gut Microbiota and Probiotic Science
                  Foundation (India).
                  <br />
                  &nbsp; This mail is on behalf of Prof. N.K. Ganguly and all
                  members of the Foundation to&nbsp;thank&nbsp;you&nbsp;for the
                  delightful event that was organized by Lotus Valley
                  international School, Gurugram. The “Dr. Elie Metchnikoff Day
                  Probiotic Workshop” was one of its kind and mere words cannot
                  express the gratitude and appreciation that we are feeling
                  now.
                  <br />
                  &nbsp; We are truly overwhelmed by your dynamism and
                  leadership and the enthusiasm with which Mrs. Jaspreet Kaur
                  and Mrs. Sureena Uppal welcomed the event. The diligence with
                  which each and every detail was organized was an eye opener.
                  We would really like to&nbsp;thank&nbsp;you&nbsp;and the
                  entire team of teachers, especially Mrs. Monika Jasrotia for
                  this impeccable coordination. The Foundation is privileged to
                  be associated with&nbsp;you&nbsp;and your institution.
                  <br />
                  &nbsp; The mandate of the Foundation is to create greater
                  understanding and awareness about the fast evolving science of
                  the intestinal microbiota and probiotics and starting with
                  young minds is a brilliant choice. The presentations that were
                  showcased yesterday speak volumes about the level of knowledge
                  that students have and how fast they can assimilate
                  information both precisely and concisely.
                  <br />
                  We&nbsp;thank&nbsp;you&nbsp;again and would like
                  to&nbsp;congratulate&nbsp;you&nbsp;for the outstanding show.
                  <br />
                  We look forward to a long and continued association.
                  <br />
                  &nbsp;With warmest regards,
                  <br />
                  Neerja
                  <br />
                  GUT MICROBIOTA AND PROBIOTIC SCIENCE FOUNDATION (INDIA)
                  <br />
                  (Society Registration No. S/708/Distt.South/2017)
                  <br />
                  M-4, LEVEL ONE, SOUTH EXTENSION PART –II
                  <br />
                  NEW DELHI- 110049
                  <br />
                  CONTACT: 011-40524711
                  <br />
                  CELLULAR : 91-9818053239
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  Greetings! This email is to congratulate you and your entire
                  team on the investiture ceremony. The ceremony was so
                  impressive right from beginning till the end. I must
                  compliment you on the way you have been taking the students,
                  teachers and the entire staff towards growth. Students' love
                  towards you is remarkable. The efforts of your teachers in the
                  primary section was clearly visible in the ceremony. The kids'
                  performance was so loveable and the way they enacted was just
                  stunning.
                  <br />
                  The head boy and head girl demonstrated an extremely powerful
                  emotional connect with you and the school which was a pleasure
                  to see and we share a similar affinity towards you and the
                  entire staff having been associated with Lotus Valley since
                  the last 8 years.&nbsp;
                  <br />
                  Last but not the least the way safety and securuty is being
                  taken care of is commendable. Must appreciate the way guards
                  control the traffic both in the morning and afternoon.
                  <br />
                  We are filled with gratitude and would to thank you for
                  nurturing our child and providing her with a world of
                  opportunity.&nbsp;
                  <br />
                  Warm Regards,
                  <br />
                  Shikha&nbsp;and Mohit&nbsp;Gaur&nbsp;
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  Greetings! This email is to congratulate you and your entire
                  team on the investiture ceremony. The ceremony was so
                  impressive right from beginning till the end. I must
                  compliment you on the way you have been taking the students,
                  teachers and the entire staff towards growth. Students' love
                  towards you is remarkable. The efforts of your teachers in the
                  primary section was clearly visible in the ceremony. The kids'
                  performance was so loveable and the way they enacted was just
                  stunning.
                  <br />
                  The head boy and head girl demonstrated an extremely powerful
                  emotional connect with you and the school which was a pleasure
                  to see and we share a similar affinity towards you and the
                  entire staff having been associated with Lotus Valley since
                  the last 8 years.&nbsp;
                  <br />
                  Last but not the least the way safety and securuty is being
                  taken care of is commendable. Must appreciate the way guards
                  control the traffic both in the morning and afternoon.
                  <br />
                  We are filled with gratitude and would to thank you for
                  nurturing our child and providing her with a world of
                  opportunity.
                  <br />
                  Warm Regards,
                  <br />
                  Shikha&nbsp;and Mohit&nbsp;Gaur&nbsp;
                </p>
                <hr />
                <p>
                  TEACHERS OPEN THE DOOR YOU ENTER BY YOURSELF Chinese proverb
                  Dear Maam, THAT LIGHT and TEACHER in Pranav"s life is you. The
                  attributes exhibited by him are seed
                  <br />
                  Amit Goswamy
                </p>
                <hr />
                <p>
                  Amazing, great work, really soooo proud of you ma'am, you have
                  lakhs of fans in the children and their parents too!!!! WOW..
                  &nbsp;love you ma'am and can't thank you enough for all that
                  you've done for the school and all. Eternally grateful
                  <br />
                  Sureena Uppal&nbsp;
                </p>
                <hr />
                <p>
                  Heartiest congratulations Anita We are all so proud of you You
                  are really taking the wave of Lotus Valley all over God bless{" "}
                  <br />
                  Dr Chona
                </p>
                <hr />
                <h6>Reading programme gets a thumbs up</h6>
                <h6>Janmastami Celebration</h6>
                <p>
                  <strong>Dear Madam</strong>
                  <br />
                  Just wanted to share my opinion on the decoration in school..
                  <br />
                  I think it's fantastic !!
                  <br />
                  Just awesome effort by all the teachers...
                  <br />
                  Walking through the junior wing corridor is like a dream..
                  <br />
                  Thanks
                  <br />
                  Tina Kapoor
                  <br />
                  (Parent)
                </p>
                <hr />
                <p>
                  <strong>Dear Principal Maam,</strong>
                  <br />
                  Warm Regards
                  <br />I would like to convey sincere thanks for the great
                  session that we had with you and Headmistress Ritu, Monica and
                  Namita.
                  <br />
                  It was very thoughtful of you and this session brings the
                  school and parents on the same platform leaving no scope for
                  misunderstandings.
                  <br />
                  All issues were very beautifully answered by you Maam.
                  <br />
                  It really has increased our belief in the school and teachers
                  and under your guidance the school will surely go a long way.
                  <br />
                  Happy to be part of Lotus Valley Family
                </p>
                <p>
                  Thanks again
                  <br />
                  Pratima Singh
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am</strong>
                  <br />
                  In fact, we should be , and We are Really thankful to you, for
                  providing us the opportunity. in today's busy life, we forget
                  that there are few more responsibilities we carry.
                  <br />
                  Thanks so much for providing us the platform, to perform our
                  duty, and definitely we look forward for more opportunities
                  like this in future. Many Thanks &amp; regards <br />
                  Ar. Chanchal Batra
                  <br />
                  ( For Design !nnovations)
                  <br />
                  Do The work you love........ Love the work you do....
                  <br />
                  Architecture | Design &amp; Build |Turnkey Solutions| Expert
                  Retail Designs |Cost Management |Project Management
                  <br />
                  9582209400,0124-7177339,batra.chanchal29@gmail.com
                </p>
                <hr />
                <p>
                  <strong>Dear Anita, </strong>
                  <br />
                  Thank you for sending me the report for the month of August.
                  The reports are always a delight to read and I look forward to
                  it every month.I simply love the innovative ideas though which
                  the young learners are being introduced to different vital
                  concepts like the water cycle and the capillary action in
                  plants, fun filled learning through practical experience will
                  ensure that the concepts are ingrained in the minds of our
                  little lotus buds. Great to see that students of class prep
                  participated in inter-school events,exposures such as these
                  will go a long way in molding &amp; developing their
                  personalities. Fantastic to see parents being involved in the
                  reading program and the sit in program I am sure you must be
                  getting a positive feedback from these initiatives.
                  <br />
                  it fills my heart with joy and pride to see the children
                  excelling in different events organised within and outside the
                  school, good to know that students are actively taking part in
                  CBSE events as well. Heartiest congratulations to all the
                  winner of the month and especially to those selected to
                  represent in the state level sports competitions. <br />
                  Another thing I would specially like to applaud are the
                  paintings of the students from the Painting Club, I think they
                  are simply marvelous, would love to see some of them in
                  person.
                  <br />
                  Do share the feedback on the first issue of Different Strokes,
                  I am sure it would have been highly appreciated by all, also
                  let me know the feedback on the open house which was organised
                  in two different groups.
                  <br />
                  Keep up the good work and all the very best for next month.
                </p>
                <p>
                  Sincerely, <br />
                  Dr. Chona{" "}
                </p>
                <hr />
                <p>
                  <strong>Dear Madam,</strong>
                  <br />
                  Trust this finds you hale and hearty as ever. Every time I and
                  my wife visit and attend the school , I decide to do this ,
                  but then I forget. This time I am writing this to you.
                  <br />
                  The art and craft work at LVIS is rocking. The teacher(s)
                  there are doing a fabulous job. The Krishna art work done by
                  them is amazing. The one that is adorning the back lobby. I
                  took a picture and have shared it on Facebook as well with
                  credits to the school.
                  <br />I congratulate for having such creative teachers in the
                  school. A part of this creativity , if imbibed by the children
                  , will take them a long way.
                  <br />
                  Much appreciated.
                  <br />
                  Best regards and wishes for upcoming festival,
                  <br />
                  Nitin Sirohi
                  <br />( f/o Ananya Sirohi V Maples and Arjun Sirohi II Macaws)
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  Different Strokes is a very informative magazine. As parents
                  we come to know of all the events, achievements and other
                  activities that happen in school. <br />
                  Great efforts on behalf of the school to go paperless and
                  publish this magazine online.
                  <br />I would like to share just one feedback which has come
                  from few parents is that some kids appear two three times in
                  the magazine while some are not there at all even though they
                  have won some certificates and awards.
                </p>
                <p>
                  All the best!
                  <br />
                  Thanks
                  <br />
                  Rachna Mathur
                  <br />
                  Parent of :<br />
                  Aryav Mathur- Grade III- Hornbills
                  <br />
                  Avyan Mathur- PN- Roses
                </p>
                <hr />
                <p>
                  <strong>Dear mam,</strong>
                  <br />I am mother of Akshadha grade III Quails, and I am
                  really overwhelmed with the information shared by the school.
                  So many times I attended such interactions in schools but
                  never got to get an y feedback for the suggestions given. It's
                  really appreciable that school is really concerned about the
                  welfare and development of the learners. Relly happy that took
                  the decision to shift my wards into Lotus Valley, last year,
                  they are really blooming.{" "}
                </p>
                <p>
                  With regards and warm wishes <br />
                  Geetu Thakur
                  <br />
                  geetu.thakur95@gmail.com
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  Thank you for the very nice face time session on IV Acacias
                  today. I wanted to take the opportunity to congratulate you on
                  this wonderful concept of Face Time and Coffee with you, and
                  to tell you that I look forward to more such meetings.
                </p>
                <p>
                  Regards,
                  <br />
                  Jaya{" "}
                </p>
                <hr />
                <p>
                  <strong>Dear Maam</strong>
                  <br />
                  This is to share a note of appreciation for the school for the
                  extensive effort that is made to celebrate every festival and
                  occasion. We happened to visit the school for the reading
                  program yesterday and were elated to see the decorations done
                  to celebrate Janamashtmi. The craftwork and decorations just
                  made every nook and corner look so vibrant.
                  <br />
                  We couldn’t help but click a few pictures with a great sense
                  of pride to be a part of an institution that puts in such
                  effort to make each day of learning for kids exciting and fun
                  ! Our heartfelt congratulations to the entire team of teachers
                  lead by yourself and Headmistress Ms Ritu and entire support
                  staff to have made such efforts to convert the school into a
                  small “modern Gokul”.
                  <br />
                  We would also appreciate and recognize that the themes that
                  are chosen for assemblies are truly enriching. These events
                  not only inculcate good values but also help kids grow in
                  confidence through stage performances.
                  <br />
                  Our ward, Ruhaan, was admitted when the school strength was
                  around 400 students. Its heartening to see the school having
                  grown both in strength and stature under your able leadership.
                  We are proud to be associated with the institution and wish it
                  grows to greater heights.
                </p>
                <p>
                  Best Regards
                  <br />
                  Shuchita Aggarwal
                  <br />
                  Danish Aggarwal
                </p>
                <hr />
                <p>
                  <strong>Respected Principal Ma’am</strong>
                  <br />
                  I would like to compliment the school for handling the safety
                  of our children during the Jat Agitation.
                  <br />
                  The school authorities were most prompt in dealing with the
                  situation.
                  <br />
                  In a very timely and well co-ordinated manner we were informed
                  about the situation and most importantly this was well
                  anticipated and directions implemented.
                  <br />
                  Teaches without panic were able to get our children to safety
                  and in a quick and efficient manner.
                  <br />
                  Thank you for your wonderful astute decision making and care
                  for safety of our children. <br />
                  With best COMPLIMENTS and deep Respect
                </p>
                <p>
                  Sumeet Mayor
                  <br />
                  F/o Chirag Mayor and Shefali Mayor
                </p>
                <hr />
                <p>
                  <strong>Dear Ma’am,</strong>
                  <br />
                  I wanted to write this mail to thank you for your comments on
                  Pahal Bansal’s Report Card for her performance in Nursery –
                  Bluebells. It made us feel very proud of our daughter and
                  moreover Pahal was so happy to see it.
                  <br />
                  I also wanted to mention here and thanks her teachers: Nursery
                  (Ms Vaani, Ms Meghna and Ms Prakriti Ma’am) and Pre-Nursery
                  (Ms. Eleanor and Ms. Dimple Ma’am) for being such a great
                  teachers. Apart from performing their duties so nicely they
                  had always gone extra mile to work on each and every Learner
                  and we could feel that in all the interactions we had with
                  them. We always feel that we made a very good choice by going
                  for Lotus Valley and with each year passing by our confidence
                  in School strengthens further.
                  <br />
                  We look forward to getting same levels of quality and support
                  in future classes as well and would always be willing to take
                  all measures that shall help in overall development of the
                  school and our child.
                </p>
                <p>
                  Thanks &amp; Regards
                  <br />
                  Nihit Bansal
                  <br />
                  Pahal’s Father
                </p>
                <hr />
                <p>
                  <strong>
                    to charu.bhambri11, Head, me, JUNEJAAT, CHARUSURI
                  </strong>
                  <br />
                  Thank you Anita Ma’am, for giving us an opportunity to
                  participate in such a noble cause. Was so kind of you to
                  provide all the support &amp; encouragement throughout the
                  event. It was wonderful to see the entire team right from Ritu
                  Ma’am in constantly cheering everyone up, the teachers, the
                  helpers, electricians….so very helpful &amp; approachable. I
                  think we all worked as a team &amp; each one of us did our bit
                  in making it a success.
                  <br />
                  My daughter, Reyna had a great time, she was not only managing
                  her own stall but also supporting the other neighbouring
                  stalls so was a superb experience of working together as a
                  team.
                </p>
                <p>
                  Thank you once again.
                  <br />
                  Ritu Upadhyay
                </p>
                <hr />
                <h6>Sanskriti event</h6>
                <p>
                  <strong>Respected mam,</strong>
                  <br />
                  We are proud parents of Siddharth Bhaskar who is studying in
                  grade 1, falcons, in lotus valley Gurgaon.. We just witnessed
                  an event "Sanakriti" which by any means a very well crafted
                  presentation of a collaborative approach of school, teachers,
                  students and parents. It was really enthralling to see such a
                  variety of activities by our young ambassadors of intelligence
                  and very ably created and supported by teachers/school
                  administration.. The quality of event was of very high
                  standards and performances by respective class students was
                  quite captivating.. We are sharing couple of videos taken in
                  grade 1, falcons for your kind viewing..
                  <br />
                  I hope these attachments open without any glitches.. I will be
                  glad to share them again if they don't open in the
                  attachment..
                  <br />
                  Thank you for giving us this wonderful moment.
                  <br />
                  Wish you all a very happy and prosperous Diwali!!
                </p>
                <p>
                  With regards
                  <br />
                  Gitanjali Bhaskar
                </p>
                <hr />
                <p>
                  <strong>Dear Madam,</strong>
                  <br />
                  Please accept our congratulations on a fantastic organisation
                  of the Sanskriti day. Everything was beautifully done. The
                  decorations were out of the world - the art and craft team of
                  LVIS are rockstars. Teachers prepared their classes very well
                  , good relevant information , artefacts and decor truly
                  represented the states they chose to showcase. And children
                  were amazing - well dressed in traditional outfits , wishing
                  all the people , putting tilaks for welcome , they really
                  conducted themselves with tehjeeb and sanskars our country has
                  inherited from a rich cultural past.
                  <br />
                  We attended our son Arjun Sirohi's presentation on West Bengal
                  or Bengal as it will be known in future. II Macaws put up a
                  brilliant performance again , thanks to the efforts of
                  children and Ms Swati , the wonderful class teacher. <br />
                  Your steer and leadership shows in the way school looked
                  today. I must admit , it was difficult to leave the junior
                  section of the building today - a mini wonderland it was !{" "}
                  <br />
                  Once again a big applause and lots of appreciation for all the
                  learners and all in the staff who made it happen. <br />
                  LVIS Sanskriti day made us all very proud.
                </p>
                <p>
                  With regards and best wishes,
                  <br />
                  Nitin Sirohi &amp; Reetu Sirohi
                  <br />- parents of Arjun and Ananya Sirohi.
                </p>
                <hr />
                <p>
                  <strong>Dear Anita,</strong> <br />
                  Thank you for sending me the report for the month of August.
                  The reports are always a delight to read and I look forward to
                  it every month.I simply love the innovative ideas though which
                  the young learners are being introduced to different vital
                  concepts like the water cycle and the capillary action in
                  plants, fun filled learning through practical experience will
                  ensure that the concepts are ingrained in the minds of our
                  little lotus buds. Great to see that students of class prep
                  participated in inter-school events,exposures such as these
                  will go a long way in molding &amp; developing their
                  personalities. Fantastic to see parents being involved in the
                  reading program and the sit in program I am sure you must be
                  getting a positive feedback from these initiatives.
                  <br />
                  it fills my heart with joy and pride to see the children
                  excelling in different events organised within and outside the
                  school, good to know that students are actively taking part in
                  CBSE events as well. Heartiest congratulations to all the
                  winner of the month and especially to those selected to
                  represent in the state level sports competitions. <br />
                  Another thing I would specially like to applaud are the
                  paintings of the students from the Painting Club, I think they
                  are simply marvelous, would love to see some of them in
                  person.
                  <br />
                  Do share the feedback on the first issue of Different Strokes,
                  I am sure it would have been highly appreciated by all, also
                  let me know the feedback on the open house which was organised
                  in two different groups.
                  <br />
                  Keep up the good work and all the very best for next month.
                  <br />
                  Sincerely, <br />
                  Dr. Chona <br />
                  shayamachona@gmail.com
                </p>
                <hr />
                <p>
                  <strong>Dear Anita,</strong>
                  <br />
                  Thank you for sharing the report for September. I really
                  appreciate the efforts which are put in compiling these
                  reports and as always they are a delight to read and make me
                  feel that I have not missed a single day of school activity.{" "}
                  <br />
                  I am sure the kidzania trip would have been super fun, I have
                  been hearing a lot about Kidzania and am glad you arranged
                  this for the children.
                  <br />
                  Good to see the continuous involvement of parents through the
                  months in school activities. I am glad to see a variety of
                  activities which were themed on health and nutrition as it is
                  imperative to sensitize students about the same.
                  <br />
                  The drama skills activities seem quite interesting and is a
                  fantastic way to prepare students for the Annual Day and
                  future events.
                  <br />
                  The smiles on the faces of the students tell me that they are
                  really enjoying the club activities and are participating in
                  them with zeal and enthusiasm. Happy to know that they have so
                  many options available, this will enable them to explore their
                  hidden talents and potentials.
                  <br />
                  Needless to say that your Walkathon and excursions were a
                  great success, the pictures and feedback tells us all. <br />
                  Wishing you all the best for the coming month.{" "}
                </p>
                <p>
                  Sincerely, <br />
                  Dr. Chona
                  <br />
                  -- <br />
                  Dr. Shayama Chona
                  <br />
                  <em>Padma Bhushan &amp; Padma Shri Awardee&lt;</em>/p&gt;
                </p>
                <hr />
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  I would like to express my appreciation for the love, support,
                  guidance, assistance and much more that you have done for my
                  daughter. My daughter Tvesha Yadav was exposed to skating in
                  the school. Her talent was spotted by school coach Mr. Vinod
                  Kumar who encouraged her to discover her passion. She joined
                  skating under patronage of Mr. Vinod Kumar and started
                  reflecting results with in three months. She has won various
                  medals at District level. She also won two Gold medals at CBSE
                  skating championship at zonal level and qualified for CBSE
                  national championship. This year too, she won a silver and
                  bronze medal at SGFI States championship under 11 years
                  category. I would like to thank Mr. Vinod Kumar for bringing
                  out the best in her and teaching her discipline, time
                  management, dedication, hard work and patience.
                  <br />
                  Apart from skating, she is doing equally good in academics and
                  other curricular activities like Music, dance and art. This
                  clearly reflects the focus of school towards the overall
                  development of their learners.
                  <br />
                  I give all credit to Mr. Vinod Kumar, her teachers and
                  especially to the principal ma'am for encouraging and giving
                  her the freedom to participate in various events.
                  <br />I feel so proud and honoured as a parent to be a part of
                  a school which is led by a dynamic and inspiring mentor like
                  you.
                </p>
                <p>
                  Thanks and Regards
                  <br />
                  Parul Yadav
                </p>
                <hr />
                <p>
                  [15/10, 11:25] Vandita Pateriya Nursery Parent Rep: Just
                  visited the mela n its was an awesome experience.
                  <br />
                  Special congratulations to Ritu mam n LVIS team for the kind
                  initiative. Kids are enjoying fully in Games n food stalls.
                  Stalls r reasonably priced so parents r also enthusiastically
                  participating. <br />
                  My best wishes r with u. Hope u all can meet d cause.
                  <br />
                  Well done
                  <br />
                  [15/10, 12:12] Rachna Mathur Parent Rep Pn: I agree...Seva
                  Mela was excellent.. So much of energy all around.. Kids had a
                  great time.. Great work <br />
                  [15/10, 12:23] Shagun Parent Rep. gr 2: Kudos to Ritu Maam
                  &amp; team for spearheading this ... <br />
                  Awesome initiative !!! So much positive energy <br />
                  [15/10, 13:02] Dr Monga Parent Rep Gr III: It was definitely a
                  great concept, perfectly executed!
                  <br />
                  Great team work <br />
                  it think the fact that we were only dealing with kids made it
                  more fun. It's just so uncomplicated and simple. I hope we can
                  contribute and continue to help, it's a valuable lesson to the
                  kids as well.
                  <br />
                  Arjita trikha
                  <br />
                  Agastya trikha (III Pelicans)
                  <br />
                  Many congratulations ma'am <br />
                  Today's mela was a huge success!! All your efforts <br />
                  My class parents were appreciating a lot.
                  <br />
                  III SKYLARKS
                  <br />
                  Msg from the parent- <br />
                  We were glad to be a part of such a well organized seva mela..
                  It was a great event even better than normal fetes and melas.
                  Truly working towards the cause! Hats off to Lotus Valley
                </p>
                <hr />
                <h6>Thank you</h6>
                <p>
                  <strong>
                    to charu.bhambri11, Head, me, JUNEJAAT, CHARUSURI
                  </strong>
                  <br />
                  Thank you Anita Ma’am, for giving us an opportunity to
                  participate in such a noble cause. Was so kind of you to
                  provide all the support &amp; encouragement throughout the
                  event. It was wonderful to see the entire team right from Ritu
                  Ma’am in constantly cheering everyone up, the teachers, the
                  helpers, electricians….so very helpful &amp; approachable. I
                  think we all worked as a team &amp; each one of us did our bit
                  in making it a success.
                  <br />
                  My daughter, Reyna had a great time, she was not only managing
                  her own stall but also supporting the other neighbouring
                  stalls so was a superb experience of working together as a
                  team.
                </p>
                <p>
                  Thank you once again.
                  <br />
                  Ritu Upadhyay
                </p>
                <hr />
                <p>
                  <strong>
                    Mrs. Anita Malhotra
                    <br />
                    Principal
                    <br />
                    Lotus Valley International School
                    <br />
                    Gurgaon
                  </strong>
                  <br />
                  <strong>Dear Mrs. Malhotra</strong>
                  <br />
                  We gratefully acknowledge the receipt of your Annual School
                  Magazine "Cascade - A Deluge of Expressions", - 2015 - 16,
                  that reflects aspirations, accomplishments and accolades of
                  all the lotus valleyians.
                  <br />
                  It was a pleasure going through the efforts put in by your
                  team under able guidance! The magazine beautifully depicts the
                  iconic growth of Lotus Valley International School.
                  Partnership with Tamanna speaks volumes about the values and
                  ideals that the school stands for. 'Sound of Music' and 'Book
                  &amp; Beyond' also are interesting reads.
                  <br />
                  The Cascade has become part of our school library for all to
                  partake from it.
                </p>
                <p>
                  Thanking you again <br />
                  With regards
                  <br />
                  Ritu Bedi
                  <br />
                  Principal
                </p>
                <hr />
                <p>
                  <strong>Respected Anita ma'am,</strong>
                  <br />
                  My heartfelt congratulations to you on the richly deserved
                  success of the extravaganza that was 'Sanskriti'. <br />
                  The name itself evoked a sense of pride for our country, an
                  anticipation of display of our rich culture and heritage. The
                  entire event was so meticulously planned and executed. It was
                  far beyond our expectations.
                  <br />
                  My sincere wishes and thanks to each and everyone who was a
                  part of Sanskriti. The hardwork that had gone behind this
                  spectacular event was alive in the classes and all across. The
                  beauty and grandeur of the entire program cannot be described
                  in just a few words. Kudos to the entire team who went to
                  lengths to put up such a mesmerising event for us to witness.
                  <br />
                  Congratulations once again and hoping and wishing that the
                  school keeps soaring greater heights.
                  <br />
                  More power to the entire LVIS family.
                </p>
                <p>
                  Regards, <br />
                  Shivani Garg
                  <br />
                  (M/o Sidhansh Garg
                  <br />
                  Grade II Swifts )
                </p>
                <hr />
                <p>
                  <strong>Respected Ma'am,</strong>
                  <br />
                  It gives me immense pleasure to write this that i simply love
                  the Reading prog. My daughter Ashrita Chakraborty is in Grade
                  1, Penguins, she came back from school and after her usual
                  lunch and stuff she took out a story book and read the whole
                  book entirely on her own. I was surprised and at the same time
                  was very proud of her.
                  <br />
                  Special appreciation to the class teacher Ms. Khusi Nawani and
                  ofcourse kudos to Lotus Valley Gurgaon.
                </p>
                <p>
                  Regards (from a happy and a satisfied parent)
                  <br />
                  Tuhina Chakraborty
                  <br />
                  (Mother)
                </p>
                <hr />
                <h6>Respected Madam,</h6>
                <p>
                  <strong>Hello,</strong>
                  <br />
                  I am Sonali Bajaj, Nivedita's mother. She is in
                  Nur-Carnations.
                  <br />
                  Thank you so much for starting reading and Sit - in program. I
                  have attended the both. It was a wonderful experience.
                  <br />I was amaze to see how all kids were attached with their
                  teachers. loveena and Himansi madam were able to manage and
                  love them all giving equal attention.
                  <br />
                  Apart from this i was also surprised to see how loveena madam
                  was able to involve all the kids while teaching 7 wonders of
                  the world, types of house and life cycle of butterfly and
                  truly amazed to see every student answering questions asked by
                  her while teaching. The scene was the 8th wonder for me.
                  <br />
                  They both have very strong command and bonding with their
                  students. They are amazing.
                  <br />
                  Bache ghar aatey hue
                  <br />
                  khush hote hai. <br />
                  school khushi se jaye,
                  <br />
                  yeh badi baat hai.
                  <br />
                  Padate hue to
                  <br />
                  bahoto ko dekha hai,
                  <br />
                  koi Loveena aur Himansi... sa.. padaye
                  <br />
                  to badi baat hai.
                </p>
                <p>
                  Thanks &amp; Regards,
                  <br />
                  Sonali - Mandeep
                  <br />
                  9873678888/9811507876
                </p>
                <hr />
                <h6>Dear Mrs. Malhotra,</h6>
                <p>
                  As you are aware, Vaibhav( Class VII-Ravi) joined LVIS in
                  April 2014. Both the school as well as the CBSE curriculum was
                  new to him.
                  <br />
                  After the first few days at school, Vaibhav fell ill, was
                  hospitalized 3 times and went through dozens of specialists,
                  doctors, imaging &amp; scans and tests &amp; reports. As a
                  result, he missed school for a considerable period of time.
                  <br />
                  This is to deeply appreciate and applaud the support we got
                  from the school during this period, especially that from
                  Vaibhav's Class Teacher Madam Harvinder Kaur. During this
                  tough period, she was in constant touch with Vaibhav &amp; us,
                  updating us on the various activities at school also
                  comforting us. Once Vaibhav rejoined school, she took the
                  extra steps to ensure he got back on track quickly. The rest
                  of Vaibhav's subject teachers provided the help &amp; extra
                  support once he was back.
                  <br />
                  The result was Vaibhav settled down extremely well at school
                  and did well in his FA1 ( 5 x A1's, 2 x A2's). We are happy to
                  have made the change.
                  <br />
                  Once again, deep appreciation and heartfelt thanks to team
                  LVIS.
                </p>
                <p>
                  Best Wishes,
                  <br />
                  Subroto Das
                  <br />
                  Director-India &amp; South Asia
                  <br />
                  Mobile : +91 9871674507
                  <br />
                  <Link
                    to="https://wdc.com/en/"
                    target="_blank"
                    rel="noreferrer">
                    wdc.com
                  </Link>{" "}
                  |{" "}
                  <Link
                    to="https://wduniversity.com/Index.aspx"
                    target="_blank"
                    rel="noreferrer">
                    wduniversity.com
                  </Link>
                </p>
                <hr />
                <h6>Dear Ma'am,</h6>
                <p>
                  I wanted to write to you for so long but kept procrastinating.
                  I have to tell you
                  <br />
                  We throughly enjoyed Ishita's annual presentation. A special
                  thanks to LVG for extending an open invitation to all the
                  special people in the learner's life and not restricting it to
                  just the parents. It was a proud moment for Ishita's
                  grandparents and great grandparent (could not come but watched
                  the CD) to be part of an educational facility of LVG's
                  stature. We can imagine the kind of effort that went into
                  putting this together. You'd mentioned in your speech that
                  Krishna theme was your idea. It was such a welcome change in
                  today's age of Bollywood overdose. The quality of dance,
                  music, stage set-up and arrangements was outstanding. Giving
                  individual lines to some kids was a great concept. Even the
                  belly dancing act by prep kids the next day was classy and
                  created quite a sensations amongt the audience.
                  <br />I recently got to know from my daughter that you made a
                  public announcement saying everyone should feel free to walk
                  up to you if they want to talk to you. Thank you for
                  encouraging kids to speak up. Its wonderful to have an open
                  door / 2 way communication system. I am sure it will mean a
                  lot to the learners, especially those who have problems and
                  don't have adequate support system at home.
                  <br />
                  The additional expenses, though considerable, have not felt
                  like a rip off so far. The system is transparent (eg. books
                  and stationary) and quality is good (eg. group photos). I have
                  never felt fleeced by LVG. Some such expenses are optional
                  hence don't feel imposed (eg science workshop).
                  <br />
                  Ishita has gone to 4th standard now. She has started with her
                  FAs and I, as a parent, am still stuggling to get my act
                  together. I have certain suggestions around communication gaps
                  which I have marked in Ishita's diary and discussed with her
                  teachers in brief. I plan to take it up with Ruchi Ma'am and
                  the subject teachers in detail when I meet them in the Open
                  House. Vidhi Ma'am, Namita Ma'am have been most co-operative
                  and Vibha Ma'am has always attended to my queries even when
                  she is busy with dispersal or unwell. It just takes the pain
                  out of solving issues . Thank you for giving us such a
                  wonderful staff.
                  <br />A small suggestion for the videographer- he can perhaps
                  use a tripod while shooting.
                </p>
                <p>
                  Warm regards,
                  <br />
                  Smita Bhushan
                  <br />
                  m/o Ishita Bhushan
                </p>
                <hr />
                <h6>Perfect orientation programme</h6>
                <p>
                  <strong>Dear Anita,</strong>
                  <br />
                  This is to congratulate you for the perfect orientation
                  programme. Every moment of it exhibited your immaculate
                  planning and direction. You spoke so well. The songs of the
                  children were melodious. It was very nice to hear Mr. Aftab to
                  express his views on Gandhian values. You could start a Gandhi
                  Club in school based on Peace and Non- Violence and invole Mr.
                  Seth. Follow with him on Indo Japanese Friendship club. I will
                  certainly contact Mr Hiroji Koedo in Nagano.{" "}
                </p>
                <p>
                  The parents were full of praise for you. God bless you with
                  greater energy and ideas. <br />
                  Best wishes,
                  <br />
                  Sincerely, <br />
                  Anita{" "}
                </p>
                <hr />
                <h6>Thanking you...</h6>
                <p>
                  <strong>
                    To <br />
                    The Principal Lotus Valley International School <br />
                    Gurgaon <br />
                    Respected Mam
                  </strong>
                  <br />
                  Thank you very much for the wonderful trip organised by you
                  all to Gwalior. My daughter Soumya had a lovely time and was
                  very happy and exited. Sameer sir was very approaching and
                  caring towards the children and we were well informed about
                  our children. With such a reliable, helpful and hardworking
                  staff of the school we feel blessed to have chosen Lotus
                  Valley School. We are thankhful to god that he has given our
                  children the opportunity to bloom under your guidence. Thank
                  You once again.
                </p>
                <p>
                  Regards
                  <br />
                  Atul, Shilpa Vasishta <br />
                  31 March 2014
                </p>
                <hr />
                <h6>Thanking you...</h6>
                <p>
                  <strong>Dear Anita Ma’am,</strong>
                  <br />
                  It’s with the great pleasure and delight I am writing to you.{" "}
                  <br />
                  It’s been about 2 years that I am witnessing an honour to have
                  my daughter study in an institution like Lotus valley which
                  surely will construct not only strong academic and literally
                  figures, but more so certainly good human beings. <br />I and
                  my family attended the annual day and I must say it was
                  extraordinary! As you rightly stated in your thank you note
                  that it takes a lot in the background to create a magical show
                  like we observed. <br />
                  It’s the everyday experience that I draw together as a father,
                  thus have become the most prominent and expressive ambassador
                  of Lotus valley, at least in my friend circle. <br />
                  My note of appreciation will be partial without mentioning the
                  embodiment of patience Lotus valley teachers acquire, we truly
                  have caring mentors!!! , Under your leadership the most under
                  estimated phenomenon is being very well fostered and
                  incessantly worked upon i.e. “continuous improvement” an
                  upcoming cafe and lot more are significant examples of it.
                  Your contribution is impeccable! <br />I also want to thank
                  and be grateful to the close ally of my daughter who has been
                  with her every possible moment in the school helping her and
                  supporting her to climb the most difficult stepladder called
                  “life”. VIDHI MAM &amp; ASHIMA MAM, with all my sincerity i am
                  thankful to them... Timely parent teacher meets, unbiased
                  feedback, patient hearing, polite attitude and above all
                  wearing the most classical apparel all the time is “smile” Plz
                  continue - you guys are amazing! I truly regard your
                  contribution in making Halayna a better human being.. <br />
                  At last I personally feel very proud and happy in every step
                  lotus valley takes in building a strong learning place for my
                  daughter and for rest of the children.
                  <br />
                  With lots of Gratitude <br />
                  Syed <br />
                  Handfone - 9910019094 <br />
                  Father of Halayna Sadaat <br />
                  Prim Roses
                </p>
                <hr />
                <h6>Thanking you...</h6>
                <p>
                  <strong>Dear Ms Anita</strong>
                  <br />
                  It gives me an immense pleasure to express my gratitude about
                  the role of LVIS, our esteem school, to give wonderful
                  opportunities to our daughters (Nandini Saluja, Grade 4
                  Chinars and Gauri Salujai, Grade 8, Amazon) in past one year
                  that helped not only smooth settlement of our daughters in
                  this new school but also helped boost their morale by
                  multi-faceted learning in academics and extra curricular.{" "}
                  <br />I truly appreciate the efforts put in by class teachers
                  (Ms Ragini Grade 4 and Ms Renu Grade 8 and the entire team of
                  grade 4 and grade 8) to ensure that children are finding their
                  natural space in their respective classes and get the best
                  learning in each stride. <br />
                  Needless to say, wonderful results of your school is due to
                  continuous improvement in every single activity performed
                  within the school premises under your leadership and
                  direction. <br />
                  Looking forward for children's consistent learning and growth
                  in LVIS for many years...
                </p>
                <p>
                  Kind regards
                  <br />
                  Diljeet Saluja <br />
                  Rekha Saluja
                </p>
                <hr />
                <h6>Trust you are doing well</h6>
                <p>
                  <strong>Dear ma'am</strong>
                  <br />
                  At the outset, I would like to congratulate you for building
                  such a strong educational institution in such a short span of
                  time. I am Sara Mehta (Grade 1 – Flamingoes)’s mother and
                  writing this letter on behalf of many parents who would like
                  to make similar recommendation. <br />
                  We have seen a huge improvement in our children’s development
                  in the current academic year and amongst other things, would
                  like to give due credit to Jyoti Ma’m. We are very keen that
                  she continues to have responsibility of this section in Grade
                  2 as well. This will help strengthen the confidence and growth
                  of the children which we were somehow worried when they moved
                  from Grade ‘ Prep’ to Grade 1. <br />I am hopeful that you
                  will definitely give this a due consideration, as always.
                </p>
                <p>
                  Kind regards
                  <br />
                  Parul
                </p>
                <hr />
                <h6>Journey thus far...</h6>
                <p>
                  <strong>Dear Ms. Malhotra,</strong>
                  <br />
                  First and foremost, THANK YOU Lotus Valley for making our
                  children Ashlyn &amp; Arjan Talwar (Grade 5 &amp; 1 resp.)
                  feel right at home within a short span. Moving from a
                  different country, we had our initial apprehensions as to how
                  soon and how well they would settle in. However, they took to
                  your school like a fish to water right from the first day. We
                  are surprised to see that both have not only gained new
                  skills, but also a much higher degree of confidence,
                  independence and maturity.
                  <br />
                  On a related note we would especially like to recommend the
                  teachers Beena, Aarti &amp; Rajnandini for being instrumental
                  in our kids‘ journey and making it beautiful &amp; memorable.
                  Our compliments to these fantastic teachers who work so hard
                  to ensure that the children are shaped into good and
                  responsible citizens. We can also well imagine the kind of
                  effort from your side that would be going into making this
                  endeavor successful.
                  <br />
                  It’s really heartening to hear from our kids "It was so
                  fun-the day seemed so short." They are always happy to go to
                  school and that is a great indicator for us!
                  <br />
                  Thank you for all the inputs and efforts from your end.
                </p>
                <hr />
                <h6>Appreciation for Sports Day</h6>
                <p>
                  <strong>Respected Anita ma'am</strong>
                  <br />
                </p>
                <p>
                  It was a pleasure to attend the sports day yesterday.
                  <br />
                  <br />
                  Even the dense fog could do nothing to dampen the levels of
                  excitement n enthusiasm of the children, teachers n the
                  parents! As parents we really appreciate the efforts to
                  encourage parent participation in the event.
                  <br />
                  Thank you for a wonderful experience.
                  <br />
                  Warm regards
                  <br />
                  Pooja Gehani
                  <br />
                  Mother of Simar Gehani, Prep Zinnias)
                </p>
                <hr />
                <h6>Views on Sports Day</h6>
                <p>
                  <strong>Greetings!</strong>
                  <br />
                  I am Sarabjot, mother of Tavrehat Singh
                  <br />
                  Nursery -pansies.
                  <br />I wanted to share my view about the sports day that took
                  place today....It was a great experience seeing the little
                  ones perform.I humbly appreciate the efforts made by school
                  and teachers to make students bring forward their
                  potentialities....Thanks once again.We would like to see such
                  events in future also..
                </p>
                <hr />
                <h6>Pansies Child feedback about Sports Day today</h6>
                <p>
                  <strong>Dear Principal and Teachers,</strong>
                  <br />
                  This give me an immense pleasure to write about today’s event
                  which was amazing and simultaneously proved that sports are
                  the epitome of hard work and dedication which was put by not
                  only children but by teachers also. There was proper
                  coordination, team spirit and encouragement among the children
                  which is remarkable for a ~4-5 year child. The children was
                  fully aware of what to do and how to do. The children felt
                  more motivated when they saw parents performing in the same
                  way as they were.
                  <br />
                  For us Mam this has moved us in our flash back days of school
                  for our sports day where we used to perform and now performing
                  with our own children was like a dream come true. I hope
                  school will conduct more sports day in school and invite us as
                  well for such events.
                  <br />
                  Reenu Kedia
                  <br />
                  Senior Manager, International Membership Rewards
                  <br />
                  Am erican Express, 11th Floor,
                  <br />
                  Towers B &amp; C, Bldg No 5,
                  <br />
                  DLF Cyber City – Phase III,
                  <br />
                  Gurgaon 122002, Haryana, INDIA
                  <br />
                  <a href="mailto:reenu.a.aggarwal@aexp.com">
                    reenu.a.aggarwal@aexp.com
                  </a>
                  <br />
                  Office: +91-124-611-8200
                  <br />
                  Mobile: +91-99 10 06 70 92
                  <br />
                  Follow us: https://twitter.com/americanexpress
                  <br />
                  American Express made the following annotations
                  <br />
                  "This message and any attachments are solely for the intended
                  recipient and may contain confidential or privileged
                  information. If you are not the intended recipient, any
                  disclosure, copying, use, or distribution of the information
                  included in this message and any attachments is prohibited. If
                  you have received this communication in error, please notify
                  us by reply e-mail and immediately and permanently delete this
                  message and any attachments. Thank you."
                  <br />
                  American Express a ajouté le commentaire suivant le Ce
                  courrier et toute pièce jointe qu'il contient sont réservés au
                  seul destinataire indiqué et peuvent renfermer des
                  renseignements confidentiels et privilégiés. Si vous n'êtes
                  pas le destinataire prévu, toute divulgation, duplication,
                  utilisation ou distribution du courrier ou de toute pièce
                  jointe est interdite. Si vous avez reçu cette communication
                  par erreur, veuillez nous en aviser par courrier et détruire
                  immédiatement le courrier et les pièces jointes. Merci
                </p>
                <hr />
                <h6>Pre-Nursery Annual Day Celebrations</h6>
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  My husband and I would like to offer our heartiest
                  congratulations to your entire faculty, staff, students and
                  definitely not the least, to you, for the wonderful Annual Day
                  Celebrations of Pre-Nursery.
                  <br />
                  Though we have attended the last year's Annual Day for the
                  whole school (for our elder daughter), the Saturday event was
                  just so beautiful because we couldn't have imagined that our
                  little 3 year olds could have done so so well!
                  <br />
                  We didn't get a chance to properly thank you and your team on
                  Saturday, for the inspiring way that you take care of our
                  wards, so though we should send you a mail in an effort to
                  show our appreciation for all that you have done and are
                  doing.
                  <br />I would especially like to mention the awesome work by
                  the art and dance departments and also by our daughter's class
                  reps - Ms. Pooja and Ms. Suruchi. The parents love them as
                  much as the kids!
                  <br />
                  Thank you
                  <br />
                  Warm Regards
                  <br />
                  Swati Saxena
                  <br />
                  (Mother of Suhana Srivastava - Pre-N Poppies)
                </p>
                <hr />
                <h6>Release of Cascade 2012 – 13</h6>
                <p>
                  On 25th October, 2013, Scholars of the Academic Session 2012 -
                  13 were felicitated. The occasion was discernible with the
                  presence of Dr. Praveen Kumar, IAS HUDA Administrator.
                  <br />
                  On this occasion, the second issue of the school magazine,
                  "Cascade – a deluge of expressions", was released by the
                  honourable Chief Guest of the day, Dr. Praveen Kumar. Cascade,
                  not only highlights the events and feats of the school but
                  also showcases the ingenious talents and writing dexterity of
                  the learners along with inspiring messages by the mentors.
                  This magazine is a great platform for the school's budding
                  writers, artists and journalists. In short, it reflects the
                  talents of the students, teachers' potentiality and
                  administrative staff's dedication.
                </p>
                <hr />
                <h6>
                  Tete-e-Tete with Dr. Praveen Kumar (IAS), Administrator HUDA
                </h6>
                <p>
                  The very eminent Dr Praveen Kumar, IAS, Administrator HUDA
                  interacts with learners in Lotus Valley International School,
                  Gurgaon, on the scholar batch ceremony 2012-13. Impressed with
                  the skit put up by the learners with the four great leaders
                  namely; Gandhi, Nehru, Tagore and Teresa reflecting on their
                  idiosyncrasies. He put up his first interrogation pertaining
                  the message of the play.
                  <br />
                  Dr. Praveen Kumar :What is the message of the play?
                  <br />
                  Learner: the message drove home the crux of believing in
                  yourself and making your own path.
                  <br />
                  Dr. Praveen Kumar:What is belief? Is the belief that you have
                  in you the same as the belief that others have in you?
                  <br />
                  Learner: Belief is the truth. Both the beliefs are different
                  as the belief by others is based on a presumption but the
                  belief in me by myself is the most lucid one.
                  <br />
                  Learner: Sir, What is your inspiration; your driving force?
                  <br />
                  Dr. Praveen Kumar: One in Many. There is one being which is an
                  amalgamation of good and bad, but the most important is the
                  universal ability/intelligence which distinguishes good from
                  bad which is my belief and the driving force.
                  <br />
                  Learner: How does it feel working for the nation?
                  <br />
                  Dr.Praveen Kumar: We are all working for the nation. Educating
                  ourself right is also working for the nation. It is the
                  formation of tomorrow.
                  <br />
                  Dr.Praveen Kumar: What is self?
                  <br />
                  Learner: Self is the basis of behaviour, attitude of life. It
                  is the ability to resist temptations. Strength to persevere
                  challenges, the strength of will. Here the self is the common
                  and most strongest premise.
                  <br />
                  Learner: How is the self the main agent of life?
                  <br />
                  Dr. Praveen Kumar: The theory of Biocentrism (theory of
                  everything) from Greek: βίος, bios, "life"; and κέντρον,
                  kentron, "center" — also known as the biocentric universe — is
                  a theory proposed in 2007 by American scientist Robert Lanza.
                  In this view, life and biology are central to being, reality,
                  and the cosmos. Biocentrism asserts that current theories of
                  the physical world do not work, and can never be made to work,
                  until they fully account for life and consciousness.
                  <br />
                  Learner: what do you do when you are nervous?
                  <br />
                  Dr. Praveen Kumar: I try and understand the reason, which is
                  created by an image which makes me nervous. Then I look for
                  the 'self' that is free from nervousness also it is free and
                  natural. Greater than confidence is the silence. T.S. Eliot:
                  "real personality begins with impersonality"
                  <br />
                  Learner: There are 5,50.000 students appearing for the civil
                  services exam and the acceptance rate for an IAS is 0.01%,
                  which makes it one of the most difficult entrance tests.
                  <br />
                  Dr. Praveen Kumar: I did not clear my Civil Services exam but
                  entered through the state services exam. am a homeopathic
                  Doctor by profession and had interest in philosophy, but
                  landed here due to my parents constant persuasion.
                  <br />
                  Learner: What are your expectations from life?
                  <br />
                  Dr. Praveen Kumar: Compliments!!
                  <br />
                  Learners: What is your premise of leading life and succeeding.
                  <br />
                  Dr. Praveen Kumar: The inquiry and and learning mode is my
                  method to lead life. Observe life, it is multi dimensional.
                  Discover it and understand it.
                  <br />
                  Learner: Sir, we understand you have initiated a 'think tank'.
                  Could you throw some light on the same.
                  <br />
                  Dr. Praveen Kumar: It is a collective effort, an attempt to
                  get together, think, reach the absolute truth/solution
                  collectively and find a solution to problems. ' One in Many'
                </p>
                <hr />
                <h6>Two Time Congratulations</h6>
                <p>
                  <strong>Dear Principal Ma'am,</strong>
                  <br />
                  You would be happy to know that
                </p>
                <ul class="lower-alpha">
                  <li>
                    Your student Anya Gupta Grade II Doves has been awarded a
                    Bronze medal by Kumon in their Maths program.
                  </li>
                  <li>
                    Your student Shivenn Gupta Grade Nursery Blue-bells has been
                    awarded a Bronze medal by Kumon in their Maths program.
                  </li>
                </ul>
                <p>
                  Both of them are six months ahead of their school grade in
                  Maths. Please find enclosed their ecstatic photographs
                  accepting the medals at Kumon Advance Student Honour Roll
                  ceremony held recently.
                  <br />
                  Thank you for providing such a fantastic holistic education to
                  Anya &amp; Shivenn, without which this would not have been
                  possible. Do pass on my complements and thanks to their class
                  teachers - Ms Shailja, Ms Kavita &amp; Ms Aditi - for their
                  love, warmth and mentoring; that has both children so fully
                  blossom.
                  <br />
                  Few examples of the progress that the children have made,
                  under your loving leadership at school -
                </p>
                <ul class="lower-alpha">
                  <li>
                    Both Anya &amp; Shivenn have graduated to yellow belt in
                    Taekwondo.
                  </li>
                  <li>Both of them are learning piano and progressing well.</li>
                  <li>
                    Anya is learning hindustani classical and progressing well.
                  </li>
                  <li>
                    Shivenn recites songs and poems with complex words, learnt
                    at school, with such confidence that leaves everyone amazed
                    :-) He, of course, is a story-teller and holds the attention
                    of 7 to 11 years old at Sri Sri Sanskar Kendra where I
                    volunteer as a teacher, with his long stories heard at
                    school.
                  </li>
                  <li>
                    Anya and even, Shivenn, do their home-work on their own
                    without any supervision from my side.
                  </li>
                </ul>
                <p>
                  Thank you for providing them with not only a complete
                  education but also a loving &amp; warm environment at school
                  that both of them are confident, happy and one with the world
                  around them.
                  <br />
                  Their Grateful Mother,
                  <br />
                  Jyoti
                </p>
                <hr />
                <h6>Breakfast with Children</h6>
                <p>
                  <strong>Hello</strong>
                  <br />
                  The Breakfast interaction with Kids was a brilliant idea.
                  <br />
                  It was great to see the children perform morning prayer &amp;
                  activities, and got to know how the kids start their day at
                  school.
                  <br />
                  The energy in the children &amp; enthusiasm was amazing.
                  <br />
                  It was nice to see how they have their breakfast with their
                  Mams' &amp; staff helping &amp; encouraging the little ones to
                  eat properly &amp; finish their tiffins, which their mothers
                  have prepared &amp; packed for the little angels with great
                  love &amp; affection.
                  <br />
                  The musical chair for fathers was a good idea as well. Maybe a
                  game in which the children were also involved would have been
                  even more enjoyable.
                  <br />
                  Overall a great experience &amp; look forward to such
                  engagements in future.
                  <br />
                  Appreciate the effort put in by the School Principal, Teachers
                  &amp; Staff for the kids &amp; parents.
                  <br />
                  Thank you.
                  <br />
                  Anuj Nath
                  <br />
                  Veer's father
                  <br />
                  Nursery – Pansies
                </p>
                <hr />
                <h6>Breakfast with Children</h6>
                <p>
                  <strong>Dear Ma'am,</strong>
                  <br />
                  We came to Lotus Valley and got the feeling of beauty,
                  openness and warmth. Than we met you Ma'am and realized that
                  this is the golden opportunity for our children to be guided
                  in life by someone as experienced and wonderful as you.
                  <br />
                  Then came the 2nd of April and from the moment we stepped
                  inside the gates of the school we were so touched by the
                  ceremonies of tying of the thread and lighting of the Diyas
                  that it overwhelmed us. It was such an honour to be part of
                  the function and to be a part of your school.
                  <br />
                  We have no words to describe our feelings when Dr Shayama
                  Chona stole our hearts and bought tears in our eyes with her
                  wise words. We have a lot to learn from her and would love to
                  part of the parenting programme.
                  <br />
                  Thank you Ma'am for everything, we are happy to be part for
                  your institution and we wish you, the school and all the
                  children all the very best for a fantastic future.
                </p>
                <p>
                  Thanking you,
                  <br />
                  Personal Warm Regards,
                  <br />
                  Ritika and Himanshu Mehrish
                  <br />
                  Parents of
                  <br />
                  Twesham Mehrish - IV Ashokas
                  <br />
                  Tavishi Mehrish - VIII Brahmaputra
                  <br />
                  Dated: April 4, 2011
                  <br />
                  32, Sainik Farms, New Delhi – 110 062. Mob: 91 9654442514, 91
                  9811141799 Email:hmehrish@gmail.com &amp;
                  Ritika.mehrish@gmail.com
                </p>
                <hr />
                <h6>Respected Principal Ma'am</h6>
                <p>
                  Finding a good school in Gurgaon for my son and the experience
                  of admission process, all the way to the 1 st day at Lotus
                  Valley International has been in has been a very gratifying
                  and memorable. The finesse, professionalism, and friendliness
                  of the staff has truly won us over.
                  <br />
                  We are very happy to see Chirag Mayor (Pansies) adjust to the
                  new environment as he was quite reluctant at first and is now
                  all excited for 'Day Two'. All credit and a special Thank You
                  to his class teacher Ms. Anita for facilitating this change.
                  <br />
                  Would also like to Thank you for organizing a wonderful
                  Orientation and inviting Respected Mrs. Chona for the
                  occasion.
                  <br />
                  We wish Lotus Valley Gurgaon, all the very best and we are
                  sure your astute leadership and guidance will nurture the
                  school and its students to success.{" "}
                </p>
                <p>
                  Thank You and Best Regards
                  <br />
                  Sumeet Mayor
                  <br />
                  +91-8826-478-479
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Testimonial;
